var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 118.623,
    viewBox: "0 0 120 118.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #301010;\n      }\n\n      .cls-4 {\n        fill: #260505;\n      }\n\n      .cls-5 {\n        fill: #481018;\n      }\n\n      .cls-6 {\n        fill: #4f1f26;\n      }\n\n      .cls-7 {\n        fill: #67383f;\n      }\n\n      .cls-8 {\n        fill: #5c2930;\n      }\n\n      .cls-9 {\n        fill: #e49a00;\n      }\n\n      .cls-10 {\n        fill: #a40;\n      }\n\n      .cls-11 {\n        fill: #be5900;\n      }\n\n      .cls-12 {\n        fill: #bb5900;\n      }\n\n      .cls-13 {\n        fill: #da7200;\n      }\n\n      .cls-14 {\n        fill: #952e00;\n      }\n\n      .cls-15 {\n        fill: #f5a355;\n      }\n\n      .cls-16 {\n        fill: #83645c;\n      }\n\n      .cls-17 {\n        fill: #b54112;\n      }\n\n      .cls-18 {\n        fill: #543a32;\n      }\n\n      .cls-19 {\n        fill: #3c241d;\n      }\n\n      .cls-20 {\n        fill: #600010;\n      }\n\n      .cls-21 {\n        fill: #56050f;\n      }\n\n      .cls-22 {\n        fill: #722b3b;\n      }\n\n      .cls-23 {\n        fill: #4f2f38;\n      }\n\n      .cls-24 {\n        fill: #5b454c;\n      }\n\n      .cls-25 {\n        fill: #7a5d64;\n      }\n\n      .cls-26 {\n        fill: #634b52;\n      }\n\n      .cls-27 {\n        fill: #2d2d2d;\n      }\n\n      .cls-28 {\n        fill: #bf582b;\n      }\n\n      .cls-29 {\n        fill: #4f3c3c;\n      }\n\n      .cls-30 {\n        fill: #4c3b40;\n      }\n\n      .cls-31 {\n        fill: #685056;\n      }\n\n      .cls-32 {\n        fill: #6b5351;\n      }\n\n      .cls-33 {\n        fill: #d8681d;\n      }\n\n      .cls-34 {\n        fill: #3f0f1c;\n      }\n\n      .cls-35 {\n        fill: #562331;\n      }\n\n      .cls-36 {\n        fill: #380009;\n      }\n\n      .cls-37 {\n        fill: #723744;\n      }\n\n      .cls-38 {\n        fill: #b84c21;\n      }\n\n      .cls-39 {\n        fill: #953500;\n      }\n\n      .cls-40 {\n        fill: #7d2700;\n      }\n\n      .cls-41 {\n        fill: #ce7731;\n      }\n\n      .cls-42 {\n        fill: #bc5b19;\n      }\n\n      .cls-43 {\n        fill: #aa4724;\n      }\n\n      .cls-44 {\n        fill: #e58229;\n      }\n\n      .cls-45 {\n        fill: #c6621e;\n      }\n\n      .cls-46 {\n        fill: #4f2f32;\n      }\n\n      .cls-47 {\n        fill: #35000a;\n      }\n\n      .cls-48 {\n        fill: #1a0000;\n      }\n\n      .cls-49 {\n        fill: #491a1d;\n      }\n\n      .cls-50 {\n        fill: #3f0f1a;\n      }\n\n      .cls-51 {\n        mix-blend-mode: multiply;\n        isolation: isolate;\n      }\n\n      .cls-52 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-53 {\n        fill: #c79e8f;\n      }\n\n      .cls-54 {\n        fill: #ecdcce;\n      }\n\n      .cls-55 {\n        fill: #965f5f;\n      }\n\n      .cls-56 {\n        fill: #ce9999;\n      }\n\n      .cls-57 {\n        fill: #b79898;\n      }\n\n      .cls-58 {\n        fill: #edd8ce;\n      }\n\n      .cls-59 {\n        fill: #efceb6;\n      }\n\n      .cls-60 {\n        fill: #42180f;\n      }\n\n      .cls-61 {\n        fill: #491a23;\n      }\n\n      .cls-62 {\n        fill: #99431d;\n      }\n\n      .cls-63 {\n        fill: #491a2a;\n      }\n\n      .cls-64 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-65 {\n        fill: #b3b3b3;\n      }\n\n      .cls-66 {\n        fill: #f9bf6b;\n      }\n\n      .cls-67 {\n        fill: #953e00;\n      }\n\n      .cls-68 {\n        fill: #2e0008;\n      }\n\n      .cls-69 {\n        fill: #e68d00;\n      }\n\n      .cls-70 {\n        fill: #ffd02d;\n      }\n\n      .cls-71 {\n        fill: #e25b00;\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-73 {\n        fill: #b07c6a;\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-75 {\n        fill: #664a43;\n      }\n\n      .cls-76 {\n        fill: #be9991;\n      }\n\n      .cls-77 {\n        fill: #74574e;\n      }\n\n      .cls-78 {\n        fill: #997970;\n      }\n\n      .cls-79 {\n        fill: #220e08;\n      }\n\n      .cls-80 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-81 {\n        fill: #94746b;\n      }\n\n      .cls-82 {\n        fill: #24100a;\n      }\n\n      .cls-83 {\n        fill: #694d47;\n      }\n\n      .cls-84 {\n        fill: #442c25;\n      }\n\n      .cls-85 {\n        fill: #1b0803;\n      }\n\n      .cls-86 {\n        fill: #9b7a72;\n      }\n\n      .cls-87 {\n        fill: #e29609;\n      }\n\n      .cls-88 {\n        fill: #c27700;\n      }\n\n      .cls-89 {\n        fill: #b45300;\n      }\n\n      .cls-90 {\n        fill: #b56943;\n      }\n\n      .cls-91 {\n        fill: #7a4420;\n      }\n\n      .cls-92 {\n        fill: #7a4006;\n      }\n\n      .cls-93 {\n        fill: #bc7657;\n      }\n\n      .cls-94 {\n        fill: #ff9d0a;\n      }\n\n      .cls-95 {\n        fill: #d66b00;\n      }\n\n      .cls-96 {\n        fill: #706158;\n      }\n\n      .cls-97 {\n        fill: #403732;\n      }\n\n      .cls-98 {\n        fill: #907d72;\n      }\n\n      .cls-99 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-101 {\n        fill: #606060;\n      }\n\n      .cls-102 {\n        fill: #fcc7aa;\n      }\n\n      .cls-103 {\n        clip-path: url(#clip-path-11);\n      }\n\n      .cls-104 {\n        fill: #fad3be;\n      }\n\n      .cls-105 {\n        fill: #4a2727;\n      }\n\n      .cls-106 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-108 {\n        fill: #c4c4c4;\n      }\n\n      .cls-109 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-111 {\n        fill: #6d6d6d;\n      }\n\n      .cls-112 {\n        fill: #454545;\n      }\n\n      .cls-113 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-115 {\n        fill: #4c4c4c;\n      }\n\n      .cls-116 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-118 {\n        fill: #e2e2e2;\n      }\n\n      .cls-119 {\n        fill: #6a6a6a;\n      }\n\n      .cls-120 {\n        fill: #7e7e7e;\n      }\n\n      .cls-121 {\n        fill: #494949;\n      }\n\n      .cls-122 {\n        fill: #99a7ad;\n      }\n\n      .cls-123 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-124 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-125 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-126 {\n        fill: #2f2720;\n      }\n\n      .cls-127 {\n        fill: #d6a94f;\n      }\n\n      .cls-128 {\n        fill: #355fa3;\n      }\n\n      .cls-129 {\n        clip-path: url(#clip-path-23);\n      }\n\n      .cls-130 {\n        fill: #6c91c4;\n      }\n\n      .cls-131 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-132 {\n        clip-path: url(#clip-path-25);\n      }\n\n      .cls-133 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-134 {\n        clip-path: url(#clip-path-27);\n      }\n\n      .cls-135 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-136 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-137 {\n        fill: #3c7eb0;\n      }\n\n      .cls-138 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-139 {\n        fill: #707da7;\n      }\n\n      .cls-140 {\n        fill: #ff5757;\n      }\n\n      .cls-141 {\n        fill: #99c2d6;\n      }\n\n      .cls-142 {\n        fill: #241818;\n      }\n\n      .cls-143 {\n        fill: #ffd6bf;\n      }\n\n      .cls-144 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-145 {\n        clip-path: url(#clip-path-32);\n      }\n\n      .cls-146 {\n        fill: #f09f69;\n      }\n\n      .cls-147 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-148 {\n        clip-path: url(#clip-path-34);\n      }\n\n      .cls-149 {\n        fill: #db8484;\n      }\n\n      .cls-150 {\n        fill: #495cb6;\n      }\n\n      .cls-151 {\n        fill: #f0892c;\n      }\n\n      .cls-152 {\n        fill: #d96200;\n      }\n\n      .cls-153 {\n        fill: #ffae5e;\n      }\n\n      .cls-154 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-155 {\n        clip-path: url(#clip-path-36);\n      }\n\n      .cls-156 {\n        clip-path: url(#clip-path-37);\n      }\n\n      .cls-157 {\n        fill: #bbb;\n      }\n\n      .cls-158 {\n        clip-path: url(#clip-path-38);\n      }\n\n      .cls-159 {\n        clip-path: url(#clip-path-39);\n      }\n\n      .cls-160 {\n        clip-path: url(#clip-path-40);\n      }\n\n      .cls-161 {\n        clip-path: url(#clip-path-41);\n      }\n\n      .cls-162 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-163 {\n        fill: #8b7c77;\n      }\n\n      .cls-164 {\n        fill: #545454;\n      }\n\n      .cls-165 {\n        fill: #6e5c56;\n      }\n\n      .cls-166 {\n        fill: #9a8d89;\n      }\n\n      .cls-167 {\n        fill: #4a4a4a;\n      }\n\n      .cls-168 {\n        fill: #dfdbdb;\n      }\n\n      .cls-169 {\n        fill: #e8870f;\n      }\n\n      .cls-169, .cls-170, .cls-171, .cls-173, .cls-174, .cls-176, .cls-177, .cls-179, .cls-180, .cls-182 {\n        fill-rule: evenodd;\n      }\n\n      .cls-170 {\n        fill: #faa43c;\n      }\n\n      .cls-171 {\n        fill: #f89419;\n      }\n\n      .cls-172 {\n        clip-path: url(#clip-path-43);\n      }\n\n      .cls-173 {\n        fill: #faa53c;\n      }\n\n      .cls-174 {\n        fill: #eaeaea;\n      }\n\n      .cls-175 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-176 {\n        fill: #d8d8d8;\n      }\n\n      .cls-177 {\n        fill: #e8e8e8;\n      }\n\n      .cls-178 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-179 {\n        fill: #e0e0e0;\n      }\n\n      .cls-180 {\n        fill: #dc8416;\n      }\n\n      .cls-181 {\n        clip-path: url(#clip-path-48);\n      }\n\n      .cls-182 {\n        fill: #7b5e3a;\n      }\n\n      .cls-183 {\n        clip-path: url(#clip-path-50);\n      }\n\n      .cls-184 {\n        clip-path: url(#clip-path-51);\n      }\n\n      .cls-185 {\n        clip-path: url(#clip-path-53);\n      }\n\n      .cls-186 {\n        clip-path: url(#clip-path-55);\n      }\n\n      .cls-187 {\n        clip-path: url(#clip-path-57);\n      }\n\n      .cls-188 {\n        clip-path: url(#clip-path-58);\n      }\n\n      .cls-189 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-190 {\n        clip-path: url(#clip-path-62);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26893",
    "data-name": "Rectangle 26893",
    className: "cls-1",
    width: 120,
    height: 118.624
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26848",
    "data-name": "Rectangle 26848",
    className: "cls-1",
    width: 24.932,
    height: 10.735
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26849",
    "data-name": "Rectangle 26849",
    className: "cls-1",
    width: 14,
    height: 8.088
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26850",
    "data-name": "Rectangle 26850",
    className: "cls-1",
    width: 35.066,
    height: 18.928
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79918",
    "data-name": "Path 79918",
    className: "cls-1",
    d: "M375.434,272.3V283.35l14.914-8.611V263.691Z",
    transform: "translate(-375.434 -263.691)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26852",
    "data-name": "Rectangle 26852",
    className: "cls-1",
    width: 4.936,
    height: 6.897
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79944",
    "data-name": "Path 79944",
    className: "cls-1",
    d: "M72.854,285.886l-.159.228-.36-.114v.34h0a.215.215,0,0,0,.107.2l.245.142a.473.473,0,0,0,.47,0l.75-.432a.214.214,0,0,0,.11-.192h0v-.35l-.292.022-.067-.039a.216.216,0,0,0-.105-.021,1.938,1.938,0,0,0-.7.216",
    transform: "translate(-72.335 -285.67)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.095,
    y1: 47.034,
    x2: -9.955,
    y2: 47.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26855",
    "data-name": "Rectangle 26855",
    className: "cls-1",
    width: 0.76,
    height: 0.576
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79949",
    "data-name": "Path 79949",
    className: "cls-1",
    d: "M82.8,263.336l-1.049.616c.035.054.069.109.1.166L82.9,263.5c.026-.015.026-.065,0-.112a.108.108,0,0,0-.079-.061.036.036,0,0,0-.017,0",
    transform: "translate(-81.756 -263.332)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13.576,
    y1: 44.954,
    x2: -13.409,
    y2: 44.954,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79951",
    "data-name": "Path 79951",
    className: "cls-1",
    d: "M81.765,265.026l-.078.047c.111.169.216.342.315.52l.067-.04c.082-.047.081-.2,0-.349a.338.338,0,0,0-.247-.191.1.1,0,0,0-.054.014",
    transform: "translate(-81.687 -265.012)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -27.591,
    y1: 76.734,
    x2: -27.251,
    y2: 76.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79954",
    "data-name": "Path 79954",
    className: "cls-1",
    d: "M78.817,264.83l-.693.383q.258.392.489.8l.674-.373c.127-.073.125-.315,0-.54a.523.523,0,0,0-.382-.3.164.164,0,0,0-.083.021",
    transform: "translate(-78.124 -264.809)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10.549,
    y1: 33.443,
    x2: -10.412,
    y2: 33.443,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79956",
    "data-name": "Path 79956",
    className: "cls-1",
    d: "M77.994,265.768l-.206.118q.321.487.607,1l.183-.106c.158-.091.155-.392-.006-.672a.651.651,0,0,0-.475-.368.2.2,0,0,0-.1.026",
    transform: "translate(-77.788 -265.742)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -12.965,
    y1: 38.397,
    x2: -12.797,
    y2: 38.397,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26864",
    "data-name": "Rectangle 26864",
    className: "cls-1",
    width: 5.355,
    height: 2.345
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26865",
    "data-name": "Rectangle 26865",
    className: "cls-1",
    width: 1.244,
    height: 0.773
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26866",
    "data-name": "Rectangle 26866",
    className: "cls-1",
    width: 0.452,
    height: 1.417
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26867",
    "data-name": "Rectangle 26867",
    className: "cls-1",
    width: 4.837,
    height: 8.802
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26868",
    "data-name": "Rectangle 26868",
    className: "cls-1",
    width: 4.563,
    height: 13.183
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26869",
    "data-name": "Rectangle 26869",
    className: "cls-1",
    width: 3.176,
    height: 11.438
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26870",
    "data-name": "Rectangle 26870",
    className: "cls-1",
    width: 1.994,
    height: 3.164
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26871",
    "data-name": "Rectangle 26871",
    className: "cls-1",
    width: 6.118,
    height: 5.636
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26872",
    "data-name": "Rectangle 26872",
    className: "cls-1",
    width: 0.401,
    height: 1.19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26873",
    "data-name": "Rectangle 26873",
    className: "cls-1",
    width: 0.243,
    height: 0.365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26874",
    "data-name": "Rectangle 26874",
    className: "cls-1",
    width: 2.258,
    height: 2.967
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26875",
    "data-name": "Rectangle 26875",
    className: "cls-1",
    width: 1.195,
    height: 1.073
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26876",
    "data-name": "Rectangle 26876",
    className: "cls-1",
    width: 3.575,
    height: 10.184
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26877",
    "data-name": "Rectangle 26877",
    className: "cls-1",
    width: 0.813,
    height: 0.211
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26878",
    "data-name": "Rectangle 26878",
    className: "cls-1",
    width: 2.118,
    height: 9.326
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26879",
    "data-name": "Rectangle 26879",
    className: "cls-1",
    width: 5.605,
    height: 3.376
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26880",
    "data-name": "Rectangle 26880",
    className: "cls-1",
    width: 6.273,
    height: 7.372
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26881",
    "data-name": "Rectangle 26881",
    className: "cls-1",
    width: 8.414,
    height: 7.508
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26882",
    "data-name": "Rectangle 26882",
    className: "cls-1",
    width: 1.574,
    height: 1.702
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26883",
    "data-name": "Rectangle 26883",
    className: "cls-1",
    width: 5.075,
    height: 3.172
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26884",
    "data-name": "Rectangle 26884",
    className: "cls-1",
    width: 2.186,
    height: 4.746
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26885",
    "data-name": "Rectangle 26885",
    className: "cls-1",
    width: 4.461,
    height: 8.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26886",
    "data-name": "Rectangle 26886",
    className: "cls-1",
    width: 2.63,
    height: 7.076
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80080",
    "data-name": "Path 80080",
    className: "cls-1",
    d: "M285.827,406.591h.013a1.526,1.526,0,0,0,.937,1.491,5.076,5.076,0,0,0,4.59,0,1.619,1.619,0,0,0,.95-1.314h0a1.157,1.157,0,0,0-.119-.516l-2.281-9.856-1.688-.047Z",
    transform: "translate(-285.827 -396.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80082",
    "data-name": "Path 80082",
    className: "cls-1",
    d: "M289.32,420.566a1.348,1.348,0,0,0,.692.8,3.828,3.828,0,0,0,3.462,0,1.4,1.4,0,0,0,.675-.74l-.323-1.4a1.717,1.717,0,0,1-.427.338,3.663,3.663,0,0,1-3.312,0,1.689,1.689,0,0,1-.448-.362Z",
    transform: "translate(-289.32 -419.206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80086",
    "data-name": "Path 80086",
    className: "cls-1",
    d: "M292.513,408.067a1.042,1.042,0,0,0,.45.455,2.7,2.7,0,0,0,2.443,0,1.072,1.072,0,0,0,.436-.425l-.239-1.03a1.281,1.281,0,0,1-.25.185,2.584,2.584,0,0,1-2.337,0,1.263,1.263,0,0,1-.266-.2Z",
    transform: "translate(-292.513 -407.053)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80090",
    "data-name": "Path 80090",
    className: "cls-1",
    d: "M297.658,395.425a.214.214,0,0,0,0,.405.777.777,0,0,0,.7,0,.214.214,0,0,0,0-.405.777.777,0,0,0-.7,0",
    transform: "translate(-297.513 -395.341)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80097",
    "data-name": "Path 80097",
    className: "cls-1",
    d: "M476.95,321.565h.013a1.525,1.525,0,0,0,.937,1.491,5.074,5.074,0,0,0,4.589,0,1.618,1.618,0,0,0,.95-1.314h0a1.155,1.155,0,0,0-.119-.516l-2.281-9.856-1.688-.047Z",
    transform: "translate(-476.95 -311.324)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80099",
    "data-name": "Path 80099",
    className: "cls-1",
    d: "M480.442,335.54a1.349,1.349,0,0,0,.692.8,3.827,3.827,0,0,0,3.462,0,1.394,1.394,0,0,0,.676-.74l-.323-1.4a1.72,1.72,0,0,1-.427.338,3.664,3.664,0,0,1-3.312,0,1.682,1.682,0,0,1-.448-.362Z",
    transform: "translate(-480.442 -334.18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80103",
    "data-name": "Path 80103",
    className: "cls-1",
    d: "M483.635,323.041a1.043,1.043,0,0,0,.45.455,2.7,2.7,0,0,0,2.443,0,1.074,1.074,0,0,0,.436-.425l-.238-1.03a1.282,1.282,0,0,1-.251.186,2.586,2.586,0,0,1-2.338,0,1.262,1.262,0,0,1-.266-.2Z",
    transform: "translate(-483.635 -322.027)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80107",
    "data-name": "Path 80107",
    className: "cls-1",
    d: "M488.78,310.4a.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405.774.774,0,0,0-.7,0",
    transform: "translate(-488.635 -310.314)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80114",
    "data-name": "Path 80114",
    className: "cls-1",
    d: "M154.548,326.531h.013a1.525,1.525,0,0,0,.937,1.491,5.074,5.074,0,0,0,4.589,0,1.618,1.618,0,0,0,.95-1.314h0a1.154,1.154,0,0,0-.12-.516l-2.281-9.856-1.689-.047Z",
    transform: "translate(-154.548 -316.29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80116",
    "data-name": "Path 80116",
    className: "cls-1",
    d: "M158.04,340.506a1.348,1.348,0,0,0,.692.8,3.828,3.828,0,0,0,3.462,0,1.4,1.4,0,0,0,.675-.74l-.323-1.4a1.716,1.716,0,0,1-.427.338,3.663,3.663,0,0,1-3.312,0,1.689,1.689,0,0,1-.448-.362Z",
    transform: "translate(-158.04 -339.146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80120",
    "data-name": "Path 80120",
    className: "cls-1",
    d: "M161.233,328.007a1.043,1.043,0,0,0,.45.455,2.7,2.7,0,0,0,2.443,0,1.07,1.07,0,0,0,.436-.425l-.238-1.03a1.276,1.276,0,0,1-.251.186,2.586,2.586,0,0,1-2.338,0,1.256,1.256,0,0,1-.265-.2Z",
    transform: "translate(-161.233 -326.992)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80124",
    "data-name": "Path 80124",
    className: "cls-1",
    d: "M166.378,315.364a.214.214,0,0,0,0,.4.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.4.775.775,0,0,0-.7,0",
    transform: "translate(-166.233 -315.28)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73120",
    "data-name": "Group 73120",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72980",
    "data-name": "Group 72980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72979",
    "data-name": "Group 72979",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79525",
    "data-name": "Path 79525",
    className: "cls-3",
    d: "M298.028,285.857a1.081,1.081,0,0,0-.883-.109c-.325.128-29.058,16.885-29.058,16.885l2.176,3.386s28.6-16.665,28.834-16.766a.945.945,0,0,0,.476-1,3.148,3.148,0,0,0-1.546-2.392",
    transform: "translate(-205.025 -218.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79526",
    "data-name": "Path 79526",
    className: "cls-4",
    d: "M331.742,312.986s1.044,1.685.013,2.285l-2.161,1.258s.946.543,1.293.692a5.1,5.1,0,0,0,2.826.115,11.652,11.652,0,0,0,2.509-1.7l-.977-5.336-3.5-1.24-2.589,1.754Z",
    transform: "translate(-251.727 -236.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79527",
    "data-name": "Path 79527",
    className: "cls-5",
    d: "M344.9,210.878c0,.136-.009.271-.009.41a16.481,16.481,0,0,0,.117,1.914l.4.257c.032.263.073.528.117.794l-.362-.015a21.422,21.422,0,0,0,.593,2.5l.392.14c.086.28.179.559.276.838l-.309.114a25.861,25.861,0,0,0,1.043,2.512l.362.012q.2.416.418.826l-.236.235a27.368,27.368,0,0,0,1.423,2.37l.307-.115q.262.387.536.763l-.149.343a25.324,25.324,0,0,0,1.713,2.076l.234-.236q.307.332.624.648l-.051.425a20.533,20.533,0,0,0,1.894,1.653l.146-.341q.331.251.669.482l.049.482c.323.218.648.426.978.617s.655.358.978.513l.049-.426q.337.158.669.29l.146.509a10.281,10.281,0,0,0,1.38.429l-1.84,1.994.843.436,1.894-1.008.225.094,6.419-2.705c.307-.141,2.046-2.144,2.32-2.341l-.048-.1.592-.342a6.032,6.032,0,0,0,1.043-1.308l-.223-.34.583-.336a8.762,8.762,0,0,0,.593-1.811l-.362-.4c.012-.058.02-.12.032-.179l.482-.279a13.241,13.241,0,0,0,.117-1.779c0-.139-.005-.28-.009-.421l-.392-.312c-.005-.152-.016-.307-.026-.46l.364-.21a19.05,19.05,0,0,0-.384-2.448l-.4-.2c-.05-.222-.106-.445-.164-.667l.306-.176a24.137,24.137,0,0,0-.857-2.546l-.379-.076q-.16-.4-.334-.787l.273-.175a27.184,27.184,0,0,0-1.273-2.485l-.339.052q-.217-.37-.445-.731l.193-.29a26.736,26.736,0,0,0-1.613-2.269l-.285.165q-.254-.317-.518-.623l.1-.387a23.037,23.037,0,0,0-1.854-1.907l-.318.183c-.151-.134-.3-.268-.455-.4v-.459a17.854,17.854,0,0,0-1.979-1.424l-.379.219-.018-.011c-.1-.058-.2-.109-.3-.163l-.1-.5a12.337,12.337,0,0,0-1.978-.861l-.534.308-.046-.013-.192-.514a7.988,7.988,0,0,0-1.854-.234l-.7.034a43.581,43.581,0,0,0-4.235,1.919l-.562.324-.03-.039-6.118,3.533-1.182,3.185,2.331-1.441a10.682,10.682,0,0,0-.329,1.781l.38.36c-.02.228-.034.462-.042.7Zm.588-2.827.387-.239c-.048.132-.1.264-.138.4Z",
    transform: "translate(-262.279 -153.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79528",
    "data-name": "Path 79528",
    className: "cls-6",
    d: "M359.261,201.442l-3.307,2.189-5.466,2.629,1.613-.406,5.362-2.32,3.378-2.726Z",
    transform: "translate(-268.043 -153.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79529",
    "data-name": "Path 79529",
    className: "cls-6",
    d: "M423.954,242.567l-2.775,4.1-5.965.948,1.273,2.485,6-.967,2.741-4.08-.608-1.266Z",
    transform: "translate(-317.544 -185.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79530",
    "data-name": "Path 79530",
    className: "cls-6",
    d: "M431.238,257.544l-3.227,4.11-5.513.936.857,2.546,5.546-.956,3.193-4.091-.35-1.156Z",
    transform: "translate(-323.115 -196.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79531",
    "data-name": "Path 79531",
    className: "cls-6",
    d: "M435.974,272.808l-3.045,4.087-5.695.96.384,2.448,5.728-.979,3.011-4.067-.117-1.094Z",
    transform: "translate(-326.737 -208.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79532",
    "data-name": "Path 79532",
    className: "cls-6",
    d: "M437.487,287.392l-2.935,4-5.8,1.046-.108,2.2,5.838-1.065,2.9-3.981.117-.956Z",
    transform: "translate(-327.812 -219.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79533",
    "data-name": "Path 79533",
    className: "cls-6",
    d: "M434.8,300.4l-2.576,3.548-6.164,1.5-.593,1.811L431.8,305.4l2.412-3.189.327-.748Z",
    transform: "translate(-325.388 -229.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79534",
    "data-name": "Path 79534",
    className: "cls-6",
    d: "M429.29,310.971l-2.9,2.806-5.841,2.24-1.043,1.308,5.875-2.26,2.864-2.787.557-.551Z",
    transform: "translate(-320.827 -237.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79535",
    "data-name": "Path 79535",
    className: "cls-6",
    d: "M414.582,228.805l-2.775,4.1-5.965.948,1.613,2.269,6-.967,2.741-4.08-.8-1.193Z",
    transform: "translate(-310.377 -174.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79536",
    "data-name": "Path 79536",
    className: "cls-6",
    d: "M403.714,217.106l-2.775,4.1-5.965.947,1.854,1.907,6-.967,2.741-4.08-.836-.951Z",
    transform: "translate(-302.065 -166.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79537",
    "data-name": "Path 79537",
    className: "cls-6",
    d: "M392.022,208.2l-2.775,4.1-5.965.947,1.979,1.424,6-.967,2.741-4.08-.845-.685Z",
    transform: "translate(-293.123 -159.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79538",
    "data-name": "Path 79538",
    className: "cls-6",
    d: "M380.235,202.59l-2.5,3.415-6.244,1.632,1.979.861,6.277-1.651,2.462-3.4-.868-.458Z",
    transform: "translate(-284.109 -154.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79539",
    "data-name": "Path 79539",
    className: "cls-6",
    d: "M369.072,200.661l-2.714,2.76-6.025,2.286,1.854.234,5.882-1.873,2.857-3.173-1.019-.184Z",
    transform: "translate(-275.572 -153.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79540",
    "data-name": "Path 79540",
    className: "cls-5",
    d: "M344.722,222.608l-4.032,2.154,1.064,1.64,2.967-1.677Z",
    transform: "translate(-260.551 -170.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79541",
    "data-name": "Path 79541",
    className: "cls-5",
    d: "M339.985,231.664l-4.032,2.328,1.064,1.641,2.968-1.677Z",
    transform: "translate(-256.927 -177.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79542",
    "data-name": "Path 79542",
    className: "cls-5",
    d: "M338.121,244.1l-4.032,2.328,1.064,1.64,2.968-1.677Z",
    transform: "translate(-255.502 -186.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79543",
    "data-name": "Path 79543",
    className: "cls-5",
    d: "M339.227,258.38l-4.032,2.328,1.064,1.64,2.968-1.677Z",
    transform: "translate(-256.348 -197.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79544",
    "data-name": "Path 79544",
    className: "cls-5",
    d: "M343.28,273.631l-4.032,2.328,1.064,1.641,2.967-1.677Z",
    transform: "translate(-259.447 -209.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79545",
    "data-name": "Path 79545",
    className: "cls-7",
    d: "M356.3,244.716a13.209,13.209,0,0,0,.117-1.779c0-.139-.005-.28-.009-.421l-.393-.311c-.008-.248-.021-.5-.042-.749l.38.079a19.1,19.1,0,0,0-.384-2.448l-.4-.2c-.06-.265-.124-.529-.2-.794l.337-.05a24.125,24.125,0,0,0-.857-2.546l-.379-.076q-.16-.4-.335-.787l.273-.175a27.2,27.2,0,0,0-1.273-2.485l-.339.052q-.217-.369-.445-.731l.193-.29a26.827,26.827,0,0,0-1.613-2.269l-.274.178q-.26-.324-.529-.637l.1-.387a23,23,0,0,0-1.854-1.907l-.192.292q-.287-.26-.581-.5v-.459a17.838,17.838,0,0,0-1.978-1.424l-.1.389c-.1-.06-.2-.123-.3-.181s-.2-.109-.3-.163l-.1-.5a12.385,12.385,0,0,0-1.978-.861v.46q-.294-.094-.581-.165l-.192-.514a7.985,7.985,0,0,0-1.854-.234l.1.5q-.269,0-.529.026l-.274-.494a5.722,5.722,0,0,0-1.613.406l.193.513c-.152.065-.3.137-.445.217l-.339-.444a5.41,5.41,0,0,0-1.273,1.015l.273.49c-.116.127-.228.26-.334.4l-.379-.362a7,7,0,0,0-.857,1.556l.337.439c-.071.183-.135.374-.2.569l-.4-.26a10.68,10.68,0,0,0-.384,2.005l.38.36c-.021.228-.034.462-.042.7l-.393-.142c0,.136-.009.271-.009.41a16.476,16.476,0,0,0,.117,1.914l.4.257c.032.263.073.528.117.794l-.362-.015a21.324,21.324,0,0,0,.593,2.5l.392.14c.086.28.179.559.276.838l-.308.114a25.794,25.794,0,0,0,1.043,2.512l.362.013q.2.416.418.826l-.236.235a27.439,27.439,0,0,0,1.424,2.37l.307-.115q.262.387.536.763l-.149.343a25.292,25.292,0,0,0,1.713,2.076l.234-.236c.2.221.412.438.624.648l-.051.425a20.5,20.5,0,0,0,1.894,1.653l.146-.341q.331.251.668.482l.049.482c.322.218.648.426.978.617s.656.359.978.513l.049-.426q.338.158.669.29l.146.509a9.865,9.865,0,0,0,1.894.534l-.051-.483c.211.034.419.057.624.072l.234.506a6.566,6.566,0,0,0,1.713-.1l-.149-.514a5.468,5.468,0,0,0,.536-.144l.307.47a5.327,5.327,0,0,0,1.424-.726l-.236-.508a5.239,5.239,0,0,0,.418-.343l.362.406a6.038,6.038,0,0,0,1.043-1.308l-.309-.47c.1-.167.191-.338.276-.519l.392.313a8.769,8.769,0,0,0,.594-1.811l-.362-.4c.044-.214.085-.432.117-.658Z",
    transform: "translate(-255.472 -169.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79546",
    "data-name": "Path 79546",
    className: "cls-8",
    d: "M358.414,248.052c0,6.287-4.442,8.82-9.921,5.656s-9.921-10.825-9.921-17.112,4.442-8.82,9.921-5.656,9.921,10.825,9.921,17.112",
    transform: "translate(-258.93 -175.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79547",
    "data-name": "Path 79547",
    className: "cls-7",
    d: "M364.733,258.157c0,4.508-3.185,6.324-7.114,4.056a15.674,15.674,0,0,1-7.114-12.27c0-4.508,3.185-6.324,7.114-4.056a15.675,15.675,0,0,1,7.114,12.27",
    transform: "translate(-268.057 -187.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79548",
    "data-name": "Path 79548",
    className: "cls-9",
    d: "M354.231,254.109a13.744,13.744,0,0,0,6.237,10.759c3.445,1.989,6.238.4,6.238-3.556a13.744,13.744,0,0,0-6.238-10.758c-3.445-1.989-6.237-.4-6.237,3.556",
    transform: "translate(-270.906 -190.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79549",
    "data-name": "Path 79549",
    className: "cls-10",
    d: "M368.5,264.2c0,3.442-2.432,4.833-5.43,3.1a11.987,11.987,0,0,1-5.441-9.388c0-3.359,2.318-4.771,5.235-3.194a.971.971,0,0,1,.206.1,11.994,11.994,0,0,1,5.42,9.078,2.889,2.889,0,0,1,.01.3",
    transform: "translate(-273.504 -194.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79550",
    "data-name": "Path 79550",
    className: "cls-11",
    d: "M378.841,266,377,267.226l-4.658-3.215-1.175-5.729,2.051-1.463a.947.947,0,0,1,.206.1,11.994,11.994,0,0,1,5.42,9.078",
    transform: "translate(-283.856 -196.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79551",
    "data-name": "Path 79551",
    className: "cls-12",
    d: "M366.25,265.576a11.982,11.982,0,0,1-5.438-9.38,5.235,5.235,0,0,1,.378-2.055c-2.077-.32-3.56,1.107-3.56,3.795a11.983,11.983,0,0,0,5.438,9.38c2.3,1.33,4.268.818,5.06-1.046a5.428,5.428,0,0,1-1.878-.694",
    transform: "translate(-273.504 -194.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79552",
    "data-name": "Path 79552",
    className: "cls-13",
    d: "M368.018,263.772A8.334,8.334,0,0,0,371.8,270.3c2.089,1.206,3.782.241,3.782-2.157a8.335,8.335,0,0,0-3.782-6.524c-2.089-1.206-3.782-.24-3.782,2.157",
    transform: "translate(-281.45 -199.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79553",
    "data-name": "Path 79553",
    className: "cls-11",
    d: "M374.1,272.651a4.435,4.435,0,0,0,2.013,3.471c1.111.642,2.012.128,2.012-1.147a4.434,4.434,0,0,0-2.012-3.471c-1.111-.642-2.013-.128-2.013,1.147",
    transform: "translate(-286.1 -207.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79554",
    "data-name": "Path 79554",
    className: "cls-13",
    d: "M373.357,275.6A3.617,3.617,0,0,0,375,278.432c.907.523,1.641.1,1.641-.936A3.616,3.616,0,0,0,375,274.665c-.907-.523-1.641-.1-1.641.936",
    transform: "translate(-285.533 -209.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79555",
    "data-name": "Path 79555",
    className: "cls-5",
    d: "M179.312,115.277c0,.136-.009.271-.009.41a16.426,16.426,0,0,0,.117,1.914l.4.257c.032.263.073.528.117.794l-.362-.015a21.429,21.429,0,0,0,.593,2.5l.392.14c.086.28.179.559.276.838l-.309.114a25.882,25.882,0,0,0,1.043,2.512l.362.012q.2.416.418.826l-.236.235a27.4,27.4,0,0,0,1.423,2.37l.307-.116q.262.387.536.763l-.149.343a25.253,25.253,0,0,0,1.713,2.076l.234-.236c.2.221.412.438.624.648l-.051.425a20.534,20.534,0,0,0,1.894,1.653l.146-.341q.331.251.669.482l.049.482c.322.218.648.426.978.617s.655.359.978.513l.049-.426q.337.158.669.29l.146.51a10.323,10.323,0,0,0,1.38.428l-1.84,1.994.843.436,1.894-1.008.225.094,6.419-2.705c.306-.141,2.046-2.144,2.321-2.341l-.048-.1.592-.342a6.032,6.032,0,0,0,1.043-1.308l-.223-.34.583-.336a8.779,8.779,0,0,0,.593-1.811l-.362-.4c.012-.058.02-.12.032-.179l.482-.279a13.242,13.242,0,0,0,.117-1.779c0-.139-.005-.28-.009-.421l-.392-.312c-.005-.152-.016-.307-.026-.46l.364-.21a19.059,19.059,0,0,0-.384-2.448l-.4-.2c-.05-.222-.106-.445-.164-.667l.306-.176a24.135,24.135,0,0,0-.857-2.546l-.379-.076q-.16-.4-.335-.787l.273-.175a27.193,27.193,0,0,0-1.273-2.485l-.339.052q-.217-.37-.445-.731l.193-.29a26.679,26.679,0,0,0-1.613-2.269l-.285.165q-.254-.317-.518-.623l.1-.387a23.039,23.039,0,0,0-1.854-1.907l-.318.183c-.151-.134-.3-.268-.455-.4v-.459a17.858,17.858,0,0,0-1.978-1.424l-.379.219-.018-.011c-.1-.058-.2-.109-.3-.163l-.1-.5a12.353,12.353,0,0,0-1.979-.861l-.533.308-.046-.013-.192-.515a7.987,7.987,0,0,0-1.854-.234l-.7.034a43.577,43.577,0,0,0-4.235,1.919l-.562.324-.03-.039-6.118,3.533-1.181,3.185,2.331-1.441a10.684,10.684,0,0,0-.329,1.781l.38.36c-.021.228-.034.462-.042.7Zm.588-2.827.387-.239c-.048.132-.1.264-.138.4Z",
    transform: "translate(-135.644 -80.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79556",
    "data-name": "Path 79556",
    className: "cls-6",
    d: "M193.675,105.84l-3.307,2.189-5.466,2.629,1.613-.406,5.362-2.32,3.378-2.726Z",
    transform: "translate(-141.407 -80.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79557",
    "data-name": "Path 79557",
    className: "cls-6",
    d: "M258.367,146.965l-2.775,4.1-5.965.947L250.9,154.5l6-.967,2.741-4.08-.608-1.266Z",
    transform: "translate(-190.908 -112.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79558",
    "data-name": "Path 79558",
    className: "cls-6",
    d: "M265.651,161.943l-3.227,4.11-5.513.936.857,2.546,5.547-.956,3.193-4.091-.35-1.156Z",
    transform: "translate(-196.478 -123.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79559",
    "data-name": "Path 79559",
    className: "cls-6",
    d: "M270.388,177.207l-3.045,4.087-5.695.96.384,2.448,5.728-.979,3.011-4.067-.117-1.094Z",
    transform: "translate(-200.101 -135.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79560",
    "data-name": "Path 79560",
    className: "cls-6",
    d: "M271.9,191.79l-2.936,4-5.8,1.046-.108,2.2,5.838-1.065,2.9-3.981.117-.956Z",
    transform: "translate(-201.176 -146.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79561",
    "data-name": "Path 79561",
    className: "cls-6",
    d: "M269.217,204.8l-2.576,3.548-6.163,1.5-.593,1.811,6.328-1.858,2.412-3.189.327-.748Z",
    transform: "translate(-198.752 -156.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79562",
    "data-name": "Path 79562",
    className: "cls-6",
    d: "M263.7,215.369l-2.9,2.806-5.841,2.24-1.043,1.308,5.875-2.26,2.865-2.787.557-.551Z",
    transform: "translate(-194.191 -164.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79563",
    "data-name": "Path 79563",
    className: "cls-6",
    d: "M248.995,133.2l-2.775,4.1-5.965.947,1.613,2.269,6-.967,2.741-4.08-.8-1.193Z",
    transform: "translate(-183.74 -101.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79564",
    "data-name": "Path 79564",
    className: "cls-6",
    d: "M238.128,121.5l-2.775,4.1-5.965.947,1.854,1.907,6-.967,2.741-4.08-.836-.951Z",
    transform: "translate(-175.429 -92.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79565",
    "data-name": "Path 79565",
    className: "cls-6",
    d: "M226.435,112.6l-2.775,4.1-5.965.947,1.979,1.424,6-.967,2.741-4.08-.845-.685Z",
    transform: "translate(-166.487 -86.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79566",
    "data-name": "Path 79566",
    className: "cls-6",
    d: "M214.648,106.988l-2.5,3.415-6.244,1.632,1.978.861,6.277-1.651,2.463-3.4-.868-.458Z",
    transform: "translate(-157.473 -81.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79567",
    "data-name": "Path 79567",
    className: "cls-6",
    d: "M203.485,105.06l-2.714,2.76-6.025,2.286,1.854.234,5.882-1.873,2.857-3.173-1.019-.184Z",
    transform: "translate(-148.936 -80.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79568",
    "data-name": "Path 79568",
    className: "cls-5",
    d: "M179.135,127.007l-4.032,2.154,1.064,1.64,2.967-1.677Z",
    transform: "translate(-133.914 -97.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79569",
    "data-name": "Path 79569",
    className: "cls-5",
    d: "M174.4,136.063l-4.032,2.328,1.064,1.64,2.967-1.677Z",
    transform: "translate(-130.291 -104.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79570",
    "data-name": "Path 79570",
    className: "cls-5",
    d: "M172.535,148.494l-4.032,2.328,1.064,1.64,2.968-1.677Z",
    transform: "translate(-128.866 -113.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79571",
    "data-name": "Path 79571",
    className: "cls-5",
    d: "M173.64,162.778l-4.032,2.328,1.064,1.64,2.967-1.677Z",
    transform: "translate(-129.711 -124.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79572",
    "data-name": "Path 79572",
    className: "cls-5",
    d: "M177.693,178.03l-4.032,2.328,1.064,1.64,2.967-1.677Z",
    transform: "translate(-132.811 -136.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79573",
    "data-name": "Path 79573",
    className: "cls-7",
    d: "M190.714,149.114a13.2,13.2,0,0,0,.117-1.779c0-.139-.005-.28-.009-.421l-.393-.311c-.008-.248-.021-.5-.042-.749l.38.079a19.1,19.1,0,0,0-.384-2.448l-.4-.2c-.06-.265-.124-.529-.2-.794l.337-.05a24.15,24.15,0,0,0-.857-2.546l-.379-.076q-.16-.4-.335-.787l.273-.175a27.181,27.181,0,0,0-1.273-2.485l-.339.052q-.217-.369-.445-.731l.193-.29a26.768,26.768,0,0,0-1.613-2.269l-.274.178q-.26-.324-.529-.637l.1-.387a23.039,23.039,0,0,0-1.854-1.907l-.192.292q-.287-.26-.581-.5v-.459a17.825,17.825,0,0,0-1.978-1.424l-.1.389c-.1-.06-.2-.123-.3-.181s-.2-.109-.3-.163l-.1-.5a12.374,12.374,0,0,0-1.979-.861v.46q-.294-.094-.581-.166l-.192-.514a7.984,7.984,0,0,0-1.854-.234l.1.5q-.269,0-.529.026l-.274-.494a5.723,5.723,0,0,0-1.613.406l.193.513c-.152.066-.3.137-.445.217l-.339-.444a5.409,5.409,0,0,0-1.273,1.015l.273.49c-.116.127-.228.26-.334.4l-.379-.362a7,7,0,0,0-.857,1.557l.337.439c-.071.183-.135.374-.2.569l-.4-.26a10.674,10.674,0,0,0-.384,2.005l.38.36c-.02.228-.033.462-.042.7l-.393-.142c0,.136-.009.271-.009.41a16.483,16.483,0,0,0,.117,1.914l.4.257c.032.263.073.528.117.794l-.362-.015a21.382,21.382,0,0,0,.594,2.5l.392.14c.086.28.179.559.276.838l-.309.114a25.85,25.85,0,0,0,1.043,2.512l.362.013q.2.416.418.826l-.236.235a27.482,27.482,0,0,0,1.423,2.37L173,146.8q.262.387.536.763l-.149.343a25.3,25.3,0,0,0,1.713,2.076l.234-.236c.2.221.412.438.624.648l-.051.425a20.528,20.528,0,0,0,1.894,1.653l.146-.341q.331.251.669.482l.049.482c.323.218.648.426.978.617s.656.358.978.513l.049-.426q.337.158.669.29l.146.51a9.865,9.865,0,0,0,1.894.534l-.051-.483c.211.034.419.057.624.072l.234.506a6.566,6.566,0,0,0,1.713-.1l-.149-.514a5.487,5.487,0,0,0,.536-.144l.307.47a5.328,5.328,0,0,0,1.424-.726l-.236-.508a5.2,5.2,0,0,0,.418-.343l.362.406a6.045,6.045,0,0,0,1.043-1.308l-.309-.47c.1-.167.191-.338.276-.519l.392.313a8.768,8.768,0,0,0,.593-1.811l-.362-.4c.044-.214.085-.432.117-.658Z",
    transform: "translate(-128.836 -96.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79574",
    "data-name": "Path 79574",
    className: "cls-8",
    d: "M192.827,152.45c0,6.287-4.442,8.82-9.921,5.656s-9.921-10.825-9.921-17.112,4.442-8.82,9.921-5.656,9.921,10.825,9.921,17.112",
    transform: "translate(-132.294 -102.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79575",
    "data-name": "Path 79575",
    className: "cls-7",
    d: "M199.146,162.556c0,4.508-3.185,6.324-7.114,4.056a15.675,15.675,0,0,1-7.114-12.27c0-4.508,3.185-6.324,7.114-4.056a15.674,15.674,0,0,1,7.114,12.27",
    transform: "translate(-141.421 -114.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79576",
    "data-name": "Path 79576",
    className: "cls-9",
    d: "M188.645,158.508a13.744,13.744,0,0,0,6.237,10.759c3.445,1.989,6.238.4,6.238-3.556a13.744,13.744,0,0,0-6.238-10.758c-3.445-1.989-6.237-.4-6.237,3.556",
    transform: "translate(-144.27 -117.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79577",
    "data-name": "Path 79577",
    className: "cls-10",
    d: "M202.913,168.6c0,3.442-2.432,4.833-5.43,3.1a11.988,11.988,0,0,1-5.441-9.388c0-3.359,2.318-4.771,5.235-3.194a.966.966,0,0,1,.206.1,11.993,11.993,0,0,1,5.42,9.078,2.892,2.892,0,0,1,.01.3",
    transform: "translate(-146.868 -121.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79578",
    "data-name": "Path 79578",
    className: "cls-11",
    d: "M213.255,170.4l-1.844,1.226-4.658-3.215-1.175-5.729,2.051-1.463a.953.953,0,0,1,.206.1,11.994,11.994,0,0,1,5.42,9.078",
    transform: "translate(-157.22 -123.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79579",
    "data-name": "Path 79579",
    className: "cls-12",
    d: "M200.663,169.975a11.982,11.982,0,0,1-5.438-9.38,5.231,5.231,0,0,1,.378-2.055c-2.077-.32-3.56,1.107-3.56,3.795a11.983,11.983,0,0,0,5.438,9.38c2.3,1.33,4.268.818,5.061-1.046a5.429,5.429,0,0,1-1.878-.694",
    transform: "translate(-146.868 -121.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79580",
    "data-name": "Path 79580",
    className: "cls-13",
    d: "M202.431,168.171a8.334,8.334,0,0,0,3.782,6.524c2.089,1.206,3.782.24,3.782-2.157a8.335,8.335,0,0,0-3.782-6.524c-2.089-1.206-3.782-.24-3.782,2.157",
    transform: "translate(-154.813 -126.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79581",
    "data-name": "Path 79581",
    className: "cls-11",
    d: "M208.512,177.049a4.434,4.434,0,0,0,2.013,3.471c1.111.642,2.012.128,2.012-1.147a4.434,4.434,0,0,0-2.012-3.471c-1.112-.642-2.013-.128-2.013,1.147",
    transform: "translate(-159.464 -134.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79582",
    "data-name": "Path 79582",
    className: "cls-13",
    d: "M207.771,180a3.616,3.616,0,0,0,1.641,2.831c.907.523,1.641.1,1.641-.936a3.616,3.616,0,0,0-1.641-2.831c-.907-.523-1.641-.1-1.641.936",
    transform: "translate(-158.897 -136.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79583",
    "data-name": "Path 79583",
    className: "cls-14",
    d: "M470.872,262.226l-3.382,1.953V266l4.26-3.272Z",
    transform: "translate(-357.523 -200.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79584",
    "data-name": "Path 79584",
    className: "cls-15",
    d: "M474.605,264.362l-3.382,1.953v1.822l3.382-1.953Z",
    transform: "translate(-360.378 -202.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79585",
    "data-name": "Path 79585",
    className: "cls-16",
    d: "M472.065,267.545l2.986-1.724v1.364l-2.986,1.724Z",
    transform: "translate(-361.022 -203.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79586",
    "data-name": "Path 79586",
    className: "cls-17",
    d: "M468.368,271.03l-.878-.5v1.822l.878.5Z",
    transform: "translate(-357.523 -206.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79587",
    "data-name": "Path 79587",
    className: "cls-18",
    d: "M478.591,268.957a1.2,1.2,0,0,1-.546.941c-.3.174-.546.035-.546-.311a1.2,1.2,0,0,1,.546-.941c.3-.174.546-.035.546.311",
    transform: "translate(-365.178 -205.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79588",
    "data-name": "Path 79588",
    className: "cls-19",
    d: "M478.623,269.621a.745.745,0,0,1-.338.583c-.187.108-.338.021-.338-.193a.744.744,0,0,1,.338-.582c.186-.108.338-.021.338.192",
    transform: "translate(-365.521 -206.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79589",
    "data-name": "Path 79589",
    className: "cls-18",
    d: "M473.564,271.858a1.2,1.2,0,0,1-.546.941c-.3.174-.546.035-.546-.311a1.2,1.2,0,0,1,.546-.941c.3-.174.546-.035.546.311",
    transform: "translate(-361.334 -207.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79590",
    "data-name": "Path 79590",
    className: "cls-19",
    d: "M473.8,272.367a.744.744,0,0,1-.338.582c-.187.108-.338.021-.338-.193a.744.744,0,0,1,.338-.582c.187-.108.338-.021.338.192",
    transform: "translate(-361.829 -208.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79591",
    "data-name": "Path 79591",
    className: "cls-19",
    d: "M482.723,266.667l.379-.217v1.139l-.379.217Z",
    transform: "translate(-369.173 -203.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79592",
    "data-name": "Path 79592",
    className: "cls-20",
    d: "M269.062,218.451l-27.023,15.6-.7,5.813,27.023-15.6Z",
    transform: "translate(-184.568 -167.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79593",
    "data-name": "Path 79593",
    className: "cls-21",
    d: "M99.178,135.341l27.023-15.6,34.142,23.22-27.023,15.6Z",
    transform: "translate(-75.848 -91.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79594",
    "data-name": "Path 79594",
    className: "cls-22",
    d: "M96.894,186.065l34.143,23.22-.7,5.813L96.191,194.665Z",
    transform: "translate(-73.564 -142.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79595",
    "data-name": "Path 79595",
    className: "cls-23",
    d: "M178.656,259.59l7.468,4.312.8-7.873v-3.842l-8.882-5.128v4.02Z",
    transform: "translate(-136.161 -188.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79596",
    "data-name": "Path 79596",
    className: "cls-24",
    d: "M182.718,235.584l8.882,5.128-4.675,2.7-8.882-5.128Z",
    transform: "translate(-136.162 -180.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79597",
    "data-name": "Path 79597",
    className: "cls-25",
    d: "M220.477,261.226v-3.842l-4.675,2.7v3.842Z",
    transform: "translate(-165.039 -196.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79598",
    "data-name": "Path 79598",
    className: "cls-26",
    d: "M217.874,273.716l-.8,7.873-4.675,2.7.8-7.873Z",
    transform: "translate(-162.436 -209.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79599",
    "data-name": "Path 79599",
    className: "cls-27",
    d: "M340.339,225.681c0,7.178,5.071,15.924,11.326,19.536s11.326.72,11.326-6.457-5.071-15.924-11.326-19.536-11.326-.72-11.326,6.457",
    transform: "translate(-260.282 -166.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79600",
    "data-name": "Path 79600",
    className: "cls-27",
    d: "M344.948,230.837c0,6.491,4.585,14.4,10.242,17.665s10.242.651,10.242-5.839-4.586-14.4-10.242-17.665-10.242-.651-10.242,5.839",
    transform: "translate(-263.806 -170.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79601",
    "data-name": "Path 79601",
    className: "cls-27",
    d: "M358.12,245.568a15.74,15.74,0,0,0,7.143,12.321c3.945,2.278,7.143.454,7.143-4.073a15.74,15.74,0,0,0-7.143-12.321c-3.945-2.278-7.143-.454-7.143,4.073",
    transform: "translate(-273.88 -183.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79602",
    "data-name": "Path 79602",
    className: "cls-28",
    d: "M362.95,250.97a13.237,13.237,0,0,0,6.007,10.362c3.318,1.915,6.008.382,6.008-3.425a13.238,13.238,0,0,0-6.008-10.362c-3.318-1.915-6.007-.382-6.007,3.425",
    transform: "translate(-277.574 -188.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79603",
    "data-name": "Path 79603",
    className: "cls-28",
    d: "M367.56,256.125a10.848,10.848,0,0,0,4.923,8.491c2.719,1.57,4.923.313,4.923-2.807a10.847,10.847,0,0,0-4.923-8.491c-2.719-1.57-4.923-.313-4.923,2.807",
    transform: "translate(-281.099 -193.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79604",
    "data-name": "Path 79604",
    className: "cls-28",
    d: "M381.39,271.594a3.679,3.679,0,0,0,1.67,2.88c.922.532,1.67.106,1.67-.952a3.68,3.68,0,0,0-1.67-2.88c-.922-.532-1.67-.106-1.67.952",
    transform: "translate(-291.676 -206.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79605",
    "data-name": "Path 79605",
    className: "cls-28",
    d: "M384.683,275.276a1.972,1.972,0,0,0,.9,1.544c.494.286.9.057.9-.51a1.972,1.972,0,0,0-.9-1.544c-.494-.286-.9-.057-.9.51",
    transform: "translate(-294.195 -210.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79606",
    "data-name": "Path 79606",
    className: "cls-29",
    d: "M277.78,340.98l-2.014,1.31-4.658-3.215-.907-5.865,2.05-1.463a2.16,2.16,0,0,1,1.246-.264c3.317.567,4.158,6.107,4.282,9.5",
    transform: "translate(-206.643 -253.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79607",
    "data-name": "Path 79607",
    className: "cls-30",
    d: "M275.16,334.226a8.334,8.334,0,0,0,3.782,6.524c2.089,1.206,3.782.241,3.782-2.156a8.335,8.335,0,0,0-3.782-6.524c-2.089-1.206-3.782-.24-3.782,2.157",
    transform: "translate(-210.434 -253.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79608",
    "data-name": "Path 79608",
    className: "cls-31",
    d: "M265.917,340.2a8.334,8.334,0,0,0,3.782,6.524c2.089,1.206,3.782.241,3.782-2.156a8.335,8.335,0,0,0-3.782-6.524c-2.089-1.206-3.782-.24-3.782,2.157",
    transform: "translate(-203.366 -258.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79609",
    "data-name": "Path 79609",
    className: "cls-30",
    d: "M272,349.083a4.435,4.435,0,0,0,2.013,3.471c1.111.642,2.012.128,2.012-1.147a4.434,4.434,0,0,0-2.012-3.471c-1.111-.642-2.013-.128-2.013,1.147",
    transform: "translate(-208.016 -265.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79610",
    "data-name": "Path 79610",
    className: "cls-32",
    d: "M271.256,352.033a3.617,3.617,0,0,0,1.641,2.831c.907.523,1.641.1,1.641-.936A3.616,3.616,0,0,0,272.9,351.1c-.907-.524-1.641-.1-1.641.936",
    transform: "translate(-207.449 -268.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79611",
    "data-name": "Path 79611",
    className: "cls-17",
    d: "M344.129,170.621l-2.63-1.475-3.1,3.442-2.014,2.452v2.055l5.367,3.65,11.776,8.154,4.615,1.439v-6.883l-15.733-9.478Z",
    transform: "translate(-257.259 -129.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79612",
    "data-name": "Path 79612",
    className: "cls-17",
    d: "M429.517,228.656v6.676l-2.892-1.669-2.72-6.39v-1.857Z",
    transform: "translate(-324.191 -172.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79613",
    "data-name": "Path 79613",
    className: "cls-33",
    d: "M355.591,194.858l-9.579-5.53v-1.067l9.579,5.53Z",
    transform: "translate(-264.62 -143.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79614",
    "data-name": "Path 79614",
    className: "cls-3",
    d: "M293.534,193.266,301,197.578l.8-7.873v-3.842l-8.882-5.128v4.019Z",
    transform: "translate(-224.017 -138.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79615",
    "data-name": "Path 79615",
    className: "cls-28",
    d: "M211.772,119.74l34.142,23.22-.7,5.813-34.142-20.431Z",
    transform: "translate(-161.419 -91.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79616",
    "data-name": "Path 79616",
    className: "cls-27",
    d: "M177.449,131.636c0,7.178,5.071,15.924,11.326,19.536s11.326.72,11.326-6.458-5.071-15.924-11.326-19.536-11.326-.721-11.326,6.458",
    transform: "translate(-135.708 -94.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79617",
    "data-name": "Path 79617",
    className: "cls-27",
    d: "M182.059,136.792c0,6.491,4.585,14.4,10.242,17.665s10.242.651,10.242-5.839-4.586-14.4-10.242-17.665-10.242-.651-10.242,5.839",
    transform: "translate(-139.234 -99.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79618",
    "data-name": "Path 79618",
    className: "cls-27",
    d: "M195.23,151.524a15.74,15.74,0,0,0,7.143,12.321c3.945,2.278,7.143.454,7.143-4.073a15.74,15.74,0,0,0-7.143-12.321c-3.945-2.278-7.143-.454-7.143,4.073",
    transform: "translate(-149.306 -112.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79619",
    "data-name": "Path 79619",
    className: "cls-28",
    d: "M200.06,156.925a13.237,13.237,0,0,0,6.007,10.362c3.318,1.916,6.007.382,6.007-3.425a13.237,13.237,0,0,0-6.007-10.362c-3.318-1.915-6.007-.382-6.007,3.425",
    transform: "translate(-153 -116.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79620",
    "data-name": "Path 79620",
    className: "cls-28",
    d: "M204.67,162.082a10.848,10.848,0,0,0,4.923,8.491c2.719,1.57,4.923.313,4.923-2.807a10.847,10.847,0,0,0-4.923-8.491c-2.719-1.57-4.923-.313-4.923,2.807",
    transform: "translate(-156.526 -121.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79621",
    "data-name": "Path 79621",
    className: "cls-28",
    d: "M218.5,177.55a3.679,3.679,0,0,0,1.669,2.88c.922.532,1.67.106,1.67-.952a3.68,3.68,0,0,0-1.67-2.88c-.922-.532-1.669-.106-1.669.952",
    transform: "translate(-167.103 -134.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79622",
    "data-name": "Path 79622",
    className: "cls-28",
    d: "M221.793,181.232a1.973,1.973,0,0,0,.9,1.544c.494.286.9.057.9-.51a1.971,1.971,0,0,0-.9-1.544c-.494-.286-.9-.057-.9.51",
    transform: "translate(-169.621 -138.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79623",
    "data-name": "Path 79623",
    className: "cls-34",
    d: "M341.152,324.047l7.258-3.227,16.391-9.464,3.374-2.911v-3.1l-27.023,15.6Z",
    transform: "translate(-260.903 -233.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79624",
    "data-name": "Path 79624",
    className: "cls-35",
    d: "M341.152,324.047l7.258-3.227-6.958,2.767-.04-2.274,26.429-15.389.164,2.368-1.844,1.891,2.014-1.738v-3.1l-27.023,15.6Z",
    transform: "translate(-260.903 -233.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79625",
    "data-name": "Path 79625",
    className: "cls-19",
    d: "M445.052,312.5a.884.884,0,0,1-.45.683l-1.271.754c-.209.138-.429.055-.406-.153l0-.032.036-.345a.7.7,0,0,1,.358-.542l.92-.55.511-.307c.154-.092.31-.036.306.11Z",
    transform: "translate(-338.736 -238.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79626",
    "data-name": "Path 79626",
    className: "cls-4",
    d: "M443.8,314.468l-.856.43.036-.345a.7.7,0,0,1,.358-.542l.92-.55-.008.324a.885.885,0,0,1-.45.683",
    transform: "translate(-338.752 -239.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79627",
    "data-name": "Path 79627",
    className: "cls-36",
    d: "M335.02,371.23l1.442.833v-3.1l-1.442-.833Z",
    transform: "translate(-256.214 -281.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79628",
    "data-name": "Path 79628",
    className: "cls-37",
    d: "M335.02,317.405l27.023-15.6,1.442.833-27.023,15.6Z",
    transform: "translate(-256.214 -230.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79629",
    "data-name": "Path 79629",
    className: "cls-28",
    d: "M348.537,284.767l5.611,3.24v12.7l-5.611-3.24Z",
    transform: "translate(-266.551 -217.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79630",
    "data-name": "Path 79630",
    className: "cls-14",
    d: "M357.276,316.159l-3.382,1.953v1.822l4.26-3.272Z",
    transform: "translate(-270.648 -241.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79631",
    "data-name": "Path 79631",
    className: "cls-15",
    d: "M361.01,318.3l-3.382,1.952v1.822l3.382-1.953Z",
    transform: "translate(-273.503 -243.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79632",
    "data-name": "Path 79632",
    className: "cls-16",
    d: "M358.47,321.478l2.986-1.724v1.364l-2.986,1.724Z",
    transform: "translate(-274.148 -244.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79633",
    "data-name": "Path 79633",
    className: "cls-17",
    d: "M354.772,324.963l-.878-.5v1.822l.878.5Z",
    transform: "translate(-270.648 -248.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79634",
    "data-name": "Path 79634",
    className: "cls-18",
    d: "M367.191,321.645a1.2,1.2,0,0,1-.546.941c-.3.174-.546.035-.546-.311a1.2,1.2,0,0,1,.546-.941c.3-.174.546-.035.546.311",
    transform: "translate(-279.983 -245.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79635",
    "data-name": "Path 79635",
    className: "cls-19",
    d: "M367.222,322.308a.744.744,0,0,1-.338.582c-.187.108-.338.021-.338-.193a.744.744,0,0,1,.338-.582c.186-.108.338-.021.338.192",
    transform: "translate(-280.325 -246.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79636",
    "data-name": "Path 79636",
    className: "cls-18",
    d: "M362.163,324.545a1.2,1.2,0,0,1-.545.941c-.3.174-.546.035-.546-.311a1.2,1.2,0,0,1,.546-.941c.3-.174.545-.035.545.311",
    transform: "translate(-276.138 -247.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79637",
    "data-name": "Path 79637",
    className: "cls-19",
    d: "M362.394,325.053a.744.744,0,0,1-.338.582c-.187.107-.338.021-.338-.193a.744.744,0,0,1,.338-.582c.186-.108.338-.022.338.192",
    transform: "translate(-276.632 -248.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79638",
    "data-name": "Path 79638",
    className: "cls-19",
    d: "M358.9,326.657l.379-.217v1.139l-.379.217Z",
    transform: "translate(-274.48 -249.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79639",
    "data-name": "Path 79639",
    className: "cls-33",
    d: "M357.4,268.555l27.023-15.6v-1.837l-27.023,15.6Z",
    transform: "translate(-273.327 -192.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79640",
    "data-name": "Path 79640",
    className: "cls-33",
    d: "M1.511,45.431l27.023-15.6L78.941,68.548,51.918,84.15Z",
    transform: "translate(-1.156 -22.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79641",
    "data-name": "Path 79641",
    className: "cls-38",
    d: "M114.525,113.137l15.629-9.027,22.975,15.774-17.318,14.271Z",
    transform: "translate(-87.586 -79.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79642",
    "data-name": "Path 79642",
    className: "cls-15",
    d: "M65.539,89.471l-5.68,3.476L7.851,63.5l-1.163.665-.231,1.492v4.859l50.407,38.719L66.972,97.172l1.665-3.463Z",
    transform: "translate(-4.938 -48.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79643",
    "data-name": "Path 79643",
    className: "cls-15",
    d: "M175.471,25.976l-5.68,3.476L117.783,0,116.62.666l-.231,1.492V7.017L166.8,45.736,176.9,33.677l1.665-3.463Z",
    transform: "translate(-89.011 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79644",
    "data-name": "Path 79644",
    className: "cls-39",
    d: "M242.824,143.967l-27.023,15.6,10.108-12.059,1.665-3.463,27.023-15.6-1.665,3.463Z",
    transform: "translate(-165.039 -98.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79645",
    "data-name": "Path 79645",
    className: "cls-14",
    d: "M240.133,230.663l-2.63-1.475-3.1,3.442-2.014,2.452v2.054l5.367,3.65,11.776,8.154,4.615,1.439V243.1l-15.733-9.083Z",
    transform: "translate(-177.725 -175.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79646",
    "data-name": "Path 79646",
    className: "cls-40",
    d: "M334.595,301.311v6.676l-1.712.989V302.3Z",
    transform: "translate(-254.579 -230.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79647",
    "data-name": "Path 79647",
    className: "cls-28",
    d: "M254.123,219.512l4.91-2.976-2.28,4.451Z",
    transform: "translate(-194.346 -165.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79648",
    "data-name": "Path 79648",
    className: "cls-33",
    d: "M255.27,252.779l-9.579-5.53v-1.067l9.579,5.53Z",
    transform: "translate(-187.898 -188.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79649",
    "data-name": "Path 79649",
    className: "cls-15",
    d: "M324.567,216.561l-27.023,15.6-18.409-10.629,27.022-15.6Z",
    transform: "translate(-213.475 -157.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79650",
    "data-name": "Path 79650",
    className: "cls-4",
    d: "M393.011,183.14,414.932,195.8v-.434l-21.921-12.656Z",
    transform: "translate(-300.564 -139.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79651",
    "data-name": "Path 79651",
    className: "cls-4",
    d: "M484.2,240.952l.236.136.235-.136v-5.328l-.471-.272Z",
    transform: "translate(-370.301 -179.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79652",
    "data-name": "Path 79652",
    className: "cls-4",
    d: "M465.96,230.423l.236.136.236-.136v-5.31l-.471-.29Z",
    transform: "translate(-356.353 -171.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79653",
    "data-name": "Path 79653",
    className: "cls-4",
    d: "M447.723,219.894l.236.136.236-.136V214.6l-.471-.307Z",
    transform: "translate(-342.406 -163.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79654",
    "data-name": "Path 79654",
    className: "cls-4",
    d: "M429.486,209.364l.236.136.235-.136v-5.275l-.471-.325Z",
    transform: "translate(-328.459 -155.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79655",
    "data-name": "Path 79655",
    className: "cls-4",
    d: "M411.249,198.835l.236.136.235-.136v-5.258l-.471-.342Z",
    transform: "translate(-314.511 -147.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79656",
    "data-name": "Path 79656",
    className: "cls-4",
    d: "M393.011,188.305l.236.136.236-.136v-5.24l-.471-.36Z",
    transform: "translate(-300.564 -139.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79657",
    "data-name": "Path 79657",
    className: "cls-33",
    d: "M273.356,204.795l2.788,10.735,2.375,3.228V223.1L258,211.258l6.059-11.829Z",
    transform: "translate(-197.312 -152.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79658",
    "data-name": "Path 79658",
    className: "cls-17",
    d: "M314.639,294.98v6.676l-2.892-1.67-2.72-6.39v-1.857Z",
    transform: "translate(-236.336 -223.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79659",
    "data-name": "Path 79659",
    className: "cls-33",
    d: "M279.135,274.094l18.409,10.629v-1.837l-18.409-10.629Z",
    transform: "translate(-213.475 -208.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79660",
    "data-name": "Path 79660",
    className: "cls-33",
    d: "M354.662,168.964,357.45,179.7l2.376,3.228v4.345l-14.6,8.428.139-32.1Z",
    transform: "translate(-264.02 -125.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79661",
    "data-name": "Path 79661",
    className: "cls-41",
    d: "M170.526,28.805l-5.68,3.476L112.838,2.829l-.826.649-.568,1.509V9.846L161.85,48.565l10.108-12.059,1.665-3.463Z",
    transform: "translate(-85.229 -2.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79662",
    "data-name": "Path 79662",
    className: "cls-42",
    d: "M121.762,21.79l6.111,4.959.886.675,2.866,2.184L136.2,33.1l2.387,1.819,2.866,2.185,6.965,5.308,2.866,2.183,6.966,5.309,2.866,2.184,7.538,5.745,3.562-4.415,1.5-1.861,1.753-2.173L167.2,44.722l-3.187-1.8-7.746-4.363-3.188-1.8-7.747-4.363-3.187-1.8L134.4,26.248l-3.188-1.8-8.833-4.971Z",
    transform: "translate(-93.12 -14.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79663",
    "data-name": "Path 79663",
    className: "cls-43",
    d: "M161.9,51.632l-2.866-2.184-6.966-5.309-2.866-2.183-6.965-5.308-2.866-2.184-2.387-1.819-4.578-3.488-2.866-2.184-.886-.675-6.111-4.959.411-1.531-.576-.324-.62,2.309,6.111,4.959.886.675,2.866,2.184L136.2,33.1l2.387,1.819,2.866,2.184,6.965,5.308,2.866,2.183,6.966,5.309,2.866,2.185,7.538,5.745.525-.651Z",
    transform: "translate(-93.12 -14.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79664",
    "data-name": "Path 79664",
    className: "cls-40",
    d: "M122.547,21.336l-.785.454.62-2.309.576.324Z",
    transform: "translate(-93.12 -14.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79665",
    "data-name": "Path 79665",
    className: "cls-44",
    d: "M182.471,64.687l.5-.616-8.006-4.516,1.274-1.541-.28-.158-2.907-1.637-1.272,1.539-7.743-4.368,1.269-1.534-.28-.158-2.908-1.638-1.267,1.533L153.1,47.224l1.262-1.527-.28-.158L151.18,43.9l-1.261,1.526-7.742-4.367,1.257-1.521-.28-.158-2.908-1.638-1.255,1.519-1.592-.9-3.409-1.711-.785.453,4.2,2.321.886.675,2.866,2.185,4.578,3.488,2.653,1.5,1.814,2.96.785-.453.586-.709,7.743,4.368.717,4.287.785-.453,1.684-2.036L170.25,59.6l-.38,5.615.785-.454,2.78-3.364,8.031,4.531Z",
    transform: "translate(-101.871 -28.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79666",
    "data-name": "Path 79666",
    className: "cls-40",
    d: "M215.273,76.106l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-164.034 -56.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79667",
    "data-name": "Path 79667",
    className: "cls-40",
    d: "M206.27,87l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-157.149 -65.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79668",
    "data-name": "Path 79668",
    className: "cls-40",
    d: "M261.711,102.3l-.785.454,1.774-2.146.28.158Z",
    transform: "translate(-199.548 -76.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79669",
    "data-name": "Path 79669",
    className: "cls-40",
    d: "M248.064,119.157l-.785.454,1.684-2.036.28.158Z",
    transform: "translate(-189.111 -89.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79670",
    "data-name": "Path 79670",
    className: "cls-40",
    d: "M308.169,128.486l-.785.454,1.779-2.152.28.158Z",
    transform: "translate(-235.078 -96.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79671",
    "data-name": "Path 79671",
    className: "cls-40",
    d: "M289.863,146.7l-.785.454,2.78-3.364.28.158Z",
    transform: "translate(-221.078 -109.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79672",
    "data-name": "Path 79672",
    className: "cls-40",
    d: "M168.794,49.927l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-128.488 -36.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79673",
    "data-name": "Path 79673",
    className: "cls-41",
    d: "M182.471,66.161l-8.295-4.679,1.779-2.152-3.187-1.8-1.777,2.15-7.743-4.368,1.774-2.146-3.188-1.8-1.772,2.144-7.743-4.368,1.768-2.138-3.187-1.8-1.767,2.138-7.742-4.367,1.763-2.132-3.188-1.8-1.76,2.13-1.592-.9L133.2,38.581l3.419,2.775.886.675,2.866,2.184,4.578,3.488,2.653,1.5-.267.322,2.866,2.184.586-.709,7.743,4.368-1.364,1.65,2.866,2.183,1.684-2.036,7.743,4.368L167,64.508l2.866,2.184,2.78-3.364,8.32,4.693Z",
    transform: "translate(-101.871 -29.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79674",
    "data-name": "Path 79674",
    className: "cls-45",
    d: "M126.961,44.643l10.415,15.31L166.415,81.2l5.437-2.078Z",
    transform: "translate(-97.096 -34.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79675",
    "data-name": "Path 79675",
    className: "cls-36",
    d: "M335.284,189.21v2.37l-18.8-13.225,4.341-8.476,9.3,5.366,2.788,10.735Z",
    transform: "translate(-242.038 -129.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79676",
    "data-name": "Path 79676",
    className: "cls-46",
    d: "M332.725,181.828v5.511l-2.909-1.68v-1.254l1.566-3.352Z",
    transform: "translate(-252.234 -138.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79677",
    "data-name": "Path 79677",
    className: "cls-47",
    d: "M284.1,218.758v2.37L265.3,207.9l4.341-8.476,9.3,5.367,2.788,10.735Z",
    transform: "translate(-202.897 -152.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79678",
    "data-name": "Path 79678",
    className: "cls-48",
    d: "M301.329,219.858l1.618,6.178-6.171-3.563-1.162-2.863v-3.052Z",
    transform: "translate(-226.077 -165.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79679",
    "data-name": "Path 79679",
    className: "cls-48",
    d: "M281.546,211.377v5.511l-2.909-1.679v-1.254L280.2,210.6Z",
    transform: "translate(-213.094 -161.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79680",
    "data-name": "Path 79680",
    className: "cls-33",
    d: "M367.56,112.877l14.115,8.149v-2.449l-14.115-8.149Z",
    transform: "translate(-281.099 -84.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79681",
    "data-name": "Path 79681",
    className: "cls-33",
    d: "M410.133,153.646l4.1-6.125v-2.449l-4.1,6.125Z",
    transform: "translate(-313.658 -110.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79682",
    "data-name": "Path 79682",
    className: "cls-49",
    d: "M293.055,177.392l14.6-8.428-9.295-5.367-14.6,8.428Z",
    transform: "translate(-217.011 -125.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79683",
    "data-name": "Path 79683",
    className: "cls-50",
    d: "M323.275,194.84l14.6-8.428,2.789,10.735-14.6,8.428Z",
    transform: "translate(-247.231 -142.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79684",
    "data-name": "Path 79684",
    className: "cls-48",
    d: "M326.549,199l13.344-7.7,2.359,9.08-13.344,7.7Z",
    transform: "translate(-249.735 -146.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79685",
    "data-name": "Path 79685",
    className: "cls-49",
    d: "M347.8,226.915,344.654,226,333.8,232.1l.653,2.515Z",
    transform: "translate(-255.28 -172.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79686",
    "data-name": "Path 79686",
    className: "cls-15",
    d: "M363.39,184.027l1.618,6.178-6.171-3.563-1.162-2.863v-3.052Z",
    transform: "translate(-273.54 -138.215)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72972",
    "data-name": "Group 72972",
    className: "cls-51",
    transform: "translate(66.748 43.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72971",
    "data-name": "Group 72971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72970",
    "data-name": "Group 72970",
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79687",
    "data-name": "Path 79687",
    className: "cls-53",
    d: "M308.691,190.408l-9.863,5.585-5.174,1.154-.6-2.307-9.3-5.367,23.894-3.062Z",
    transform: "translate(-283.759 -186.412)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79688",
    "data-name": "Path 79688",
    className: "cls-5",
    d: "M49.006,190.509c0,.136-.009.271-.009.41a16.48,16.48,0,0,0,.117,1.914l.4.257c.032.263.073.528.117.794l-.362-.015a21.368,21.368,0,0,0,.594,2.5l.392.14c.086.28.179.559.276.838l-.309.114a25.874,25.874,0,0,0,1.043,2.512l.362.012q.2.416.418.826l-.236.235a27.513,27.513,0,0,0,1.424,2.37l.307-.115q.262.387.536.763l-.149.343a25.3,25.3,0,0,0,1.713,2.076l.234-.236c.2.221.412.438.624.648l-.051.424a20.535,20.535,0,0,0,1.894,1.653l.146-.341q.331.251.669.482l.049.482c.322.218.648.426.978.617s.655.359.978.513l.049-.426q.337.158.669.29l.146.51a10.27,10.27,0,0,0,1.38.428l-1.84,1.994.843.436,1.894-1.008.225.094,6.419-2.705c.307-.141,2.046-2.144,2.321-2.341l-.048-.1.592-.342a6.032,6.032,0,0,0,1.043-1.308l-.223-.339.583-.336a8.774,8.774,0,0,0,.594-1.811l-.362-.4c.012-.058.02-.12.032-.179l.482-.279a13.239,13.239,0,0,0,.117-1.779c0-.139-.005-.28-.009-.421l-.392-.312c-.005-.152-.016-.307-.026-.46l.364-.21a19.065,19.065,0,0,0-.384-2.448l-.4-.2c-.05-.222-.106-.445-.164-.667l.306-.176a24.13,24.13,0,0,0-.857-2.546l-.379-.076c-.106-.263-.219-.525-.334-.787l.273-.175a27.188,27.188,0,0,0-1.273-2.485l-.339.052q-.217-.369-.445-.731l.193-.29a26.688,26.688,0,0,0-1.613-2.269l-.285.165q-.254-.317-.518-.623l.1-.387a23.039,23.039,0,0,0-1.854-1.907l-.318.183c-.151-.134-.3-.267-.455-.4v-.46a17.882,17.882,0,0,0-1.979-1.424l-.379.219-.018-.011c-.1-.058-.2-.109-.3-.163l-.1-.5a12.35,12.35,0,0,0-1.978-.861l-.533.308-.047-.013-.192-.514a7.984,7.984,0,0,0-1.854-.234l-.7.034a43.629,43.629,0,0,0-4.235,1.919l-.562.324-.03-.039-6.118,3.533-1.181,3.185,2.331-1.441a10.709,10.709,0,0,0-.329,1.781l.38.36c-.02.228-.034.462-.042.7Zm.588-2.826.387-.239c-.048.132-.1.264-.138.4Z",
    transform: "translate(-35.989 -137.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79689",
    "data-name": "Path 79689",
    className: "cls-6",
    d: "M63.369,181.072l-3.307,2.189L54.6,185.89l1.613-.406,5.362-2.32,3.378-2.726Z",
    transform: "translate(-41.754 -137.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79690",
    "data-name": "Path 79690",
    className: "cls-6",
    d: "M128.061,222.2l-2.775,4.1-5.965.948,1.273,2.485,6-.967,2.741-4.08-.608-1.266Z",
    transform: "translate(-91.254 -169.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79691",
    "data-name": "Path 79691",
    className: "cls-6",
    d: "M135.345,237.175l-3.227,4.11-5.513.937.857,2.546,5.546-.956,3.193-4.09-.35-1.157Z",
    transform: "translate(-96.824 -181.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79692",
    "data-name": "Path 79692",
    className: "cls-6",
    d: "M140.082,252.439l-3.045,4.087-5.695.96.384,2.448,5.728-.979,3.012-4.067-.117-1.094Z",
    transform: "translate(-100.447 -193.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79693",
    "data-name": "Path 79693",
    className: "cls-6",
    d: "M141.595,267.023l-2.936,4-5.8,1.046-.108,2.2,5.838-1.065,2.9-3.981.117-.956Z",
    transform: "translate(-101.521 -204.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79694",
    "data-name": "Path 79694",
    className: "cls-6",
    d: "M138.911,280.03l-2.576,3.548-6.163,1.5-.593,1.811,6.328-1.858,2.412-3.189.327-.748Z",
    transform: "translate(-99.097 -214.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79695",
    "data-name": "Path 79695",
    className: "cls-6",
    d: "M133.4,290.6l-2.9,2.806-5.841,2.24-1.043,1.308,5.875-2.26,2.864-2.787.557-.55Z",
    transform: "translate(-94.536 -222.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79696",
    "data-name": "Path 79696",
    className: "cls-6",
    d: "M118.689,208.436l-2.775,4.1-5.965.947,1.613,2.269,6-.967,2.741-4.08-.8-1.193Z",
    transform: "translate(-84.086 -159.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79697",
    "data-name": "Path 79697",
    className: "cls-6",
    d: "M107.822,196.737l-2.775,4.1-5.965.948,1.854,1.907,6-.967,2.741-4.08-.836-.95Z",
    transform: "translate(-75.775 -150.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79698",
    "data-name": "Path 79698",
    className: "cls-6",
    d: "M96.129,187.829l-2.775,4.1-5.965.948,1.979,1.424,6-.967,2.741-4.08-.845-.685Z",
    transform: "translate(-66.833 -143.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79699",
    "data-name": "Path 79699",
    className: "cls-6",
    d: "M84.342,182.22l-2.5,3.415L75.6,187.267l1.979.861,6.277-1.651,2.462-3.4-.868-.458Z",
    transform: "translate(-57.819 -139.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79700",
    "data-name": "Path 79700",
    className: "cls-6",
    d: "M73.179,180.292l-2.714,2.76-6.025,2.286,1.854.234,5.883-1.873,2.857-3.173-1.019-.183Z",
    transform: "translate(-49.282 -137.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79701",
    "data-name": "Path 79701",
    className: "cls-5",
    d: "M48.829,202.239,44.8,204.393l1.064,1.64,2.967-1.677Z",
    transform: "translate(-34.26 -154.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79702",
    "data-name": "Path 79702",
    className: "cls-5",
    d: "M44.092,211.295l-4.032,2.328,1.065,1.64,2.967-1.677Z",
    transform: "translate(-30.637 -161.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79703",
    "data-name": "Path 79703",
    className: "cls-5",
    d: "M42.228,223.726,38.2,226.054l1.064,1.641,2.968-1.677Z",
    transform: "translate(-29.212 -171.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79704",
    "data-name": "Path 79704",
    className: "cls-5",
    d: "M43.334,238.01,39.3,240.338l1.064,1.64,2.967-1.677Z",
    transform: "translate(-30.057 -182.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79705",
    "data-name": "Path 79705",
    className: "cls-5",
    d: "M47.387,253.262l-4.032,2.328,1.064,1.64,2.967-1.677Z",
    transform: "translate(-33.157 -193.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79706",
    "data-name": "Path 79706",
    className: "cls-7",
    d: "M60.408,224.346a13.238,13.238,0,0,0,.117-1.778c0-.139-.005-.28-.009-.421l-.393-.311c-.008-.248-.021-.5-.042-.749l.38.079a19.015,19.015,0,0,0-.384-2.448l-.4-.2c-.06-.265-.124-.529-.2-.794l.337-.05a24.129,24.129,0,0,0-.857-2.546l-.379-.077q-.159-.4-.334-.787l.273-.175A27.218,27.218,0,0,0,57.25,211.6l-.339.052q-.217-.37-.446-.731l.193-.29a26.772,26.772,0,0,0-1.613-2.269l-.274.178q-.26-.324-.529-.636l.1-.387a22.967,22.967,0,0,0-1.854-1.907l-.192.293q-.288-.26-.581-.5v-.459a17.82,17.82,0,0,0-1.978-1.424l-.1.388c-.1-.06-.2-.123-.3-.181s-.2-.109-.3-.163l-.1-.5a12.373,12.373,0,0,0-1.979-.861v.46q-.293-.094-.58-.166l-.192-.514a8,8,0,0,0-1.854-.234l.1.5q-.269,0-.529.026l-.274-.495a5.731,5.731,0,0,0-1.613.406l.193.513c-.152.066-.3.137-.445.217l-.339-.444a5.41,5.41,0,0,0-1.273,1.015l.273.49c-.116.127-.228.26-.334.4l-.379-.362a6.994,6.994,0,0,0-.857,1.557l.337.439c-.071.183-.135.374-.2.569l-.4-.26a10.663,10.663,0,0,0-.384,2.005l.38.36c-.02.228-.033.462-.042.7l-.393-.142c0,.136-.009.271-.009.41a16.48,16.48,0,0,0,.117,1.914l.4.257c.032.263.072.528.117.794l-.362-.015a21.382,21.382,0,0,0,.594,2.5l.392.14c.086.28.179.559.276.838l-.309.114a25.872,25.872,0,0,0,1.043,2.512l.362.012q.2.416.418.826l-.236.235a27.334,27.334,0,0,0,1.424,2.37l.307-.115q.262.387.536.763l-.149.343a25.293,25.293,0,0,0,1.713,2.076l.234-.236c.205.221.413.438.624.648l-.051.424A20.535,20.535,0,0,0,47.5,227.7l.146-.341q.331.251.669.482l.049.482c.323.218.648.426.978.617s.656.358.978.513l.049-.426q.337.158.669.29l.146.51a9.862,9.862,0,0,0,1.894.534l-.051-.483c.211.034.419.057.624.072l.234.506a6.556,6.556,0,0,0,1.713-.1l-.149-.515a5.488,5.488,0,0,0,.536-.144l.307.47a5.323,5.323,0,0,0,1.423-.726l-.236-.508a5.207,5.207,0,0,0,.418-.343l.362.406a6.037,6.037,0,0,0,1.043-1.308l-.309-.47c.1-.167.191-.338.276-.519l.392.313a8.786,8.786,0,0,0,.593-1.811l-.362-.4c.045-.214.085-.433.117-.659Z",
    transform: "translate(-29.182 -154.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79707",
    "data-name": "Path 79707",
    className: "cls-8",
    d: "M62.521,227.682c0,6.287-4.442,8.82-9.921,5.656s-9.921-10.825-9.921-17.112,4.442-8.82,9.921-5.656,9.921,10.825,9.921,17.112",
    transform: "translate(-32.64 -159.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79708",
    "data-name": "Path 79708",
    className: "cls-7",
    d: "M68.84,237.788c0,4.508-3.185,6.324-7.114,4.056a15.674,15.674,0,0,1-7.114-12.27c0-4.508,3.185-6.324,7.114-4.056a15.675,15.675,0,0,1,7.114,12.27",
    transform: "translate(-41.766 -171.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79709",
    "data-name": "Path 79709",
    className: "cls-54",
    d: "M58.338,233.74A13.744,13.744,0,0,0,64.576,244.5c3.445,1.989,6.237.4,6.237-3.556a13.744,13.744,0,0,0-6.237-10.758c-3.445-1.989-6.238-.4-6.238,3.556",
    transform: "translate(-44.615 -175.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79710",
    "data-name": "Path 79710",
    className: "cls-55",
    d: "M72.607,243.835c0,3.442-2.432,4.833-5.43,3.1a11.987,11.987,0,0,1-5.441-9.387c0-3.359,2.318-4.771,5.235-3.194a.961.961,0,0,1,.206.1,11.994,11.994,0,0,1,5.42,9.078,2.947,2.947,0,0,1,.01.3",
    transform: "translate(-47.214 -178.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79711",
    "data-name": "Path 79711",
    className: "cls-56",
    d: "M82.949,245.631,81.1,246.857l-4.658-3.215-1.175-5.729,2.05-1.463a.95.95,0,0,1,.206.1,11.994,11.994,0,0,1,5.42,9.078",
    transform: "translate(-57.566 -180.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79712",
    "data-name": "Path 79712",
    className: "cls-57",
    d: "M70.358,245.207a11.982,11.982,0,0,1-5.438-9.38,5.235,5.235,0,0,1,.378-2.055c-2.077-.32-3.56,1.107-3.56,3.795a11.983,11.983,0,0,0,5.438,9.38c2.3,1.33,4.268.818,5.06-1.046a5.429,5.429,0,0,1-1.878-.694",
    transform: "translate(-47.215 -178.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79713",
    "data-name": "Path 79713",
    className: "cls-58",
    d: "M72.125,243.4a8.334,8.334,0,0,0,3.782,6.524c2.089,1.206,3.782.241,3.782-2.156a8.335,8.335,0,0,0-3.782-6.524c-2.089-1.206-3.782-.24-3.782,2.157",
    transform: "translate(-55.159 -184.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79714",
    "data-name": "Path 79714",
    className: "cls-55",
    d: "M78.206,252.281a4.434,4.434,0,0,0,2.013,3.471c1.111.642,2.013.128,2.013-1.147a4.434,4.434,0,0,0-2.013-3.471c-1.112-.642-2.013-.128-2.013,1.147",
    transform: "translate(-59.81 -191.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79715",
    "data-name": "Path 79715",
    className: "cls-59",
    d: "M77.464,255.231a3.617,3.617,0,0,0,1.641,2.831c.907.523,1.641.1,1.641-.936a3.616,3.616,0,0,0-1.641-2.831c-.907-.524-1.641-.1-1.641.936",
    transform: "translate(-59.242 -194.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79716",
    "data-name": "Path 79716",
    className: "cls-15",
    d: "M279.7,110.427l-27.023,15.6,14.115,8.149,10.877-2.523,12.046-6.953,4.1-6.125Z",
    transform: "translate(-193.244 -84.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79717",
    "data-name": "Path 79717",
    className: "cls-41",
    d: "M252.682,179.2l14.115,8.149V184.9l-14.115-8.149Z",
    transform: "translate(-193.244 -135.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79718",
    "data-name": "Path 79718",
    className: "cls-33",
    d: "M323.563,203.118l-10.877,2.523v-2.449l10.877-2.523Z",
    transform: "translate(-239.133 -153.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79719",
    "data-name": "Path 79719",
    className: "cls-41",
    d: "M370.97,173.559l-12.046,6.953v-2.449l12.046-6.953Z",
    transform: "translate(-274.495 -130.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79720",
    "data-name": "Path 79720",
    className: "cls-41",
    d: "M60.593,92.3l-5.68,3.476L2.905,66.324l-.826.649-.568,1.509v4.859L51.918,112.06,62.026,100l1.665-3.463Z",
    transform: "translate(-1.155 -50.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79721",
    "data-name": "Path 79721",
    className: "cls-42",
    d: "M11.829,85.285l6.111,4.959.886.675L21.692,93.1l4.578,3.488,2.387,1.819,2.866,2.185,6.965,5.308,2.866,2.183,6.966,5.309,2.866,2.184,7.538,5.745,3.562-4.415,1.5-1.86,1.754-2.173-8.27-4.658-3.187-1.8-7.746-4.363-3.188-1.8L35.4,95.9l-3.187-1.8L24.47,89.743l-3.188-1.8-8.833-4.971Z",
    transform: "translate(-9.047 -63.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79722",
    "data-name": "Path 79722",
    className: "cls-43",
    d: "M51.972,115.127l-2.866-2.184-6.966-5.309-2.866-2.183-6.965-5.308-2.866-2.185-2.387-1.819L22.477,92.65l-2.866-2.184-.886-.675-6.111-4.959.411-1.531-.577-.324-.62,2.309,6.111,4.959.886.675L21.692,93.1l4.578,3.488,2.387,1.819,2.866,2.184,6.965,5.308,2.866,2.183L48.32,113.4l2.866,2.185,7.538,5.745.526-.652Z",
    transform: "translate(-9.046 -63.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79723",
    "data-name": "Path 79723",
    className: "cls-40",
    d: "M12.614,84.832l-.785.454.62-2.309.576.324Z",
    transform: "translate(-9.046 -63.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79724",
    "data-name": "Path 79724",
    className: "cls-44",
    d: "M72.538,128.182l.5-.616-8.006-4.516,1.274-1.541-.28-.158-2.907-1.637-1.272,1.539L54.1,116.885l1.269-1.534-.28-.158-2.908-1.638-1.267,1.533-7.743-4.367,1.262-1.528-.28-.158L41.247,107.4l-1.262,1.526-7.742-4.367,1.257-1.521-.28-.158-2.908-1.638-1.255,1.519-1.592-.9-3.409-1.711-.785.453,4.2,2.321.886.675,2.866,2.185,4.578,3.488,2.653,1.5,1.814,2.96.785-.453.586-.709,7.743,4.368.717,4.287.785-.453,1.684-2.036,7.743,4.368-.38,5.615.785-.454L63.5,124.9l8.032,4.531Z",
    transform: "translate(-17.798 -76.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79725",
    "data-name": "Path 79725",
    className: "cls-40",
    d: "M105.34,139.6l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-79.961 -105.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79726",
    "data-name": "Path 79726",
    className: "cls-40",
    d: "M96.338,150.492l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-73.076 -113.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79727",
    "data-name": "Path 79727",
    className: "cls-40",
    d: "M151.778,165.794l-.785.454,1.774-2.146.28.158Z",
    transform: "translate(-115.475 -125.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79728",
    "data-name": "Path 79728",
    className: "cls-40",
    d: "M138.132,182.652l-.785.454,1.684-2.036.28.158Z",
    transform: "translate(-105.039 -138.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79729",
    "data-name": "Path 79729",
    className: "cls-40",
    d: "M198.237,191.981l-.785.454,1.779-2.152.28.158Z",
    transform: "translate(-151.005 -145.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79730",
    "data-name": "Path 79730",
    className: "cls-40",
    d: "M179.93,210.19l-.785.454,2.78-3.364.28.158Z",
    transform: "translate(-137.005 -158.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79731",
    "data-name": "Path 79731",
    className: "cls-40",
    d: "M58.862,113.422l-.785.454,1.763-2.132.28.158Z",
    transform: "translate(-44.415 -85.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79732",
    "data-name": "Path 79732",
    className: "cls-41",
    d: "M72.538,129.656l-8.295-4.679,1.779-2.152-3.187-1.8-1.777,2.15-7.743-4.368,1.774-2.146-3.188-1.8-1.772,2.144-7.743-4.368,1.768-2.138-3.187-1.8L39.2,110.849l-7.742-4.367,1.763-2.132-3.188-1.8-1.76,2.13-1.592-.9-3.409-1.711,3.419,2.775.886.675,2.866,2.184,4.578,3.488,2.653,1.5-.266.322,2.866,2.184.586-.709,7.743,4.368-1.364,1.65,2.866,2.183,1.684-2.036,7.743,4.368L57.071,128l2.866,2.184,2.78-3.364,8.32,4.693Z",
    transform: "translate(-17.798 -78.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79733",
    "data-name": "Path 79733",
    className: "cls-45",
    d: "M21.877,111.8l11.563,13.127,30.37,20.852,1.818-.362Z",
    transform: "translate(-16.731 -85.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79734",
    "data-name": "Path 79734",
    className: "cls-60",
    d: "M359.826,248.142l-14.6,8.428V254.2l14.6-8.428Z",
    transform: "translate(-264.02 -187.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79735",
    "data-name": "Path 79735",
    className: "cls-61",
    d: "M335.129,240.478l2.375,3.228,14.6-8.428-2.376-3.228Z",
    transform: "translate(-256.297 -177.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79736",
    "data-name": "Path 79736",
    className: "cls-15",
    d: "M245.691,235.082l5.07-3.414-2.131,4.16L255.665,240l-.728.42Z",
    transform: "translate(-187.898 -177.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79737",
    "data-name": "Path 79737",
    className: "cls-62",
    d: "M275.495,249.808h-5.441l-3.984-2.25h-1.527l-10.985-6.342,1.379-.8-9.246-5.338,5.07-3.414-2.131,4.16,20.474,11.932,2.337-1.349v1.057Z",
    transform: "translate(-187.898 -177.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79738",
    "data-name": "Path 79738",
    className: "cls-33",
    d: "M372.392,267.859l16.345-9.437v12.7l-16.345,9.437Z",
    transform: "translate(-284.795 -197.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79739",
    "data-name": "Path 79739",
    className: "cls-3",
    d: "M375.434,272.3l14.914-8.611v11.048l-14.914,8.611Z",
    transform: "translate(-287.121 -201.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79740",
    "data-name": "Path 79740",
    className: "cls-63",
    d: "M375.434,301.73v7.158l14-8.083-4.053-2.34Z",
    transform: "translate(-287.121 -228.257)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72975",
    "data-name": "Group 72975",
    className: "cls-51",
    transform: "translate(88.313 70.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72974",
    "data-name": "Group 72974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72973",
    "data-name": "Group 72973",
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79741",
    "data-name": "Path 79741",
    className: "cls-65",
    d: "M384.792,300.323l1.01.78-2.732,1.85-5.117,2.736-2.518-.513v-6.942l9.722-.634,1.219.778,3.058,1.766H383.7Z",
    transform: "translate(-375.435 -297.601)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79742",
    "data-name": "Path 79742",
    className: "cls-15",
    d: "M389.434,264.219v9.992l-14,8.083v1.056l14.914-8.611V263.691Z",
    transform: "translate(-287.121 -201.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79743",
    "data-name": "Path 79743",
    className: "cls-17",
    d: "M434.95,264.219v9.992l.914.528V263.691Z",
    transform: "translate(-332.637 -201.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79744",
    "data-name": "Path 79744",
    className: "cls-28",
    d: "M355.16,288.591l4.053,2.34v2.409L355.16,291Z",
    transform: "translate(-271.616 -220.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79745",
    "data-name": "Path 79745",
    className: "cls-66",
    d: "M355.16,257.91l4.053,2.34,16.345-9.437-4.053-2.34Z",
    transform: "translate(-271.616 -190.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79746",
    "data-name": "Path 79746",
    className: "cls-4",
    d: "M279.135,248.887l18.645,10.765v-.435l-18.645-10.765Z",
    transform: "translate(-213.475 -190.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79747",
    "data-name": "Path 79747",
    className: "cls-4",
    d: "M356.395,298.658l.236.136.236-.136v-5.327l-.471-.272Z",
    transform: "translate(-272.561 -224.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79748",
    "data-name": "Path 79748",
    className: "cls-4",
    d: "M337.08,287.506l.236.136.236-.136V282.2l-.471-.294Z",
    transform: "translate(-257.789 -215.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79749",
    "data-name": "Path 79749",
    className: "cls-4",
    d: "M317.765,276.355l.236.136.235-.136v-5.284l-.471-.316Z",
    transform: "translate(-243.018 -207.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79750",
    "data-name": "Path 79750",
    className: "cls-4",
    d: "M298.45,265.2l.236.136.236-.136v-5.262l-.471-.338Z",
    transform: "translate(-228.246 -198.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79751",
    "data-name": "Path 79751",
    className: "cls-4",
    d: "M279.135,254.052l.236.136.235-.136v-5.24l-.471-.359Z",
    transform: "translate(-213.475 -190.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79752",
    "data-name": "Path 79752",
    className: "cls-67",
    d: "M433.308,280.281l-.233-.138,2.616-12.073.233.138Z",
    transform: "translate(-331.203 -205.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79753",
    "data-name": "Path 79753",
    className: "cls-15",
    d: "M434.066,280.025l.438-.217,2.616-12.073-.438.217Z",
    transform: "translate(-331.961 -204.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79754",
    "data-name": "Path 79754",
    className: "cls-15",
    d: "M430.333,321.048l1.66-.959-3.276-1.891-1.66.959Z",
    transform: "translate(-326.601 -243.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79755",
    "data-name": "Path 79755",
    className: "cls-33",
    d: "M440.984,327.917l1.66-.959v-.72l-1.66.959Z",
    transform: "translate(-337.252 -249.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79756",
    "data-name": "Path 79756",
    className: "cls-17",
    d: "M430.333,324.884l-3.276-1.891v-.72l3.276,1.891Z",
    transform: "translate(-326.601 -246.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79757",
    "data-name": "Path 79757",
    className: "cls-68",
    d: "M435.706,320.972l-2.589-1.534.02-.335,2.589,1.534Z",
    transform: "translate(-331.236 -244.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79758",
    "data-name": "Path 79758",
    className: "cls-69",
    d: "M436.017,321.858l-2.389-1.416-.005-.089,2.389,1.416Z",
    transform: "translate(-331.623 -244.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79759",
    "data-name": "Path 79759",
    className: "cls-36",
    d: "M444.122,323.576l1.116-.842.02-.226-1.116.733Z",
    transform: "translate(-339.652 -246.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79760",
    "data-name": "Path 79760",
    className: "cls-7",
    d: "M435.79,318.253l-2.589-1.534,1.116-.733,2.589,1.534Z",
    transform: "translate(-331.3 -241.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79761",
    "data-name": "Path 79761",
    className: "cls-68",
    d: "M438.321,309.677l-2.589-1.534.02-.335,2.589,1.534Z",
    transform: "translate(-333.235 -235.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79762",
    "data-name": "Path 79762",
    className: "cls-69",
    d: "M438.632,310.562l-2.389-1.416-.005-.089,2.389,1.416Z",
    transform: "translate(-333.623 -236.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79763",
    "data-name": "Path 79763",
    className: "cls-36",
    d: "M446.737,312.281l1.116-.842.02-.226-1.116.733Z",
    transform: "translate(-341.652 -238.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79764",
    "data-name": "Path 79764",
    className: "cls-7",
    d: "M438.4,306.958l-2.589-1.534,1.116-.733,2.589,1.534Z",
    transform: "translate(-333.299 -233.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79765",
    "data-name": "Path 79765",
    className: "cls-68",
    d: "M440.936,298.381l-2.589-1.534.02-.335,2.589,1.534Z",
    transform: "translate(-335.235 -226.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79766",
    "data-name": "Path 79766",
    className: "cls-69",
    d: "M441.247,299.268l-2.389-1.416-.005-.089,2.389,1.416Z",
    transform: "translate(-335.622 -227.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79767",
    "data-name": "Path 79767",
    className: "cls-36",
    d: "M449.352,300.986l1.116-.842.02-.226-1.116.733Z",
    transform: "translate(-343.652 -229.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79768",
    "data-name": "Path 79768",
    className: "cls-7",
    d: "M441.02,295.662l-2.589-1.534,1.116-.733,2.589,1.534Z",
    transform: "translate(-335.3 -224.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79769",
    "data-name": "Path 79769",
    className: "cls-68",
    d: "M443.551,287.086l-2.589-1.534.02-.335,2.589,1.534Z",
    transform: "translate(-337.235 -218.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79770",
    "data-name": "Path 79770",
    className: "cls-69",
    d: "M443.863,287.971l-2.389-1.416-.005-.089,2.389,1.416Z",
    transform: "translate(-337.622 -219.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79771",
    "data-name": "Path 79771",
    className: "cls-36",
    d: "M451.967,289.69l1.116-.842.02-.226-1.116.733Z",
    transform: "translate(-345.652 -220.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79772",
    "data-name": "Path 79772",
    className: "cls-7",
    d: "M443.635,284.367l-2.589-1.534,1.116-.733,2.589,1.534Z",
    transform: "translate(-337.3 -215.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79773",
    "data-name": "Path 79773",
    className: "cls-68",
    d: "M446.165,275.79l-2.589-1.534.02-.335,2.589,1.534Z",
    transform: "translate(-339.234 -209.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79774",
    "data-name": "Path 79774",
    className: "cls-69",
    d: "M446.477,276.676l-2.389-1.416-.005-.089,2.389,1.416Z",
    transform: "translate(-339.622 -210.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79775",
    "data-name": "Path 79775",
    className: "cls-36",
    d: "M454.582,278.4l1.116-.842.02-.226-1.116.733Z",
    transform: "translate(-347.651 -212.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79776",
    "data-name": "Path 79776",
    className: "cls-7",
    d: "M446.25,273.072l-2.589-1.534,1.116-.733,2.589,1.534Z",
    transform: "translate(-339.299 -207.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79777",
    "data-name": "Path 79777",
    className: "cls-15",
    d: "M446.179,287.2l.438-.217,2.616-12.073-.438.217Z",
    transform: "translate(-341.225 -210.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79778",
    "data-name": "Path 79778",
    className: "cls-67",
    d: "M445.421,287.46l-.233-.138,2.616-12.073.233.138Z",
    transform: "translate(-340.467 -210.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79779",
    "data-name": "Path 79779",
    className: "cls-15",
    d: "M447.321,256.842l6.64-3.834-3.276-1.891-6.641,3.834Z",
    transform: "translate(-339.593 -192.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79780",
    "data-name": "Path 79780",
    className: "cls-33",
    d: "M457.972,263.711l6.64-3.834v-.72l-6.64,3.834Z",
    transform: "translate(-350.244 -198.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79781",
    "data-name": "Path 79781",
    className: "cls-17",
    d: "M447.321,270.027l-3.276-1.891v-.72l3.276,1.891Z",
    transform: "translate(-339.593 -204.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79782",
    "data-name": "Path 79782",
    className: "cls-4",
    d: "M463.846,236.985l-6.876,3.97v-.435l6.876-3.97Z",
    transform: "translate(-349.478 -180.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79783",
    "data-name": "Path 79783",
    className: "cls-4",
    d: "M457.442,257.588l-.236.136-.235-.136v-5.046l.471-.272Z",
    transform: "translate(-349.478 -192.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79784",
    "data-name": "Path 79784",
    className: "cls-4",
    d: "M471.056,249.728l-.236.136-.235-.136v-5l.471-.316Z",
    transform: "translate(-359.89 -186.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79785",
    "data-name": "Path 79785",
    className: "cls-4",
    d: "M484.67,241.868l-.236.136-.235-.136v-4.958l.471-.36Z",
    transform: "translate(-370.301 -180.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79786",
    "data-name": "Path 79786",
    className: "cls-4",
    d: "M376.807,246.347l-20.015,11.58v-.435l20.015-11.579Z",
    transform: "translate(-272.864 -188.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79787",
    "data-name": "Path 79787",
    className: "cls-4",
    d: "M371.862,288.394l-.236.136-.235-.136v-2.671l.471-.272Z",
    transform: "translate(-284.029 -218.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79788",
    "data-name": "Path 79788",
    className: "cls-4",
    d: "M394.69,275.214l-.236.136-.235-.136v-2.641l.471-.3Z",
    transform: "translate(-301.487 -208.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79789",
    "data-name": "Path 79789",
    className: "cls-4",
    d: "M417.518,262.035l-.236.136-.235-.136v-2.612l.471-.331Z",
    transform: "translate(-318.946 -198.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79790",
    "data-name": "Path 79790",
    className: "cls-4",
    d: "M440.346,248.855l-.236.136-.235-.136v-2.583l.471-.359Z",
    transform: "translate(-336.404 -188.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79791",
    "data-name": "Path 79791",
    className: "cls-4",
    d: "M447.664,253.589l-3.479,13.771v-1.6l3.007-12.336Z",
    transform: "translate(-339.701 -193.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79792",
    "data-name": "Path 79792",
    className: "cls-4",
    d: "M444.657,310.03l-.236.136-.235-.136v-5.046l.471-.272Z",
    transform: "translate(-339.701 -233.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79793",
    "data-name": "Path 79793",
    className: "cls-4",
    d: "M451.049,283.809l-.236.136-.235-.136v-5l.471-.316Z",
    transform: "translate(-344.589 -212.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79794",
    "data-name": "Path 79794",
    className: "cls-4",
    d: "M457.442,257.588l-.236.136-.235-.136v-4.958l.471-.36Z",
    transform: "translate(-349.478 -192.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79795",
    "data-name": "Path 79795",
    className: "cls-33",
    d: "M425.852,322.51l-.484.8.05,5.454-.373.311.014-5.558.584-1.088Z",
    transform: "translate(-325.062 -246.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79796",
    "data-name": "Path 79796",
    className: "cls-33",
    d: "M425.478,337.834l2.816,1.558.265-.438-2.981-1.552Z",
    transform: "translate(-325.393 -258.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79797",
    "data-name": "Path 79797",
    className: "cls-33",
    d: "M425.478,328.986l2.816,1.558.265-.438-2.981-1.552Z",
    transform: "translate(-325.393 -251.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79798",
    "data-name": "Path 79798",
    className: "cls-33",
    d: "M425.656,345.53l2.816,1.558.265-.438-2.981-1.552Z",
    transform: "translate(-325.53 -263.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79799",
    "data-name": "Path 79799",
    className: "cls-33",
    d: "M438.231,329.29l-.484.8.05,5.454-.374.311.014-5.558.584-1.088Z",
    transform: "translate(-334.529 -251.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79800",
    "data-name": "Path 79800",
    className: "cls-70",
    d: "M354.685,326.33l-.31.179v1.028l.652-1.012Z",
    transform: "translate(-271.015 -249.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79801",
    "data-name": "Path 79801",
    className: "cls-15",
    d: "M356.138,327.162l-.31.179v1.028l.31-.179Z",
    transform: "translate(-272.127 -250.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79802",
    "data-name": "Path 79802",
    className: "cls-71",
    d: "M354.716,327.287l-.342-.2v1.028l.342.2Z",
    transform: "translate(-271.015 -250.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79803",
    "data-name": "Path 79803",
    className: "cls-19",
    d: "M348.092,369.5a.884.884,0,0,1-.45.683l-1.271.754c-.209.138-.429.055-.406-.153l0-.031.036-.345a.7.7,0,0,1,.358-.542l.92-.55.511-.307c.154-.092.31-.036.307.11Z",
    transform: "translate(-264.583 -282.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79804",
    "data-name": "Path 79804",
    className: "cls-4",
    d: "M346.842,371.47l-.856.43.036-.345a.7.7,0,0,1,.358-.542l.92-.55-.008.324a.886.886,0,0,1-.45.683",
    transform: "translate(-264.6 -283.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79805",
    "data-name": "Path 79805",
    className: "cls-41",
    d: "M320.71,133.962l-25.553,14.593-.1.141.686.427,25.108-14.87Z",
    transform: "translate(-225.649 -102.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79806",
    "data-name": "Path 79806",
    className: "cls-66",
    d: "M320.5,132.6,295.49,147.511l.446.277,25.107-14.87Z",
    transform: "translate(-225.982 -101.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79807",
    "data-name": "Path 79807",
    className: "cls-41",
    d: "M313.911,129.954l-25.553,14.593-.1.141.686.427,25.107-14.87Z",
    transform: "translate(-220.45 -99.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79808",
    "data-name": "Path 79808",
    className: "cls-66",
    d: "M313.7,128.589,288.691,143.5l.446.277,25.107-14.87Z",
    transform: "translate(-220.783 -98.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79809",
    "data-name": "Path 79809",
    className: "cls-41",
    d: "M307.112,125.945l-25.553,14.593-.1.141.686.427,25.108-14.87Z",
    transform: "translate(-215.249 -96.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79810",
    "data-name": "Path 79810",
    className: "cls-66",
    d: "M306.905,124.58l-25.013,14.914.446.277,25.107-14.87Z",
    transform: "translate(-215.583 -95.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79811",
    "data-name": "Path 79811",
    className: "cls-41",
    d: "M300.313,121.937,274.76,136.53l-.1.141.686.427,25.108-14.87Z",
    transform: "translate(-210.05 -93.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79812",
    "data-name": "Path 79812",
    className: "cls-66",
    d: "M300.107,120.572l-25.013,14.914.446.277,25.108-14.87Z",
    transform: "translate(-210.384 -92.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79813",
    "data-name": "Path 79813",
    className: "cls-41",
    d: "M293.515,117.928l-25.553,14.593-.1.141.686.427,25.107-14.87Z",
    transform: "translate(-204.851 -90.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79814",
    "data-name": "Path 79814",
    className: "cls-66",
    d: "M293.308,116.563l-25.013,14.914.446.277,25.108-14.87Z",
    transform: "translate(-205.184 -89.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79815",
    "data-name": "Path 79815",
    className: "cls-41",
    d: "M286.716,113.92l-25.553,14.593-.1.141.686.427,25.107-14.87Z",
    transform: "translate(-199.651 -87.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79816",
    "data-name": "Path 79816",
    className: "cls-66",
    d: "M286.509,112.555,261.5,127.469l.446.277,25.108-14.87Z",
    transform: "translate(-199.985 -86.079)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72978",
    "data-name": "Group 72978",
    className: "cls-51",
    transform: "translate(45.543 25.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72977",
    "data-name": "Group 72977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72976",
    "data-name": "Group 72976",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79817",
    "data-name": "Path 79817",
    className: "cls-73",
    d: "M228.678,112.126l-3.321-1.881-5.9-2.014-12.672,7.2-6.314,2.02-6.863,4.394,9.378,5.311,4.517-2.81Z",
    transform: "translate(-193.612 -108.231)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79818",
    "data-name": "Path 79818",
    className: "cls-29",
    d: "M82.685,258.113l-.092.06-.211-.146-.041-.266.093-.066a.1.1,0,0,1,.056-.012c.151.026.189.277.194.431",
    transform: "translate(-62.972 -197.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79819",
    "data-name": "Path 79819",
    className: "cls-29",
    d: "M82.566,257.806a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-63.144 -197.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79820",
    "data-name": "Path 79820",
    className: "cls-32",
    d: "M82.146,258.077a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-62.823 -197.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79821",
    "data-name": "Path 79821",
    className: "cls-29",
    d: "M85.3,267.263l-.091.06L85,267.177l-.041-.266.093-.066a.1.1,0,0,1,.056-.012c.151.026.189.277.194.431",
    transform: "translate(-64.972 -204.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79822",
    "data-name": "Path 79822",
    className: "cls-29",
    d: "M85.182,266.956a.379.379,0,0,0,.171.3c.095.055.172.011.172-.1a.378.378,0,0,0-.172-.3c-.095-.055-.171-.011-.171.1",
    transform: "translate(-65.145 -204.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79823",
    "data-name": "Path 79823",
    className: "cls-32",
    d: "M84.762,267.227a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-64.824 -204.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79824",
    "data-name": "Path 79824",
    className: "cls-29",
    d: "M86.957,262.552l-.091.06-.211-.146-.041-.266.093-.066a.1.1,0,0,1,.056-.012c.151.026.189.277.194.431",
    transform: "translate(-66.239 -200.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79825",
    "data-name": "Path 79825",
    className: "cls-29",
    d: "M86.838,262.245a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-66.411 -200.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79826",
    "data-name": "Path 79826",
    className: "cls-32",
    d: "M86.418,262.517a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-66.09 -200.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79827",
    "data-name": "Path 79827",
    className: "cls-29",
    d: "M80.781,263.27l-.092.06-.211-.146-.041-.266.093-.066a.1.1,0,0,1,.056-.012c.151.026.189.277.194.431",
    transform: "translate(-61.516 -201.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79828",
    "data-name": "Path 79828",
    className: "cls-29",
    d: "M80.662,262.963a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-61.688 -201.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79829",
    "data-name": "Path 79829",
    className: "cls-32",
    d: "M80.243,263.234a.379.379,0,0,0,.172.3c.095.055.171.011.171-.1a.378.378,0,0,0-.171-.3c-.095-.055-.172-.011-.172.1",
    transform: "translate(-61.368 -201.221)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72985",
    "data-name": "Group 72985",
    transform: "translate(88.313 62.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72984",
    "data-name": "Group 72984",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79830",
    "data-name": "Path 79830",
    className: "cls-75",
    d: "M347.269,280.522l4.391-3.879,1.594-3.16-7.071,3.75Z",
    transform: "translate(-353.065 -271.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79831",
    "data-name": "Path 79831",
    className: "cls-76",
    d: "M357.424,275.812l7.071-3.75-10.941-6.853-7.071,3.75Z",
    transform: "translate(-353.292 -264.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79832",
    "data-name": "Path 79832",
    className: "cls-77",
    d: "M358.468,280.724l-1.045,2.127L346.482,276l1.891-1.585Z",
    transform: "translate(-353.292 -271.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79833",
    "data-name": "Path 79833",
    className: "cls-16",
    d: "M392.7,300.04l7.071-3.75.07-1.946-7.071,3.75Z",
    transform: "translate(-388.637 -287.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79834",
    "data-name": "Path 79834",
    className: "cls-18",
    d: "M357.126,289.951,346.184,283.1l.07-1.946L357.2,288Z",
    transform: "translate(-353.065 -277.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79835",
    "data-name": "Path 79835",
    className: "cls-75",
    d: "M387.177,308.163l5.732-3.04,2.638-2.506-7.071,3.75Z",
    transform: "translate(-384.415 -293.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79836",
    "data-name": "Path 79836",
    className: "cls-76",
    d: "M362.716,256.566l7.774,4.869,3.164-1.678-7.774-4.869Z",
    transform: "translate(-365.707 -256.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79837",
    "data-name": "Path 79837",
    className: "cls-18",
    d: "M354.519,264.936l10.1,6.311-.394-4.356-7.774-4.869Z",
    transform: "translate(-359.439 -262.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79838",
    "data-name": "Path 79838",
    className: "cls-78",
    d: "M395.764,277.266l.394,4.356,4.463-2.367-1.693-3.667Z",
    transform: "translate(-390.982 -272.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79839",
    "data-name": "Path 79839",
    className: "cls-76",
    d: "M396.1,289.717l4.216-2.066.614,1.425-5.108,2.546.271-.84Z",
    transform: "translate(-391.026 -282.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79840",
    "data-name": "Path 79840",
    className: "cls-79",
    d: "M387.032,284.7a.407.407,0,0,1-.44.074,2.448,2.448,0,0,1-.372-.231c-.072-.089.109-.1.083-.255a1.488,1.488,0,0,1,.446-1.312c.108-.083.005-.292.1-.284a2.569,2.569,0,0,1,.326.205.687.687,0,0,1,.3.491,1.489,1.489,0,0,1-.446,1.312",
    transform: "translate(-383.67 -278.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79841",
    "data-name": "Path 79841",
    className: "cls-79",
    d: "M378.642,279.456a.407.407,0,0,1-.44.074,2.463,2.463,0,0,1-.372-.231c-.072-.089.109-.1.083-.255a1.489,1.489,0,0,1,.446-1.312c.108-.083.006-.292.1-.284a2.572,2.572,0,0,1,.326.205.686.686,0,0,1,.3.491,1.488,1.488,0,0,1-.446,1.312",
    transform: "translate(-377.254 -274.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79842",
    "data-name": "Path 79842",
    className: "cls-79",
    d: "M370.252,274.213a.407.407,0,0,1-.44.074,2.454,2.454,0,0,1-.372-.231c-.072-.089.109-.1.083-.255a1.488,1.488,0,0,1,.446-1.312c.108-.083.005-.293.1-.284a2.58,2.58,0,0,1,.326.205.686.686,0,0,1,.3.491,1.49,1.49,0,0,1-.446,1.312",
    transform: "translate(-370.837 -270.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79843",
    "data-name": "Path 79843",
    className: "cls-79",
    d: "M361.862,268.97a.407.407,0,0,1-.44.075,2.447,2.447,0,0,1-.372-.231c-.072-.089.109-.1.083-.255a1.489,1.489,0,0,1,.446-1.311c.108-.083.005-.293.1-.284a2.546,2.546,0,0,1,.326.205.686.686,0,0,1,.3.491,1.489,1.489,0,0,1-.446,1.312",
    transform: "translate(-364.421 -266.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79844",
    "data-name": "Path 79844",
    className: "cls-75",
    d: "M385.879,284.372c-.324.248-.651.064-.729-.412a1.489,1.489,0,0,1,.446-1.312c.324-.248.651-.064.729.412a1.489,1.489,0,0,1-.445,1.312",
    transform: "translate(-382.851 -278.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79845",
    "data-name": "Path 79845",
    className: "cls-75",
    d: "M377.443,279.1c-.325.249-.651.064-.729-.412a1.489,1.489,0,0,1,.446-1.312c.324-.248.651-.064.729.413a1.489,1.489,0,0,1-.446,1.311",
    transform: "translate(-376.4 -274.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79846",
    "data-name": "Path 79846",
    className: "cls-75",
    d: "M369.007,273.831c-.325.248-.651.064-.729-.412a1.489,1.489,0,0,1,.446-1.312c.324-.248.651-.064.729.412a1.49,1.49,0,0,1-.446,1.312",
    transform: "translate(-369.948 -270.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79847",
    "data-name": "Path 79847",
    className: "cls-75",
    d: "M360.572,268.561c-.324.248-.651.064-.729-.412a1.488,1.488,0,0,1,.445-1.312c.324-.248.651-.064.729.412a1.489,1.489,0,0,1-.445,1.312",
    transform: "translate(-363.497 -266.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79848",
    "data-name": "Path 79848",
    className: "cls-19",
    d: "M355.827,298.074l-8.558-5.36-1.085-3.289,10.941,6.853Z",
    transform: "translate(-353.064 -283.372)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72983",
    "data-name": "Group 72983",
    className: "cls-51",
    transform: "translate(4.81 6.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72982",
    "data-name": "Group 72982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72981",
    "data-name": "Group 72981",
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79849",
    "data-name": "Path 79849",
    className: "cls-81",
    d: "M400.246,291.172l-1.694,1.328-2.672,4.717.481.852.323-.172,3.136-1.77,1-3.387-.4-.014-1.08,3.019-1.286.025Z",
    transform: "translate(-395.88 -291.172)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79850",
    "data-name": "Path 79850",
    className: "cls-78",
    d: "M396.306,274.024h0a.2.2,0,0,0-.2-.007l-2.393,1.268c-.135.072-.289.154-.159.235h0a.2.2,0,0,0,.2.007l2.393-1.268c.135-.072.288-.154.159-.235",
    transform: "translate(-389.255 -271.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79851",
    "data-name": "Path 79851",
    className: "cls-78",
    d: "M386.907,268.137h0a.2.2,0,0,0-.2-.007l-2.393,1.268c-.135.072-.289.153-.159.235a.2.2,0,0,0,.2.007l2.393-1.268c.135-.072.288-.153.159-.235",
    transform: "translate(-382.068 -267.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79852",
    "data-name": "Path 79852",
    className: "cls-78",
    d: "M377.507,262.249h0a.2.2,0,0,0-.2-.007l-2.393,1.268c-.135.071-.289.153-.159.235a.2.2,0,0,0,.2.007l2.393-1.268c.135-.072.288-.153.159-.235",
    transform: "translate(-374.879 -262.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79853",
    "data-name": "Path 79853",
    className: "cls-78",
    d: "M368.107,256.362h0a.2.2,0,0,0-.2-.007l-2.393,1.268c-.135.072-.289.153-.159.235a.2.2,0,0,0,.2.007l2.393-1.268c.135-.072.288-.153.159-.235",
    transform: "translate(-367.69 -258.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79854",
    "data-name": "Path 79854",
    className: "cls-4",
    d: "M412.454,296.731,410.979,301l.629.424,1.387-4.575Z",
    transform: "translate(-402.618 -288.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79855",
    "data-name": "Path 79855",
    className: "cls-4",
    d: "M400.262,311.733l2.151-3.329-.67-.43,0,0a1.012,1.012,0,0,0-.995.073,3.092,3.092,0,0,0-1.5,2.366.981.981,0,0,0,.352.89h0l.021.013.017.011Z",
    transform: "translate(-393.645 -297.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79856",
    "data-name": "Path 79856",
    className: "cls-36",
    d: "M402.038,308.812,401,308.15a1.656,1.656,0,0,0-.253.108,3.093,3.093,0,0,0-1.5,2.366,1.424,1.424,0,0,0,.046.434l.716.458a1.717,1.717,0,0,0,.383-.149,2.534,2.534,0,0,0,.427-.29l1.13-1.749a2.524,2.524,0,0,0,.09-.517",
    transform: "translate(-393.644 -297.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79857",
    "data-name": "Path 79857",
    className: "cls-82",
    d: "M404.84,310.628a3.093,3.093,0,0,1-1.5,2.366c-.8.421-1.415.044-1.383-.842a3.092,3.092,0,0,1,1.5-2.366c.8-.421,1.415-.044,1.383.842",
    transform: "translate(-395.718 -298.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79858",
    "data-name": "Path 79858",
    className: "cls-83",
    d: "M404.965,310.882a2.973,2.973,0,0,1-1.441,2.275c-.765.4-1.361.043-1.33-.809a2.973,2.973,0,0,1,1.441-2.275c.765-.4,1.361-.043,1.33.809",
    transform: "translate(-395.899 -299.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79859",
    "data-name": "Path 79859",
    className: "cls-4",
    d: "M406.115,313.123a1.983,1.983,0,0,1-.961,1.517c-.51.27-.908.028-.887-.54a1.983,1.983,0,0,1,.961-1.517c.51-.27.907-.028.887.54",
    transform: "translate(-397.484 -300.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79860",
    "data-name": "Path 79860",
    className: "cls-83",
    d: "M407.093,315.094a1.051,1.051,0,0,1-.509.8c-.271.143-.481.015-.47-.286a1.051,1.051,0,0,1,.509-.8c.27-.143.481-.015.47.286",
    transform: "translate(-398.897 -302.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79861",
    "data-name": "Path 79861",
    className: "cls-4",
    d: "M411.689,292.747l1.352-2.092-.421-.27v0a.637.637,0,0,0-.625.046,1.944,1.944,0,0,0-.942,1.487.616.616,0,0,0,.222.559h0l.013.008.011.007Z",
    transform: "translate(-402.673 -284.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79862",
    "data-name": "Path 79862",
    className: "cls-36",
    d: "M412.806,290.911l-.653-.416a1.02,1.02,0,0,0-.159.068,1.943,1.943,0,0,0-.942,1.487.9.9,0,0,0,.029.273l.45.288a1.093,1.093,0,0,0,.241-.094,1.6,1.6,0,0,0,.268-.183l.71-1.1a1.582,1.582,0,0,0,.056-.325",
    transform: "translate(-402.673 -284.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79863",
    "data-name": "Path 79863",
    className: "cls-82",
    d: "M414.568,292.054a1.943,1.943,0,0,1-.942,1.487c-.5.265-.889.028-.869-.529a1.943,1.943,0,0,1,.942-1.487c.5-.265.889-.028.869.529",
    transform: "translate(-403.977 -284.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79864",
    "data-name": "Path 79864",
    className: "cls-83",
    d: "M414.647,292.212a1.868,1.868,0,0,1-.906,1.43c-.481.254-.855.027-.836-.509a1.867,1.867,0,0,1,.905-1.429c.481-.255.855-.027.836.508",
    transform: "translate(-404.091 -285.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79865",
    "data-name": "Path 79865",
    className: "cls-4",
    d: "M415.368,293.621a1.246,1.246,0,0,1-.6.953c-.321.17-.57.018-.557-.339a1.245,1.245,0,0,1,.6-.953c.321-.17.57-.018.557.339",
    transform: "translate(-405.086 -286.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79866",
    "data-name": "Path 79866",
    className: "cls-83",
    d: "M416.107,294.676a.677.677,0,0,1-.328.518c-.175.092-.31.01-.3-.184a.677.677,0,0,1,.328-.518c.174-.092.31-.01.3.184",
    transform: "translate(-406.057 -287.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79867",
    "data-name": "Path 79867",
    className: "cls-4",
    d: "M401.718,293.742l-.888,3.049.351.063.993-3.271Z",
    transform: "translate(-394.856 -286.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79868",
    "data-name": "Path 79868",
    className: "cls-4",
    d: "M401.083,291.029l.906-1.4-.282-.181h0a.426.426,0,0,0-.419.031,1.3,1.3,0,0,0-.632,1,.413.413,0,0,0,.148.375h0l.009.005.007,0Z",
    transform: "translate(-394.722 -283.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79869",
    "data-name": "Path 79869",
    className: "cls-36",
    d: "M401.832,289.8l-.438-.279a.68.68,0,0,0-.107.046,1.3,1.3,0,0,0-.632,1,.6.6,0,0,0,.019.183l.3.193a.743.743,0,0,0,.162-.063,1.074,1.074,0,0,0,.18-.123l.476-.737a1.06,1.06,0,0,0,.038-.218",
    transform: "translate(-394.722 -283.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79870",
    "data-name": "Path 79870",
    className: "cls-82",
    d: "M403.012,290.564a1.3,1.3,0,0,1-.632,1c-.335.178-.6.019-.583-.354a1.3,1.3,0,0,1,.631-1c.336-.177.6-.019.583.355",
    transform: "translate(-395.596 -283.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79871",
    "data-name": "Path 79871",
    className: "cls-83",
    d: "M403.065,290.669a1.253,1.253,0,0,1-.607.959c-.322.171-.573.018-.56-.341a1.252,1.252,0,0,1,.607-.959c.323-.171.573-.018.561.341",
    transform: "translate(-395.672 -284.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79872",
    "data-name": "Path 79872",
    className: "cls-4",
    d: "M403.549,291.615a.836.836,0,0,1-.4.639c-.215.114-.382.012-.374-.227a.835.835,0,0,1,.4-.639c.215-.114.383-.012.374.227",
    transform: "translate(-396.34 -284.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79873",
    "data-name": "Path 79873",
    className: "cls-4",
    d: "M396.954,304.783l.906-1.4-.282-.181h0a.426.426,0,0,0-.419.031,1.3,1.3,0,0,0-.632,1,.412.412,0,0,0,.148.375h0l.009.005.007,0Z",
    transform: "translate(-391.564 -293.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79874",
    "data-name": "Path 79874",
    className: "cls-36",
    d: "M397.7,303.552l-.438-.279a.7.7,0,0,0-.107.045,1.3,1.3,0,0,0-.632,1,.6.6,0,0,0,.019.183l.3.193a.731.731,0,0,0,.162-.063,1.071,1.071,0,0,0,.18-.123l.476-.737a1.056,1.056,0,0,0,.038-.218",
    transform: "translate(-391.564 -293.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79875",
    "data-name": "Path 79875",
    className: "cls-82",
    d: "M398.884,304.318a1.3,1.3,0,0,1-.632,1c-.335.177-.6.019-.583-.355a1.3,1.3,0,0,1,.632-1c.335-.177.6-.019.583.355",
    transform: "translate(-392.439 -294.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79876",
    "data-name": "Path 79876",
    className: "cls-83",
    d: "M398.936,304.424a1.253,1.253,0,0,1-.607.959c-.322.171-.573.018-.56-.341a1.252,1.252,0,0,1,.607-.959c.323-.171.573-.018.561.341",
    transform: "translate(-392.514 -294.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79877",
    "data-name": "Path 79877",
    className: "cls-4",
    d: "M399.42,305.37a.836.836,0,0,1-.405.639c-.215.114-.382.012-.374-.227a.836.836,0,0,1,.405-.639c.215-.114.382-.012.374.227",
    transform: "translate(-393.182 -295.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79878",
    "data-name": "Path 79878",
    className: "cls-36",
    d: "M403.853,293.3l-2.631,4.608.628.424,2.544-4.918Z",
    transform: "translate(-395.156 -286.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79879",
    "data-name": "Path 79879",
    className: "cls-84",
    d: "M382.208,299.851l-.354.716a.508.508,0,0,1-.724.2l-.92-.576a.611.611,0,0,1-.223-.789l.355-.716a.507.507,0,0,1,.724-.205l.92.576a.611.611,0,0,1,.223.788",
    transform: "translate(-378.867 -290.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79880",
    "data-name": "Path 79880",
    className: "cls-84",
    d: "M372.524,293.785l-.354.716a.508.508,0,0,1-.724.2l-.92-.576a.611.611,0,0,1-.223-.788l.355-.716a.508.508,0,0,1,.724-.205l.92.576a.611.611,0,0,1,.223.788",
    transform: "translate(-371.46 -285.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79881",
    "data-name": "Path 79881",
    className: "cls-84",
    d: "M362.84,287.719l-.354.716a.508.508,0,0,1-.724.2l-.92-.576a.611.611,0,0,1-.223-.789l.355-.716a.508.508,0,0,1,.724-.205l.92.576a.611.611,0,0,1,.223.789",
    transform: "translate(-364.054 -280.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79882",
    "data-name": "Path 79882",
    className: "cls-84",
    d: "M353.154,281.653l-.355.716a.507.507,0,0,1-.724.2l-.92-.576a.611.611,0,0,1-.223-.788l.354-.716a.508.508,0,0,1,.724-.205l.92.576a.611.611,0,0,1,.223.789",
    transform: "translate(-356.647 -276.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79883",
    "data-name": "Path 79883",
    className: "cls-85",
    d: "M352.95,298.939a.805.805,0,0,0,.01.155.061.061,0,0,0,0,.01c.053.295.258.409.462.252a.061.061,0,0,0,.016-.015.358.358,0,0,0,.072-.073.828.828,0,0,0,.153-.285,1.154,1.154,0,0,0,.044-.182.928.928,0,0,0,0-.277c-.048-.3-.258-.421-.464-.264a.591.591,0,0,0-.13.146.842.842,0,0,0-.1.206,1.04,1.04,0,0,0-.061.328",
    transform: "translate(-358.238 -290.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79884",
    "data-name": "Path 79884",
    className: "cls-86",
    d: "M343.283,285.709l-.014.385a.856.856,0,0,0,.4.757l1.848,1.161.039.027a3.862,3.862,0,0,0,.355.189.607.607,0,0,0,.115.046.013.013,0,0,0,.008,0,.361.361,0,0,0,.072-.072.836.836,0,0,0,.153-.286,1.155,1.155,0,0,0,.044-.182.643.643,0,0,0-.11-.091l-.019-.013a.158.158,0,0,0-.023-.015l-.443-.277-1.606-1.008a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.362.362,0,0,0,.2-.248.538.538,0,0,0,.014-.114.249.249,0,0,0-.291-.286l-.052.008a.347.347,0,0,0-.056.016.475.475,0,0,0-.062.021,3.2,3.2,0,0,0-.408.189l-1.927,1.023a.861.861,0,0,0-.456.728",
    transform: "translate(-350.835 -279.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79885",
    "data-name": "Path 79885",
    className: "cls-77",
    d: "M345.8,287.231l0,.115a.62.62,0,0,0,.294.636l1.449.873.31.187a3.041,3.041,0,0,0,.344.184,1.157,1.157,0,0,0,.044-.182.643.643,0,0,0-.11-.091l-.019-.013a.157.157,0,0,0-.023-.015l-.443-.277-1.606-1.008a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.183-.29L348.2,285.7l.024-.011.022-.013a.362.362,0,0,0,.2-.248.74.74,0,0,0-.092.03,3.108,3.108,0,0,0-.388.17l-1.831.931a.7.7,0,0,0-.341.667",
    transform: "translate(-352.77 -280.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79886",
    "data-name": "Path 79886",
    className: "cls-77",
    d: "M343.283,285.711l-.014.385a.856.856,0,0,0,.4.757l1.848,1.161.039.027a3.847,3.847,0,0,0,.355.189.6.6,0,0,0,.115.046.013.013,0,0,0,.008,0,.361.361,0,0,0,.072-.072,2.5,2.5,0,0,1-.326-.182l-.236-.147-1.612-1.014a.854.854,0,0,1-.4-.757l.014-.385a.859.859,0,0,1,.454-.728l1.927-1.023a3.442,3.442,0,0,1,.409-.189.773.773,0,0,1,.076-.023.274.274,0,0,0-.169-.032l-.052.008a.347.347,0,0,0-.056.016.471.471,0,0,0-.062.021,3.2,3.2,0,0,0-.408.189l-1.927,1.023a.862.862,0,0,0-.456.728",
    transform: "translate(-350.835 -279.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79887",
    "data-name": "Path 79887",
    className: "cls-85",
    d: "M362.605,304.958a.812.812,0,0,0,.01.155s0,.008,0,.01c.053.295.259.409.462.252a.06.06,0,0,0,.016-.015.356.356,0,0,0,.072-.073.833.833,0,0,0,.153-.285,1.209,1.209,0,0,0,.044-.183.917.917,0,0,0,0-.277c-.048-.3-.258-.421-.463-.264a.584.584,0,0,0-.13.146.843.843,0,0,0-.1.206,1.036,1.036,0,0,0-.061.328",
    transform: "translate(-365.623 -294.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79888",
    "data-name": "Path 79888",
    className: "cls-86",
    d: "M352.938,291.728l-.014.385a.856.856,0,0,0,.4.757l1.848,1.161.039.027a3.818,3.818,0,0,0,.355.189.616.616,0,0,0,.115.046l.008,0a.357.357,0,0,0,.072-.073.828.828,0,0,0,.153-.285,1.146,1.146,0,0,0,.044-.183.653.653,0,0,0-.11-.091l-.019-.012a.141.141,0,0,0-.023-.015l-.443-.277-1.606-1.008a.352.352,0,0,1-.161-.3l.008-.206a.346.346,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.362.362,0,0,0,.2-.248.556.556,0,0,0,.014-.114.249.249,0,0,0-.291-.286c-.016,0-.034,0-.052.008a.344.344,0,0,0-.056.016.473.473,0,0,0-.062.021,3.186,3.186,0,0,0-.408.189L353.394,291a.862.862,0,0,0-.456.728",
    transform: "translate(-358.219 -283.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79889",
    "data-name": "Path 79889",
    className: "cls-77",
    d: "M355.459,293.25l0,.115a.62.62,0,0,0,.294.636l1.449.873.31.187a3.065,3.065,0,0,0,.344.185,1.167,1.167,0,0,0,.044-.183.645.645,0,0,0-.11-.091l-.019-.012a.146.146,0,0,0-.023-.015l-.443-.277-1.606-1.008a.352.352,0,0,1-.161-.3l.008-.206a.345.345,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.361.361,0,0,0,.2-.248.777.777,0,0,0-.092.03,3.108,3.108,0,0,0-.388.17l-1.831.931a.7.7,0,0,0-.341.667",
    transform: "translate(-360.154 -284.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79890",
    "data-name": "Path 79890",
    className: "cls-77",
    d: "M352.938,291.73l-.014.385a.856.856,0,0,0,.4.757l1.848,1.161.039.027a3.811,3.811,0,0,0,.355.189.616.616,0,0,0,.115.046l.008,0a.356.356,0,0,0,.072-.073,2.472,2.472,0,0,1-.326-.182l-.236-.147-1.612-1.014a.854.854,0,0,1-.4-.756l.014-.385a.859.859,0,0,1,.454-.728l1.927-1.023a3.482,3.482,0,0,1,.409-.189c.028-.011.052-.016.076-.023a.275.275,0,0,0-.169-.032c-.016,0-.034,0-.052.008a.342.342,0,0,0-.056.016.464.464,0,0,0-.062.021,3.182,3.182,0,0,0-.408.189L353.394,291a.862.862,0,0,0-.456.728",
    transform: "translate(-358.219 -283.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79891",
    "data-name": "Path 79891",
    className: "cls-85",
    d: "M372.26,310.977a.788.788,0,0,0,.01.155s0,.008,0,.01c.053.295.259.409.462.252a.06.06,0,0,0,.016-.015.356.356,0,0,0,.072-.073.835.835,0,0,0,.153-.285,1.221,1.221,0,0,0,.044-.182.928.928,0,0,0,0-.277c-.048-.3-.258-.421-.463-.264a.588.588,0,0,0-.13.146.842.842,0,0,0-.1.206,1.033,1.033,0,0,0-.061.328",
    transform: "translate(-373.007 -299.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79892",
    "data-name": "Path 79892",
    className: "cls-86",
    d: "M362.593,297.747l-.014.385a.856.856,0,0,0,.4.757l1.848,1.161.039.027a3.785,3.785,0,0,0,.355.189.6.6,0,0,0,.115.046.012.012,0,0,0,.008,0,.357.357,0,0,0,.072-.072.832.832,0,0,0,.153-.286,1.159,1.159,0,0,0,.044-.182.642.642,0,0,0-.109-.091l-.019-.013a.144.144,0,0,0-.023-.015l-.443-.277-1.606-1.008a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.361.361,0,0,0,.2-.248.54.54,0,0,0,.014-.114.249.249,0,0,0-.291-.285c-.016,0-.034,0-.052.008a.334.334,0,0,0-.056.016.454.454,0,0,0-.062.021,3.2,3.2,0,0,0-.409.189l-1.927,1.023a.862.862,0,0,0-.455.728",
    transform: "translate(-365.603 -288.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79893",
    "data-name": "Path 79893",
    className: "cls-77",
    d: "M365.115,299.268l0,.115a.62.62,0,0,0,.294.636l1.449.873.31.187a3.056,3.056,0,0,0,.344.185,1.194,1.194,0,0,0,.044-.183.632.632,0,0,0-.109-.091l-.019-.012a.143.143,0,0,0-.023-.015l-.443-.277-1.606-1.008a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.182-.29l2.137-1.136.024-.011.022-.013a.362.362,0,0,0,.2-.248.7.7,0,0,0-.092.03,3.052,3.052,0,0,0-.388.17l-1.83.932a.7.7,0,0,0-.341.666",
    transform: "translate(-367.538 -289.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79894",
    "data-name": "Path 79894",
    className: "cls-77",
    d: "M362.593,297.748l-.014.385a.855.855,0,0,0,.4.757l1.848,1.161.039.027a3.778,3.778,0,0,0,.355.189.6.6,0,0,0,.115.046.013.013,0,0,0,.008,0,.355.355,0,0,0,.072-.072,2.483,2.483,0,0,1-.326-.182l-.236-.147-1.612-1.014a.854.854,0,0,1-.4-.757l.014-.385a.86.86,0,0,1,.454-.728l1.927-1.023a3.5,3.5,0,0,1,.409-.189.786.786,0,0,1,.076-.023.273.273,0,0,0-.169-.032.5.5,0,0,0-.052.008.339.339,0,0,0-.056.016.459.459,0,0,0-.062.021,3.2,3.2,0,0,0-.409.189l-1.927,1.023a.862.862,0,0,0-.455.728",
    transform: "translate(-365.603 -288.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79895",
    "data-name": "Path 79895",
    className: "cls-4",
    d: "M381.915,316.995a.79.79,0,0,0,.01.155.065.065,0,0,0,0,.01c.053.295.258.409.462.252a.065.065,0,0,0,.016-.015.356.356,0,0,0,.072-.073.827.827,0,0,0,.153-.285,1.165,1.165,0,0,0,.044-.183.924.924,0,0,0,0-.277c-.048-.3-.258-.421-.463-.264a.589.589,0,0,0-.13.146.851.851,0,0,0-.1.206,1.04,1.04,0,0,0-.061.328",
    transform: "translate(-380.391 -303.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79896",
    "data-name": "Path 79896",
    className: "cls-86",
    d: "M372.249,303.765l-.014.385a.855.855,0,0,0,.4.757l1.848,1.161.039.027a3.822,3.822,0,0,0,.355.189.609.609,0,0,0,.115.046l.008,0a.357.357,0,0,0,.072-.073.829.829,0,0,0,.153-.285,1.168,1.168,0,0,0,.044-.183.666.666,0,0,0-.11-.091l-.019-.012a.144.144,0,0,0-.023-.015l-.443-.277-1.606-1.008a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.362.362,0,0,0,.2-.248.54.54,0,0,0,.014-.114.249.249,0,0,0-.291-.286.509.509,0,0,0-.052.008.317.317,0,0,0-.056.016.471.471,0,0,0-.062.021,3.176,3.176,0,0,0-.408.189l-1.927,1.023a.862.862,0,0,0-.456.728",
    transform: "translate(-372.987 -292.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79897",
    "data-name": "Path 79897",
    className: "cls-77",
    d: "M374.77,305.287l0,.115a.62.62,0,0,0,.294.636l1.449.873.31.187a3.09,3.09,0,0,0,.344.185,1.138,1.138,0,0,0,.044-.183.632.632,0,0,0-.109-.091l-.019-.013a.16.16,0,0,0-.023-.015l-.443-.277L375,305.7a.351.351,0,0,1-.161-.3l.007-.206a.346.346,0,0,1,.183-.29l2.137-1.136.024-.011.022-.013a.362.362,0,0,0,.2-.248.776.776,0,0,0-.092.03,3.107,3.107,0,0,0-.388.17l-1.831.932a.7.7,0,0,0-.341.666",
    transform: "translate(-374.922 -294.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79898",
    "data-name": "Path 79898",
    className: "cls-77",
    d: "M372.249,303.767l-.014.385a.855.855,0,0,0,.4.757l1.848,1.161.039.027a3.822,3.822,0,0,0,.355.189.611.611,0,0,0,.115.046l.008,0a.357.357,0,0,0,.072-.073,2.471,2.471,0,0,1-.326-.182l-.236-.147-1.612-1.014a.853.853,0,0,1-.4-.756l.014-.386a.859.859,0,0,1,.454-.728l1.927-1.023a3.459,3.459,0,0,1,.409-.189c.028-.011.052-.016.076-.023a.274.274,0,0,0-.169-.032c-.016,0-.034,0-.052.008a.325.325,0,0,0-.056.016.476.476,0,0,0-.062.021,3.184,3.184,0,0,0-.408.189l-1.927,1.023a.862.862,0,0,0-.456.728",
    transform: "translate(-372.987 -292.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79899",
    "data-name": "Path 79899",
    className: "cls-16",
    d: "M391.181,271.562a1.659,1.659,0,0,1,1.5.062c.409.257.4.645-.02.868a1.659,1.659,0,0,1-1.5-.062c-.409-.257-.4-.645.02-.868",
    transform: "translate(-387.231 -269.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79900",
    "data-name": "Path 79900",
    className: "cls-16",
    d: "M387.483,273.946a.33.33,0,0,1,.3.012c.082.051.08.129,0,.173a.331.331,0,0,1-.3-.012c-.081-.051-.08-.129,0-.173",
    transform: "translate(-384.6 -271.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79901",
    "data-name": "Path 79901",
    className: "cls-16",
    d: "M401.678,273.274a.33.33,0,0,1,.3.012c.081.051.08.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-395.456 -270.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79902",
    "data-name": "Path 79902",
    className: "cls-16",
    d: "M395.669,269.456a.33.33,0,0,1,.3.012c.081.051.08.129,0,.173a.331.331,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-390.861 -268.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79903",
    "data-name": "Path 79903",
    className: "cls-16",
    d: "M393.311,277.837a.33.33,0,0,1,.3.012c.081.051.08.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.079-.129,0-.173",
    transform: "translate(-389.057 -274.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79904",
    "data-name": "Path 79904",
    className: "cls-16",
    d: "M381.594,265.644a1.659,1.659,0,0,1,1.5.062c.409.257.4.645-.02.868a1.659,1.659,0,0,1-1.5-.061c-.409-.257-.4-.646.02-.868",
    transform: "translate(-379.9 -265.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79905",
    "data-name": "Path 79905",
    className: "cls-16",
    d: "M377.9,268.028a.33.33,0,0,1,.3.012c.081.051.079.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-377.269 -266.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79906",
    "data-name": "Path 79906",
    className: "cls-16",
    d: "M392.092,267.356a.331.331,0,0,1,.3.012c.081.051.079.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.079-.129,0-.173",
    transform: "translate(-388.125 -266.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79907",
    "data-name": "Path 79907",
    className: "cls-16",
    d: "M386.083,263.538a.33.33,0,0,1,.3.012c.081.051.079.128,0,.173a.331.331,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-383.529 -263.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79908",
    "data-name": "Path 79908",
    className: "cls-16",
    d: "M383.726,271.919a.331.331,0,0,1,.3.012c.081.051.079.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.079-.128,0-.173",
    transform: "translate(-381.727 -269.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79909",
    "data-name": "Path 79909",
    className: "cls-16",
    d: "M372.01,259.725a1.659,1.659,0,0,1,1.5.062c.409.257.4.645-.02.868a1.659,1.659,0,0,1-1.5-.062c-.409-.257-.4-.645.02-.868",
    transform: "translate(-372.57 -260.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79910",
    "data-name": "Path 79910",
    className: "cls-16",
    d: "M368.312,262.109a.33.33,0,0,1,.3.012c.081.051.079.129,0,.173a.329.329,0,0,1-.3-.012c-.081-.051-.079-.128,0-.173",
    transform: "translate(-369.939 -262.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79911",
    "data-name": "Path 79911",
    className: "cls-16",
    d: "M382.506,261.438a.33.33,0,0,1,.3.012c.081.051.079.128,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-380.794 -261.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79912",
    "data-name": "Path 79912",
    className: "cls-16",
    d: "M376.5,257.619a.33.33,0,0,1,.3.012c.081.051.08.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.079-.128,0-.173",
    transform: "translate(-376.199 -259.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79913",
    "data-name": "Path 79913",
    className: "cls-16",
    d: "M374.14,266a.331.331,0,0,1,.3.012c.081.051.08.129,0,.173a.33.33,0,0,1-.3-.012c-.081-.051-.08-.128,0-.173",
    transform: "translate(-374.396 -265.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79914",
    "data-name": "Path 79914",
    className: "cls-36",
    d: "M397.923,292.37l-.888,3.049.351.063.993-3.27Z",
    transform: "translate(-391.954 -285.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79915",
    "data-name": "Path 79915",
    className: "cls-87",
    d: "M398.928,275.589l.874.712-3.451,1.83-.587-.864Z",
    transform: "translate(-390.982 -272.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79916",
    "data-name": "Path 79916",
    className: "cls-88",
    d: "M401.576,278.614l-.042,1.159-3.451,1.83.042-1.159Z",
    transform: "translate(-392.756 -275.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79917",
    "data-name": "Path 79917",
    className: "cls-89",
    d: "M396.352,283.585l-.042,1.178-.386-.284-.159-1.758Z",
    transform: "translate(-390.982 -278.245)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72987",
    "data-name": "Group 72987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72986",
    "data-name": "Group 72986",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79919",
    "data-name": "Path 79919",
    className: "cls-90",
    d: "M23.443,342.889l.282-.493L28.2,358.04l-.507-.293Z",
    transform: "translate(-17.929 -261.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79920",
    "data-name": "Path 79920",
    className: "cls-91",
    d: "M24.642,340.433l1.045-.6,4.479,15.645-1.045.6Z",
    transform: "translate(-18.845 -259.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79921",
    "data-name": "Path 79921",
    className: "cls-91",
    d: "M10.986,302.088l-1.045.6L2.155,332.854l1.045-.6Z",
    transform: "translate(-1.648 -231.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79922",
    "data-name": "Path 79922",
    className: "cls-90",
    d: "M7.786,303.409l.507.293L.507,333.864,0,333.571Z",
    transform: "translate(0 -232.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79923",
    "data-name": "Path 79923",
    className: "cls-92",
    d: "M15.372,375.853l0-.81-7.755,7.519,0,.81Z",
    transform: "translate(-5.826 -286.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79924",
    "data-name": "Path 79924",
    className: "cls-93",
    d: "M14.267,374.367l.263.159-7.755,7.519-.263-.159Z",
    transform: "translate(-4.981 -286.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79925",
    "data-name": "Path 79925",
    className: "cls-90",
    d: "M6.5,407.143l.263.159,0-.81-.263-.159Z",
    transform: "translate(-4.97 -310.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79926",
    "data-name": "Path 79926",
    className: "cls-94",
    d: "M33.1,300.047v.791l8.11,4.682v-.791Z",
    transform: "translate(-25.314 -229.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79927",
    "data-name": "Path 79927",
    className: "cls-95",
    d: "M68.623,317.388l-1.045.6v.791l1.045-.6Z",
    transform: "translate(-51.681 -242.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79928",
    "data-name": "Path 79928",
    className: "cls-66",
    d: "M34.145,297.483l-1.045.6,8.11,4.682,1.045-.6Z",
    transform: "translate(-25.314 -227.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79929",
    "data-name": "Path 79929",
    className: "cls-96",
    d: "M4.676,416.382v.342l6.785,3.948v-.341Z",
    transform: "translate(-3.576 -318.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79930",
    "data-name": "Path 79930",
    className: "cls-97",
    d: "M33.521,430.572v.341l1.38-.8v-.341Z",
    transform: "translate(-25.636 -328.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79931",
    "data-name": "Path 79931",
    className: "cls-98",
    d: "M11.461,417.734l-6.785-3.949,1.38-.8,6.785,3.949Z",
    transform: "translate(-3.576 -315.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79932",
    "data-name": "Path 79932",
    className: "cls-96",
    d: "M9.265,399.8v.342l6.785,3.948v-.341Z",
    transform: "translate(-7.086 -305.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79933",
    "data-name": "Path 79933",
    className: "cls-97",
    d: "M38.11,413.984v.341l1.38-.8v-.341Z",
    transform: "translate(-29.145 -315.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79934",
    "data-name": "Path 79934",
    className: "cls-98",
    d: "M16.05,401.147,9.265,397.2l1.38-.8,6.785,3.949Z",
    transform: "translate(-7.085 -303.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79935",
    "data-name": "Path 79935",
    className: "cls-96",
    d: "M13.854,383.208v.342l6.785,3.948v-.341Z",
    transform: "translate(-10.595 -293.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79936",
    "data-name": "Path 79936",
    className: "cls-97",
    d: "M42.7,397.4v.341l1.38-.8V396.6Z",
    transform: "translate(-32.655 -303.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79937",
    "data-name": "Path 79937",
    className: "cls-98",
    d: "M20.639,384.56l-6.785-3.949,1.38-.8,6.785,3.949Z",
    transform: "translate(-10.595 -290.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79938",
    "data-name": "Path 79938",
    className: "cls-96",
    d: "M18.443,366.621v.342l6.785,3.948v-.341Z",
    transform: "translate(-14.104 -280.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79939",
    "data-name": "Path 79939",
    className: "cls-97",
    d: "M47.287,380.81v.341l1.38-.8v-.341Z",
    transform: "translate(-36.164 -290.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79940",
    "data-name": "Path 79940",
    className: "cls-98",
    d: "M25.227,367.973l-6.785-3.949,1.38-.8,6.785,3.949Z",
    transform: "translate(-14.104 -277.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79941",
    "data-name": "Path 79941",
    className: "cls-96",
    d: "M23.032,350.034v.342l6.785,3.948v-.341Z",
    transform: "translate(-17.614 -267.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79942",
    "data-name": "Path 79942",
    className: "cls-97",
    d: "M51.876,364.223v.341l1.38-.8v-.341Z",
    transform: "translate(-39.674 -277.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79943",
    "data-name": "Path 79943",
    className: "cls-98",
    d: "M29.816,351.385l-6.785-3.949,1.38-.8,6.785,3.949Z",
    transform: "translate(-17.614 -265.098)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72989",
    "data-name": "Group 72989",
    transform: "translate(17.015 67.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72988",
    "data-name": "Group 72988",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26854",
    "data-name": "Rectangle 26854",
    className: "cls-100",
    width: 1.685,
    height: 1.093,
    transform: "translate(-0.002 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72994",
    "data-name": "Group 72994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72993",
    "data-name": "Group 72993",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79945",
    "data-name": "Path 79945",
    className: "cls-101",
    d: "M72.444,285.051l.245.142a.331.331,0,0,0,.037.019c.181.085.259.086.527-.065l.136-.077.521-.3a.216.216,0,0,0,0-.376l-.25-.145a.4.4,0,0,0-.068-.032.471.471,0,0,0-.407.032l-.577.338a1.418,1.418,0,0,0-.211.127.217.217,0,0,0,.047.338",
    transform: "translate(-55.32 -217.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79946",
    "data-name": "Path 79946",
    className: "cls-102",
    d: "M50.043,282.087a.569.569,0,0,0,.272.021c.573-.107,3.455-1.319,3.455-1.319a5.407,5.407,0,0,1,1.054-.394.739.739,0,0,0,.487-.223.664.664,0,0,0,.088-.131c.024-.04.051-.089.078-.143.041-.079.086-.17.129-.264a1.767,1.767,0,0,0,.243-.873c-.1-.258-.573-.244-.573-.244l-.43.352-.524.452a2.766,2.766,0,0,1-.265.151,14.724,14.724,0,0,1-2.114.551c-.889.165-1.95.33-1.95.33-.918.767-.459,1.573.051,1.735",
    transform: "translate(-37.83 -213.001)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72992",
    "data-name": "Group 72992",
    className: "cls-51",
    transform: "translate(17.015 66.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72991",
    "data-name": "Group 72991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72990",
    "data-name": "Group 72990",
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79947",
    "data-name": "Path 79947",
    className: "cls-104",
    d: "M72.966,282.515c.041-.079.086-.169.129-.264a1.228,1.228,0,0,0-.195-.3c-.071-.046-.231.089-.231.089l-.335.427a1.755,1.755,0,0,0,.281,0,1.917,1.917,0,0,1,.35.048",
    transform: "translate(-72.335 -281.939)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79948",
    "data-name": "Path 79948",
    className: "cls-105",
    d: "M73.658,275.786l-.129,2.591.608.129.419-.145.177-2.64Z",
    transform: "translate(-56.233 -210.864)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72996",
    "data-name": "Group 72996",
    transform: "translate(19.231 61.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72995",
    "data-name": "Group 72995",
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26857",
    "data-name": "Rectangle 26857",
    className: "cls-107",
    width: 1.408,
    height: 1.267,
    transform: "translate(-0.34 0.196) rotate(-30.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72998",
    "data-name": "Group 72998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72997",
    "data-name": "Group 72997",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79950",
    "data-name": "Path 79950",
    className: "cls-108",
    d: "M81.8,266.113c.026-.015.026-.065,0-.112s-.07-.072-.1-.056-.026.065,0,.112.07.072.1.057",
    transform: "translate(-62.472 -203.383)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73000",
    "data-name": "Group 73000",
    transform: "translate(19.215 62.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72999",
    "data-name": "Group 72999",
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26859",
    "data-name": "Rectangle 26859",
    className: "cls-110",
    width: 0.692,
    height: 0.735,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.251, 0.145)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73002",
    "data-name": "Group 73002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73001",
    "data-name": "Group 73001",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79952",
    "data-name": "Path 79952",
    className: "cls-111",
    d: "M81.834,265.72c.082-.048.081-.2,0-.35s-.219-.226-.3-.178-.081.2,0,.35.219.226.3.178",
    transform: "translate(-62.305 -202.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79953",
    "data-name": "Path 79953",
    className: "cls-112",
    d: "M82.127,266.065c.038-.022.037-.094,0-.161s-.1-.1-.139-.082-.037.094,0,.161.1.1.139.082",
    transform: "translate(-62.679 -203.288)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73004",
    "data-name": "Group 73004",
    transform: "translate(18.377 62.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73003",
    "data-name": "Group 73003",
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26861",
    "data-name": "Rectangle 26861",
    className: "cls-114",
    width: 1.722,
    height: 1.692,
    transform: "translate(-0.524 0.302) rotate(-30.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73006",
    "data-name": "Group 73006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73005",
    "data-name": "Group 73005",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79955",
    "data-name": "Path 79955",
    className: "cls-115",
    d: "M78.354,267.225c.127-.074.125-.316,0-.542s-.339-.349-.467-.275-.125.316.005.542.339.349.467.275",
    transform: "translate(-59.49 -203.725)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73008",
    "data-name": "Group 73008",
    transform: "translate(18.298 62.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73007",
    "data-name": "Group 73007",
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26863",
    "data-name": "Rectangle 26863",
    className: "cls-117",
    width: 1.394,
    height: 1.466,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.496, 0.286)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73079",
    "data-name": "Group 73079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73078",
    "data-name": "Group 73078",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79957",
    "data-name": "Path 79957",
    className: "cls-118",
    d: "M78.073,267.222c.159-.091.156-.393-.006-.674s-.422-.434-.581-.342-.156.393.007.674.422.434.58.342",
    transform: "translate(-59.17 -203.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79958",
    "data-name": "Path 79958",
    className: "cls-119",
    d: "M74.817,266.048l.743,1.29.026.043.022.04.569-.332a.033.033,0,0,0,.009,0,.254.254,0,0,0,.1-.108.248.248,0,0,0,.027-.087,0,0,0,0,0,0,0,.181.181,0,0,0,0-.028v-.323a.716.716,0,0,0-.037-.228.74.74,0,0,0-.192-.306.763.763,0,0,0-.141-.106l-.3-.175a.276.276,0,0,0-.1-.033.208.208,0,0,0-.036,0,.258.258,0,0,0-.114.026h0l-.031.019Z",
    transform: "translate(-57.218 -203.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79959",
    "data-name": "Path 79959",
    className: "cls-65",
    d: "M77.976,270.456v.214l.026.043.022.04.569-.332a.035.035,0,0,0,.009,0,.256.256,0,0,0,.1-.107.251.251,0,0,0,.027-.087s0,0,0,0a.669.669,0,0,0-.034-.175Z",
    transform: "translate(-59.634 -206.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79960",
    "data-name": "Path 79960",
    className: "cls-120",
    d: "M75.076,266.082l.538.314.669-.386a.718.718,0,0,0-.141-.106l-.3-.174a.258.258,0,0,0-.1-.033Z",
    transform: "translate(-57.416 -203.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79961",
    "data-name": "Path 79961",
    className: "cls-121",
    d: "M77.977,268.742v.674L78,269.4l.7-.4a.255.255,0,0,0,.029-.119v-.323a.724.724,0,0,0-.036-.228Z",
    transform: "translate(-59.635 -205.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79962",
    "data-name": "Path 79962",
    className: "cls-122",
    d: "M75.272,267.947v.323a.264.264,0,0,1-.4.229l-.3-.175a.739.739,0,0,1-.369-.64v-.323a.264.264,0,0,1,.4-.229l.3.175a.739.739,0,0,1,.369.64",
    transform: "translate(-56.749 -204.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79963",
    "data-name": "Path 79963",
    className: "cls-102",
    d: "M70.429,280.256c.076.248.226.307.372.269a.36.36,0,0,0,.107-.049.738.738,0,0,0,.236-.285.5.5,0,0,0,0-.349,1.4,1.4,0,0,1,.172-.036c.027,0,.341-.01.511,0,.112.008.172-.028.2-.082a.2.2,0,0,0,.02-.092c0-.1-.3-.23-.3-.23l-.36-.071a1.305,1.305,0,0,0-.388.05,1.688,1.688,0,0,0-.4.337.568.568,0,0,0-.17.538",
    transform: "translate(-53.848 -213.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79964",
    "data-name": "Path 79964",
    className: "cls-102",
    d: "M77.339,279.785a.779.779,0,0,0-.01.182c.01.049.079.064.079.064a1.044,1.044,0,0,0,.095-.045c.043-.023.087-.052.095-.077a1.582,1.582,0,0,0,.033-.162l.08-.231v-.135l.081-.216-.081-.246a2.066,2.066,0,0,0,.054-.306.124.124,0,0,0-.008-.044h0a.962.962,0,0,0-.126-.218l-.106-.051-.016.243s-.115.156-.093.236a1.565,1.565,0,0,0,.065.182l-.022.015h0c-.056.039-.187.139-.192.227a.226.226,0,0,0,.075.177l.055.049s-.163.075-.163.172a.29.29,0,0,0,.107.182",
    transform: "translate(-59.064 -212.836)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73011",
    "data-name": "Group 73011",
    className: "cls-51",
    transform: "translate(12.213 66.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73010",
    "data-name": "Group 73010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73009",
    "data-name": "Group 73009",
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79965",
    "data-name": "Path 79965",
    className: "cls-104",
    d: "M51.919,286.168a.569.569,0,0,0,.272.021c.573-.107,3.455-1.319,3.455-1.319a5.407,5.407,0,0,1,1.054-.394.739.739,0,0,0,.487-.223.662.662,0,0,0,.088-.131l-.187.155-.344.12-.172-.2-.18-.266-.179-.078.107.425-.537.27-2.763,1.021-.914.338s.267.028-.186.262",
    transform: "translate(-51.919 -283.852)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73014",
    "data-name": "Group 73014",
    className: "cls-51",
    transform: "translate(16.936 66.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73013",
    "data-name": "Group 73013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73012",
    "data-name": "Group 73012",
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79966",
    "data-name": "Path 79966",
    className: "cls-104",
    d: "M72.24,281.5a1.023,1.023,0,0,0,.086-.357,1.248,1.248,0,0,0-.086-.208h.2s.378.021.6.023.191-.045.191-.045l.013.022c-.028.053-.088.089-.2.082-.17-.01-.484,0-.511,0a1.391,1.391,0,0,0-.172.036.5.5,0,0,1,0,.349.74.74,0,0,1-.237.285l-.124,0s.2-.109.242-.182",
    transform: "translate(-71.998 -280.911)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73017",
    "data-name": "Group 73017",
    className: "cls-51",
    transform: "translate(18.274 65.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73016",
    "data-name": "Group 73016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73015",
    "data-name": "Group 73015",
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79967",
    "data-name": "Path 79967",
    className: "cls-104",
    d: "M77.914,280.736a.467.467,0,0,0-.063.126c.043-.023.087-.052.095-.077a1.582,1.582,0,0,0,.033-.162l.08-.231v-.135l.081-.216-.081-.246a2.06,2.06,0,0,0,.054-.306.126.126,0,0,0-.009-.044s-.1.259-.12.312-.159.09-.177.095h0l.14.015s.06.083.065.095a1.765,1.765,0,0,1-.022.182l-.3.113.055.049a.786.786,0,0,1,.2-.011.336.336,0,0,1-.027.156c-.021.021-.177.157-.177.157l-.049.052.172-.038s.092.076.054.114",
    transform: "translate(-77.688 -279.445)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79968",
    "data-name": "Path 79968",
    className: "cls-126",
    d: "M37.914,352.194a2.385,2.385,0,0,0,.136.273c.036.043.831.511.866.589s.154.416-.319.473-2.3-.025-2.3-.025l-.4-.683Z",
    transform: "translate(-27.461 -269.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79969",
    "data-name": "Path 79969",
    className: "cls-127",
    d: "M38.046,351.714a2.385,2.385,0,0,0,.136.273c.036.043.753.451.788.529s.229.394-.244.452-2.237,0-2.237,0l-.452-.627Z",
    transform: "translate(-27.562 -268.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79970",
    "data-name": "Path 79970",
    className: "cls-128",
    d: "M27.74,314.715a1.819,1.819,0,0,0,.645,1.122l1.828,1.029s-.252,2.241-.224,3.434a2.232,2.232,0,0,0,.074.63c.237.624,1.14.574,1.14.574l.574-.172s1.132-1.821,1.166-1.907c.01-.023.162-.258.382-.6s.512-.805.794-1.271c.263-.435.52-.878.708-1.244a2.879,2.879,0,0,0,.29-.713,1.581,1.581,0,0,0-.33-1.258,4.606,4.606,0,0,0-.633-.492c-.153-.109-.32-.224-.482-.335-.456-.312-.877-.592-.877-.592l-1.8-1.061-2.874,1.155a5.172,5.172,0,0,0-.378,1.7",
    transform: "translate(-21.212 -238.498)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73020",
    "data-name": "Group 73020",
    className: "cls-51",
    transform: "translate(8.776 74.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73019",
    "data-name": "Group 73019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73018",
    "data-name": "Group 73018",
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79971",
    "data-name": "Path 79971",
    className: "cls-130",
    d: "M38.653,316.445s-.125-1.118.445-.975a3.755,3.755,0,0,1,1.635.778c.247.223.075.493.115.775a2.359,2.359,0,0,0,.139.376c.055.182.024.379.063.566a1,1,0,0,0,.185.418c.1.122.135.216.217.339a.331.331,0,0,0,.153.112c.163.07.492.012.543.23-.168.086-.489.372-.673.372h-.156l.121.87s-.766.871-.766.871l-.028.4L39.1,324.087l-.681.173-1.106-1.205c.492-2.225,1.343-6.61,1.343-6.61",
    transform: "translate(-37.31 -315.458)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79972",
    "data-name": "Path 79972",
    className: "cls-126",
    d: "M27.231,378.961l.093-.186.043.513a.844.844,0,0,1-.222.62,1.177,1.177,0,0,1-1.018.419,19.43,19.43,0,0,0-2.021.025.822.822,0,0,1-.877-.2c-.2-.222-.112-.746-.112-.746l2.788-.036Z",
    transform: "translate(-17.664 -289.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79973",
    "data-name": "Path 79973",
    className: "cls-127",
    d: "M25.352,377.433l1.52.186a2.583,2.583,0,0,1,.516.129,5.758,5.758,0,0,1-.029.638,1.413,1.413,0,0,1-.921.588,9.139,9.139,0,0,1-1.559.064,5.47,5.47,0,0,1-1.319.006.853.853,0,0,1-.38-.666c.007-.194.1-.738.215-.81s1.957-.136,1.957-.136",
    transform: "translate(-17.727 -288.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79974",
    "data-name": "Path 79974",
    className: "cls-128",
    d: "M23.418,335.523c.1.072.387.774.975.817a2.284,2.284,0,0,0,1.063-.221.579.579,0,0,0,.213-.138,7.161,7.161,0,0,0,.3-1.19c.014-.258,1.4-3.47,1.6-3.871s1.907-4.975,2.056-5.548a14.848,14.848,0,0,0,.185-2.144.887.887,0,0,0-.3-.293c-1.12-.722-4.475-.9-4.475-.9s-.028,1-.028,1.344a1.174,1.174,0,0,0,.178.473h0a5.153,5.153,0,0,1,.509.978,25.2,25.2,0,0,1-.717,3.427c-.129.444-1.061,4.157-1.061,4.286,0,.108-.419,2.06-.5,2.747,0,0,0,0,0,.006-.016.133-.018.218,0,.23",
    transform: "translate(-17.901 -246.281)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73023",
    "data-name": "Group 73023",
    className: "cls-51",
    transform: "translate(7.352 76.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73022",
    "data-name": "Group 73022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73021",
    "data-name": "Group 73021",
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79975",
    "data-name": "Path 79975",
    className: "cls-130",
    d: "M31.254,337.4a8.177,8.177,0,0,1,.217.961,6.181,6.181,0,0,0-.014.7.585.585,0,0,0,.213-.138,7.14,7.14,0,0,0,.3-1.19c.014-.258,1.4-3.47,1.6-3.871s1.907-4.975,2.056-5.548a14.851,14.851,0,0,0,.185-2.144.883.883,0,0,0-.3-.293c0,.339.007.717.016.864a8.6,8.6,0,0,1-.34,1.444L34.537,330l-1.4,2.911a5.047,5.047,0,0,1-.66.889,4.51,4.51,0,0,0-.559,1.2l.329.458-.114.244s-.172.3-.129.415a1.292,1.292,0,0,1-.086.488l-.359-.66Z",
    transform: "translate(-31.254 -325.876)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73026",
    "data-name": "Group 73026",
    className: "cls-51",
    transform: "translate(5.52 77.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73025",
    "data-name": "Group 73025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73024",
    "data-name": "Group 73024",
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79976",
    "data-name": "Path 79976",
    className: "cls-130",
    d: "M23.465,341.2a2.592,2.592,0,0,1,.137-.532,3.174,3.174,0,0,0,.269-1.269,27.21,27.21,0,0,1,.71-2.989c.01-.118.4-1.634.4-1.7a16.013,16.013,0,0,0,.7-2.14,3.128,3.128,0,0,1,.366-1.086s.064-.172-.065-.2,0-.473,0-.473a4.136,4.136,0,0,1,.548-.118c.387-.064-.333-.14-.333-.14a2.544,2.544,0,0,1-.494-.29c-.041-.072-.441-.473-.466-.5a5.171,5.171,0,0,1,.509.978,25.2,25.2,0,0,1-.717,3.427c-.129.444-1.061,4.157-1.061,4.286,0,.108-.419,2.06-.5,2.747",
    transform: "translate(-23.465 -329.759)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79977",
    "data-name": "Path 79977",
    className: "cls-102",
    d: "M51.076,293.769a6.181,6.181,0,0,1-.043-.9s.015-.108.043-.291Z",
    transform: "translate(-39.028 -223.759)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73029",
    "data-name": "Group 73029",
    className: "cls-51",
    transform: "translate(11.73 68.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73028",
    "data-name": "Group 73028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73027",
    "data-name": "Group 73027",
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79978",
    "data-name": "Path 79978",
    className: "cls-104",
    d: "M51.862,289.566h0s-.236.569-.329.763a17.318,17.318,0,0,1-1.218,1.319c-.072.079-.222.264-.222.264a2.316,2.316,0,0,0-.136.317c0,.043-.05.5-.05.5l-.037-.423.095-.4a2.374,2.374,0,0,0,.222-.4v0c0,.136.373-.208.559-.409s.989-1.3,1.039-1.376c.01-.016.039-.075.078-.161",
    transform: "translate(-49.868 -289.566)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73032",
    "data-name": "Group 73032",
    className: "cls-51",
    transform: "translate(9.883 67.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73031",
    "data-name": "Group 73031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73030",
    "data-name": "Group 73030",
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79979",
    "data-name": "Path 79979",
    className: "cls-104",
    d: "M43.683,292.928a1.069,1.069,0,0,1-.918-.5,5.971,5.971,0,0,1-.573-1.7c-.136-.7-.179-1.061-.179-1.061l.048-.089s.22,1.053.3,1.311a6.464,6.464,0,0,0,.671,1.462,1.246,1.246,0,0,0,.662.355c.2,0,.734-.767.734-.767s.633-.893.965-1.319a14.386,14.386,0,0,0,1.14-1.791,3.657,3.657,0,0,1,.387-.467,7.25,7.25,0,0,0,.9-.323.32.32,0,0,0,.086-.294c-.007-.036.165-.244.165-.244l.057-.208a.739.739,0,0,1-.036.323.834.834,0,0,0-.072.186.6.6,0,0,1-.122.273,6.487,6.487,0,0,1-.645.351c-.222.122-.53.208-.617.38a16.519,16.519,0,0,1-1.742,2.989c-.875,1.075-.982,1.111-1.211,1.133",
    transform: "translate(-42.013 -287.294)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73035",
    "data-name": "Group 73035",
    className: "cls-51",
    transform: "translate(15.631 66.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73034",
    "data-name": "Group 73034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73033",
    "data-name": "Group 73033",
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79980",
    "data-name": "Path 79980",
    className: "cls-104",
    d: "M66.452,284.126l.158-.229.208-.136s-.064-.244-.072-.251-.143.055-.208.067.279-.325.279-.325l-.057-.315a1.326,1.326,0,0,1,.093.358l-.05.158s.05.021.05.136v.294l-.036.079-.236.158Z",
    transform: "translate(-66.452 -282.936)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73038",
    "data-name": "Group 73038",
    className: "cls-51",
    transform: "translate(14.75 66.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73037",
    "data-name": "Group 73037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73036",
    "data-name": "Group 73036",
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79981",
    "data-name": "Path 79981",
    className: "cls-104",
    d: "M62.867,283l-.163-.078s.02-.149.243-.286c-.018.108-.036.209-.042.236a.524.524,0,0,0-.014.1l.03,0-.054.032",
    transform: "translate(-62.704 -282.632)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79982",
    "data-name": "Path 79982",
    className: "cls-137",
    d: "M27.6,286.5a1.07,1.07,0,0,0,.2.355,3.925,3.925,0,0,0,.552.526,10.647,10.647,0,0,0,2.15.86,3.259,3.259,0,0,0,1.828-.251,6.349,6.349,0,0,0,1.027-.613c.115-.084.184-.139.184-.139s.072-1.82.144-2.723.463-4.305.463-5.036a5.77,5.77,0,0,0-.549-1.849,2.827,2.827,0,0,0-.231-.434l0,0c-.259-.428-.643-1.011-.7-1.166a4.9,4.9,0,0,0-1.215-.9,8.717,8.717,0,0,0-1.581-.162,1.689,1.689,0,0,0-.914.43.561.561,0,0,0-.05.064h0a6.208,6.208,0,0,0-.412.912c-.046.316-.2,1.864-.225,2.731s.187,1.692.2,2.279-.272.918-.344,1.391a9.735,9.735,0,0,1-.465,1.455A9.786,9.786,0,0,0,27.6,286.5",
    transform: "translate(-21.074 -210.286)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73041",
    "data-name": "Group 73041",
    className: "cls-51",
    transform: "translate(6.481 73.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73040",
    "data-name": "Group 73040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73039",
    "data-name": "Group 73039",
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79983",
    "data-name": "Path 79983",
    className: "cls-139",
    d: "M27.6,315.52a1.111,1.111,0,0,0,.2.355c0-.331-.006-.735-.006-.735a2.663,2.663,0,0,0,.56,0l.172-.4,1.286.042c-.111-.06-.22-.127-.322-.2a.894.894,0,0,1-.262-.09,3.528,3.528,0,0,0-.744-.072l-.389.172-.229-.343s-.072-.458-.072-.515a5.081,5.081,0,0,1,.774.443c-.015-.018-.259-.3-.328-.374a2.184,2.184,0,0,1-.226-.452l0,0a.671.671,0,0,1-.226-.443c-.057.151-.105.274-.127.341a9.687,9.687,0,0,0-.057,2.271",
    transform: "translate(-27.554 -312.908)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79984",
    "data-name": "Path 79984",
    className: "cls-140",
    d: "M28.5,284.121a.67.67,0,0,0,.226.443l0,0a10.205,10.205,0,0,1,.916.783,3.706,3.706,0,0,0,.56.449c.1.069.211.135.322.2a3.735,3.735,0,0,0,2.368.473c.964-.2,1.443-.735,1.488-1.434,0-.033,0-.069.006-.114.012-.169.03-.425.054-.732.108-1.313.313-3.6.422-4.476a5.831,5.831,0,0,0-.982-2.865,1.987,1.987,0,0,0-1.2-.738c-.871-.211-1.172,0-1.9-.262s-.581-.557-.581-.557-.485-.193-.789.557a8.024,8.024,0,0,0-.461,2.855,19.362,19.362,0,0,0,.16,2.961,3.051,3.051,0,0,1-.256,1.042c-.081.223-.169.452-.238.666a1.724,1.724,0,0,0-.123.75m2.669-6.169c.226-1.172.753-1.473,1.3-1.593a1.116,1.116,0,0,1,.961.313,2.758,2.758,0,0,1,.774,1.789,9.717,9.717,0,0,1-.407,3.018c-.184.542-1.675,1.054-2.121.527a7.555,7.555,0,0,1-.5-4.055",
    transform: "translate(-21.788 -210.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79985",
    "data-name": "Path 79985",
    className: "cls-141",
    d: "M29.059,307.556a7.123,7.123,0,0,0,2.5,2.057,3.985,3.985,0,0,0,1.319.256,2.939,2.939,0,0,0,1.949-.765c.012-.169.03-.425.054-.732L34.8,308.3a2.519,2.519,0,0,1-3.042.747A7.6,7.6,0,0,1,29.3,306.89c-.081.223-.169.452-.238.666",
    transform: "translate(-22.223 -234.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79986",
    "data-name": "Path 79986",
    className: "cls-102",
    d: "M38.59,261.384a5.9,5.9,0,0,0,1.16.148l.314.19.088.054.152.092s0-.032,0-.084c0-.163-.01-.518,0-.62.016-.134.113-.232.306-.232a1.331,1.331,0,0,0,.559-.1.219.219,0,0,0,.087-.119,4.459,4.459,0,0,0,.176-1.117v-.156s.226-.038.269-.129,0-.157-.092-.329a.584.584,0,0,1-.1-.284c0-.043.091-.263.1-.361a6.918,6.918,0,0,0-.07-.978,1,1,0,0,0-.5-.571c-.371-.215-2.512,1.687-2.713,1.795a1.23,1.23,0,0,0-.379.738,3.3,3.3,0,0,1,.078.71,4.052,4.052,0,0,1-.186.939c-.029.05.043.265.738.415",
    transform: "translate(-28.944 -196.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79987",
    "data-name": "Path 79987",
    className: "cls-142",
    d: "M39.241,254.88s.43-.165.552-.079a.669.669,0,0,1,.178.33l.224-.05a3.4,3.4,0,0,1,.3-.559,2.973,2.973,0,0,0,.107-.745V253.4l.3-.093a.631.631,0,0,0-.187-.5,2.436,2.436,0,0,0-1.477-.9,3.966,3.966,0,0,0-1.95.645c-.452.287-.366,1.606-.344,1.921a5.3,5.3,0,0,0,.272,1.025c.036.1.116.631.116.631s.429.107.608.164.53-.509.624-.588.38-.652.674-.832",
    transform: "translate(-28.24 -192.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79988",
    "data-name": "Path 79988",
    className: "cls-143",
    d: "M46.735,265.027a2.205,2.205,0,0,0,0,.505c.038.113.151.247.253.247s.092-.42.092-.447a4.121,4.121,0,0,0,.161-.58c0-.134-.173-.129-.261-.108s-.238.3-.244.382",
    transform: "translate(-35.729 -202.384)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73044",
    "data-name": "Group 73044",
    className: "cls-51",
    transform: "translate(11.119 64.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73043",
    "data-name": "Group 73043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73042",
    "data-name": "Group 73042",
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79989",
    "data-name": "Path 79989",
    className: "cls-104",
    d: "M47.267,274.585l.09.005.151.008c0-.163-.01-.518,0-.62.016-.134.113-.231.306-.231a1.339,1.339,0,0,0,.559-.1.222.222,0,0,0,.087-.119,5.53,5.53,0,0,1-.8.124l-.307.011a1.054,1.054,0,0,1-.01.488,1.074,1.074,0,0,0-.074.388c0,.03,0,.049,0,.049",
    transform: "translate(-47.267 -273.525)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73047",
    "data-name": "Group 73047",
    className: "cls-51",
    transform: "translate(9.502 66.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73046",
    "data-name": "Group 73046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73045",
    "data-name": "Group 73045",
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79990",
    "data-name": "Path 79990",
    className: "cls-146",
    d: "M40.393,285.593s.087,2.352.087,2.509.817,3.125.817,3.125.811.9,1.23.918.658-1.606.658-1.606l.191-1.462s-.1,1.935-.1,2.051-.065,2.637-.09,2.91c-.013.143-.012.392-.008.6.115-.084.184-.139.184-.139s.072-1.82.144-2.723.463-4.305.463-5.036a5.77,5.77,0,0,0-.549-1.849,2.808,2.808,0,0,0-.231-.434l0,0s.417,1.914.433,2.13-.243,1.822-.243,1.822l-.272-1.668-1.374-1.007Z",
    transform: "translate(-40.393 -284.452)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73050",
    "data-name": "Group 73050",
    className: "cls-51",
    transform: "translate(8.417 75.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73049",
    "data-name": "Group 73049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73048",
    "data-name": "Group 73048",
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79991",
    "data-name": "Path 79991",
    className: "cls-146",
    d: "M36.6,320.253s-.494-.118-.813-.211c.1.069.211.135.322.2Z",
    transform: "translate(-35.782 -320.042)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73053",
    "data-name": "Group 73053",
    className: "cls-51",
    transform: "translate(6.712 65.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73052",
    "data-name": "Group 73052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73051",
    "data-name": "Group 73051",
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79992",
    "data-name": "Path 79992",
    className: "cls-149",
    d: "M28.76,285.949a.694.694,0,0,1-.06-.2,3.028,3.028,0,0,1,.419-.431v-.847l.214-.328s.328,1.133.374,1.187.627.548.627.548l-.211.172-.819-.358.717.714s.633-.054.633-.127-.03-.473-.03-.473l-.515-.416-.5-1.235s-.115-.874-.1-.973.2-.883.2-.883l-.386.467s-.175-.991-.166-1.166.135-1.988.163-2.383a6.657,6.657,0,0,1,.337-2.139,6.058,6.058,0,0,0-.413.913c-.045.316-.2,1.865-.226,2.729s.187,1.693.2,2.28-.274.919-.343,1.392a6.294,6.294,0,0,1-.34,1.115.67.67,0,0,0,.226.443",
    transform: "translate(-28.534 -277.078)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_79993",
    "data-name": "Path 79993",
    className: "cls-150",
    d: "M37.938,273.864l.925.283.48.165v.776s-.71-.461-.868-.54-1.2-.093-1.634-.2a1.223,1.223,0,0,1-.662-.425l.176-.335.3-.064,0,.171a3.346,3.346,0,0,0,.48.115c.186.022.8.054.8.054",
    transform: "translate(-27.669 -209.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79994",
    "data-name": "Path 79994",
    className: "cls-102",
    d: "M44.178,283.976v1.254c0,.136.373-.208.559-.409s.989-1.3,1.039-1.376.53-1.168.638-1.505.76-.588.76-.588-.079.473-.093.538a.526.526,0,0,0-.014.1s.179-.021.337-.036a1.556,1.556,0,0,0,.459-.208s.165-.05.208-.022a1.326,1.326,0,0,1,.093.358l-.05.158s.05.021.05.136v.294l-.036.079a.74.74,0,0,1-.036.322.823.823,0,0,0-.072.187.6.6,0,0,1-.122.272,6.441,6.441,0,0,1-.645.351c-.222.122-.53.208-.617.38a16.5,16.5,0,0,1-1.742,2.989c-.875,1.075-.982,1.111-1.211,1.133a1.068,1.068,0,0,1-.917-.5,5.971,5.971,0,0,1-.573-1.7c-.136-.7-.179-1.061-.179-1.061s.409-.753.452-.781,1.713-.366,1.713-.366",
    transform: "translate(-32.13 -215.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79995",
    "data-name": "Path 79995",
    className: "cls-105",
    d: "M64.338,279.178l.07-1.148-.925.115.043.667-.131.666.618.063Z",
    transform: "translate(-48.484 -212.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79996",
    "data-name": "Path 79996",
    className: "cls-150",
    d: "M41.8,284.061a2.437,2.437,0,0,1,.86,0,1.974,1.974,0,0,1,.279.251h.043s.158-1.054.186-1.233a5.654,5.654,0,0,0-.179-1.971,1.282,1.282,0,0,0-1.19-.889c-.688-.043-1.233.731-1.376,1.649a11.439,11.439,0,0,0,.272,2.867l.157.028s0-.218.043-.253a1.42,1.42,0,0,1,.9-.448",
    transform: "translate(-30.89 -214.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79997",
    "data-name": "Path 79997",
    className: "cls-151",
    d: "M69.951,268.548l.26.834-.26.78-3.015,1.754V270.3Z",
    transform: "translate(-51.191 -205.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79998",
    "data-name": "Path 79998",
    className: "cls-152",
    d: "M62.761,274.118l.288.9-.288.716-1-.582-.281-.907.281-.705Z",
    transform: "translate(-47.016 -209.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79999",
    "data-name": "Path 79999",
    className: "cls-153",
    d: "M63.674,268.414l3.015-1.755-1-.582-3.015,1.755Z",
    transform: "translate(-47.929 -203.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80000",
    "data-name": "Path 80000",
    className: "cls-90",
    d: "M55.745,361.532l.287-.475L60.51,376.7,60,376.409Z",
    transform: "translate(-42.632 -276.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80001",
    "data-name": "Path 80001",
    className: "cls-91",
    d: "M56.965,359.1l1.045-.6,4.479,15.645-1.045.6Z",
    transform: "translate(-43.565 -274.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80002",
    "data-name": "Path 80002",
    className: "cls-91",
    d: "M43.309,320.75l-1.045.6-7.786,30.163,1.045-.6Z",
    transform: "translate(-26.368 -245.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80003",
    "data-name": "Path 80003",
    className: "cls-90",
    d: "M40.109,322.07l.507.293L32.83,352.526l-.507-.293Z",
    transform: "translate(-24.72 -246.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80004",
    "data-name": "Path 80004",
    className: "cls-92",
    d: "M47.7,394.514l0-.81-7.755,7.519,0,.81Z",
    transform: "translate(-30.546 -301.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80005",
    "data-name": "Path 80005",
    className: "cls-93",
    d: "M46.59,393.029l.263.159L39.1,400.707l-.263-.159Z",
    transform: "translate(-29.7 -300.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80006",
    "data-name": "Path 80006",
    className: "cls-90",
    d: "M38.822,425.8l.263.159,0-.81-.263-.159Z",
    transform: "translate(-29.69 -325.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80007",
    "data-name": "Path 80007",
    className: "cls-102",
    d: "M247.59,356.192a10.061,10.061,0,0,0,2.457-1.458c.039-.055.961-.426.961-.426s.677.054.929.044a1.991,1.991,0,0,0,.748-.159c.093-.076.1-.595.1-.595s-.052-.213-.07-.264a.008.008,0,0,1,0,0c-.016-.044-.137-.093-.181-.131s-.284-.153-.295-.181a1.154,1.154,0,0,0-.1-.131,1.163,1.163,0,0,1-.311-.1c-.038-.044-.252.005-.284.027s-.355.322-.481.437a1.693,1.693,0,0,1-.48.219l-1.5.551s-1.8.356-1.84.388-.213,1.835.349,1.78",
    transform: "translate(-189.038 -269.791)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73056",
    "data-name": "Group 73056",
    className: "cls-51",
    transform: "translate(58.145 83.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73055",
    "data-name": "Group 73055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73054",
    "data-name": "Group 73054",
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80008",
    "data-name": "Path 80008",
    className: "cls-104",
    d: "M247.59,356.338a10.06,10.06,0,0,0,2.457-1.458c.039-.055.961-.426.961-.426s.677.054.929.044a1.991,1.991,0,0,0,.748-.159c.093-.076.1-.595.1-.595s-.052-.213-.07-.264c0,.026.017.172-.072.182l-.4.05-.164.316s.2.087.289.12a1.95,1.95,0,0,0,.274.061s-.007.1-.2.139a4.631,4.631,0,0,1-.583.058,4.96,4.96,0,0,0-.619-.1,10.183,10.183,0,0,0-1,.28s-.093-.27-.032-.379a.541.541,0,0,0,0-.32,2.114,2.114,0,0,1,.4-.226,3.11,3.11,0,0,0,.426-.2l.508-.5c-.033.022-.355.322-.481.437a1.693,1.693,0,0,1-.48.219l-1.5.551s-1.8.356-1.84.388-.213,1.835.349,1.78",
    transform: "translate(-247.183 -352.963)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_80009",
    "data-name": "Path 80009",
    className: "cls-128",
    d: "M220.8,388.869a2.435,2.435,0,0,0-.2,1.327,4.524,4.524,0,0,0,1.168,2.577,4.552,4.552,0,0,1,.877,1.238v.844s-.044.291.7.306,1.369-1.6,1.369-1.6l-2.781-5.183Z",
    transform: "translate(-168.699 -297.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80010",
    "data-name": "Path 80010",
    className: "cls-127",
    d: "M203.3,421.107l.058-.175s.408.007.59,0a8.022,8.022,0,0,1,.968.175s.43,1.34.066,1.521a5.431,5.431,0,0,1-.568.233,3.172,3.172,0,0,0-.67.917c-.022.16-.088.619-.088.692s-.109.233-.342.153-.4-.655-.4-.655l.087-1.551Z",
    transform: "translate(-155.186 -321.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80011",
    "data-name": "Path 80011",
    className: "cls-128",
    d: "M209.293,399.609c0,.236.026.633.052.964.024.313.047.565.047.565s.611.055,1.692.2,5.122.6,5.94.054.731-2.5.731-3.451-.306-3.363-.306-3.363-.28-.178-.692-.433c-1.081-.667-3.063-1.855-3.232-1.7a3.634,3.634,0,0,0-.468.658,3.243,3.243,0,0,0-.554,1.657,5.028,5.028,0,0,0,1.158,2.2,6.109,6.109,0,0,1,.667,2.053,18.3,18.3,0,0,0-2.009.2,12.332,12.332,0,0,1-2.818-.1.146.146,0,0,0-.052.027c-.061.046-.155.167-.155.475",
    transform: "translate(-160.061 -300.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80012",
    "data-name": "Path 80012",
    className: "cls-126",
    d: "M201.977,420.934s.262.007.262.451a19.147,19.147,0,0,1-.459,2.062c-.022.187.175,1.061.153,1.177s-.524-.1-.67-.371a1.114,1.114,0,0,1-.051-1.041,6.52,6.52,0,0,0,.364-1.609c0-.211.036-.655.4-.67",
    transform: "translate(-153.801 -321.918)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73059",
    "data-name": "Group 73059",
    className: "cls-51",
    transform: "translate(49.386 92.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73058",
    "data-name": "Group 73058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73057",
    "data-name": "Group 73057",
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80013",
    "data-name": "Path 80013",
    className: "cls-130",
    d: "M209.95,401.319c.333,0,.566.177,1.119.235a15.693,15.693,0,0,0,2.389-.072c.145-.03,1.252-.1,1.252-.1s.509.684.684.714a4.463,4.463,0,0,1,.83.568,2.647,2.647,0,0,0-.553-.611c-.2-.1-.553-.83-.553-.83s.014-.554.044-.7a6.923,6.923,0,0,0-.292-1.034,6.407,6.407,0,0,0-.437-.568,12.618,12.618,0,0,1-1.179-1.863.974.974,0,0,1,.1-.87c.083-.328.151-.626.207-.9a3.241,3.241,0,0,0-.554,1.657,5.03,5.03,0,0,0,1.158,2.2,6.1,6.1,0,0,1,.666,2.053,18.292,18.292,0,0,0-2.009.2,12.335,12.335,0,0,1-2.818-.1.145.145,0,0,0-.052.027",
    transform: "translate(-209.95 -395.289)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73062",
    "data-name": "Group 73062",
    className: "cls-51",
    transform: "translate(49.283 94.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73061",
    "data-name": "Group 73061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73060",
    "data-name": "Group 73060",
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80014",
    "data-name": "Path 80014",
    className: "cls-130",
    d: "M209.512,406.134c.024.313.047.565.047.565s.611.055,1.692.2,5.122.6,5.94.054.731-2.5.731-3.451-.306-3.363-.306-3.363-.28-.178-.692-.432a5.526,5.526,0,0,0,.191,1.044,9.032,9.032,0,0,1,.36,2.348c0,.753-.077,2.686-.1,2.774s-.372.579-.393.643a3.52,3.52,0,0,1-.747.2,7.071,7.071,0,0,1-.761.152c-.142,0-1.4.154-1.784.121s-1.469-.328-2.081-.425c-.426-.067-1.491-.294-2.1-.425",
    transform: "translate(-209.512 -399.704)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_80015",
    "data-name": "Path 80015",
    className: "cls-137",
    d: "M220.38,361.874c.013.122.744,1.376.789,1.453a4.3,4.3,0,0,0,2.368,2.226,3.349,3.349,0,0,0,.892.1,2.949,2.949,0,0,0,1.643-.529,2.93,2.93,0,0,1,.064-.51c.055-.27.632-1.271.959-2.005a.01.01,0,0,0,0-.006,3.954,3.954,0,0,0,.173-.446,6.76,6.76,0,0,1,1.017-2.284,5.151,5.151,0,0,0,.6-1.691,8.963,8.963,0,0,0,.206-2.146,10.716,10.716,0,0,0-1.126-1.37,26.852,26.852,0,0,0-2.554-1.851,1.213,1.213,0,0,0-1.351.311,4.6,4.6,0,0,0-.53,1.229,19.951,19.951,0,0,0-.757,2.393,7.109,7.109,0,0,1-.606,1.771c-.093.208-.228.507-.378.793l0,0a2.216,2.216,0,0,1-.494.68,1.538,1.538,0,0,0-.456.754,9.053,9.053,0,0,0-.462,1.123",
    transform: "translate(-168.54 -269.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80016",
    "data-name": "Path 80016",
    className: "cls-128",
    d: "M220.38,381.983c.013.122.744,1.376.789,1.453a4.3,4.3,0,0,0,2.368,2.226,3.347,3.347,0,0,0,.892.1,2.949,2.949,0,0,0,1.643-.53,2.93,2.93,0,0,1,.064-.51c.055-.27.632-1.271.959-2.005a.01.01,0,0,0,0-.006l-.8.125c-.8.122-1.745-.963-1.745-.963s-.1-1.223-.35-1.405-1.729-1.463-1.729-1.463l-.513.639-.163-.225,0,0a2.217,2.217,0,0,1-.494.68,1.538,1.538,0,0,0-.456.754,9.055,9.055,0,0,0-.462,1.123",
    transform: "translate(-168.54 -289.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80017",
    "data-name": "Path 80017",
    className: "cls-128",
    d: "M234.272,361.9s-.158-.188-.839-.068-5.387,4.813-5.387,4.813l-.187-.749.333-.414s4.586-4.117,4.8-4.158a3.616,3.616,0,0,1,.926.181Z",
    transform: "translate(-174.259 -276.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80018",
    "data-name": "Path 80018",
    className: "cls-128",
    d: "M236.752,352.922s-.151-.117-.259.645-.981,7.324-.981,7.324l-.645-.68s1.1-6.938,1.1-7.018a1.09,1.09,0,0,1,.268-.517c.146-.138.512.246.512.246",
    transform: "translate(-179.62 -269.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80019",
    "data-name": "Path 80019",
    className: "cls-140",
    d: "M229.1,359.673c-.028.082-.4,1.1-1.058,2.682-.1.23-.2.475-.311.73-.161.378-.334.781-.523,1.2a2.98,2.98,0,0,1-3.2-.727c-1.605-1.473-2.568-2.2-2.568-2.666a2.87,2.87,0,0,1,.485-1.07c.183-.3.387-.595.548-.821a.01.01,0,0,1,0-.006c.091-.126.17-.233.223-.305a41.846,41.846,0,0,0,1.621-4.678c-.028-.072.8-1.341,1.445-1.524a.855.855,0,0,1,.941.211s-.614-.035-.551.563,2.635,1.294,2.635,1.294a2.823,2.823,0,0,1,.573.3c.022.063.211.475.23.519-.06-.054-.928-.765-1.684.412-.784,1.218-1.618,2.7-.415,4.064a1.106,1.106,0,0,0,1.268.135,2.251,2.251,0,0,0,.334-.318",
    transform: "translate(-169.354 -269.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80020",
    "data-name": "Path 80020",
    className: "cls-157",
    d: "M224.911,379.852l-.3-.11.3.107Z",
    transform: "translate(-171.779 -290.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80021",
    "data-name": "Path 80021",
    className: "cls-157",
    d: "M229.617,383.683c-.1.23-.2.475-.312.73a3.964,3.964,0,0,1-.831.088,4.59,4.59,0,0,1-3.167-1.564,6.173,6.173,0,0,0-.859-.708,2.14,2.14,0,0,1-.944-1.076c.183-.3.387-.595.548-.822-.047.167-.151.825.724,1.36a6.612,6.612,0,0,1,.96.784c.919.85,1.961,1.816,3.881,1.209",
    transform: "translate(-170.929 -290.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80022",
    "data-name": "Path 80022",
    className: "cls-102",
    d: "M254.562,373.127a7.084,7.084,0,0,1,.339.644,3.632,3.632,0,0,0,.36.573s.753-.628.863-.756a1.559,1.559,0,0,0,.257-.412,4.2,4.2,0,0,1,.259-.628,2.09,2.09,0,0,1,.341-.29,1.033,1.033,0,0,1,.3-.051c.051.022.025.167.025.167l-.2.088.044.1.167-.149a1.32,1.32,0,0,1,.278-.036c.04.014.229.175.24.247a1.687,1.687,0,0,1-.011.269,2.323,2.323,0,0,1,.025.233.7.7,0,0,1-.036.175l.007.284-.222.28a.439.439,0,0,1-.342.095c-.193-.036-.3-.069-.375.033a5.758,5.758,0,0,1-.946,1.582c-.633.693-.884.617-1.092.655s-.541-.126-.874-.551-.972-1.218-1.179-1.431,1.775-1.119,1.775-1.119",
    transform: "translate(-193.313 -284.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80023",
    "data-name": "Path 80023",
    className: "cls-102",
    d: "M273.982,373.829a1.693,1.693,0,0,1-.011.269s.007.046.014.1a.311.311,0,0,0-.1-.05.906.906,0,0,0,.071-.295c0-.021,0-.045,0-.072a.14.14,0,0,1,.023.048",
    transform: "translate(-209.462 -285.857)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73065",
    "data-name": "Group 73065",
    className: "cls-51",
    transform: "translate(60.769 88.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73064",
    "data-name": "Group 73064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73063",
    "data-name": "Group 73063",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80024",
    "data-name": "Path 80024",
    className: "cls-104",
    d: "M259.913,377.83a.824.824,0,0,1-.378-.284c-.138-.2-.546-.975-.677-1.15-.048-.064-.264-.076-.518-.037.273-.135.48-.23.48-.23a7.088,7.088,0,0,1,.339.644,3.643,3.643,0,0,0,.36.573s.133.229.191.3a1.5,1.5,0,0,0,.2.182",
    transform: "translate(-258.339 -376.128)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73068",
    "data-name": "Group 73068",
    className: "cls-51",
    transform: "translate(59.459 88.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73067",
    "data-name": "Group 73067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73066",
    "data-name": "Group 73066",
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80025",
    "data-name": "Path 80025",
    className: "cls-104",
    d: "M253.967,378.466c-.333-.426-.972-1.218-1.179-1.43-.067-.069.094-.209.342-.368a.379.379,0,0,0-.025.161,6.156,6.156,0,0,0,.584,1.043,5.167,5.167,0,0,0,.961,1.016.636.636,0,0,0,.59,0,4.945,4.945,0,0,0,1.021-1.2,8.69,8.69,0,0,0,.513-1.059c.016-.082.044-.513.044-.513a4.5,4.5,0,0,0,.306.431.616.616,0,0,0,.224.071.306.306,0,0,0,.246-.049.722.722,0,0,0,.222-.334l-.042-.12s.054-.169.071-.262c0,.024,0,.047,0,.063a.7.7,0,0,1-.036.175l.007.284-.222.28a.44.44,0,0,1-.342.095c-.193-.036-.3-.069-.375.033a5.749,5.749,0,0,1-.946,1.582c-.633.693-.884.617-1.092.655s-.541-.126-.874-.551",
    transform: "translate(-252.773 -375.851)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_80026",
    "data-name": "Path 80026",
    className: "cls-102",
    d: "M243.828,344.064a1.112,1.112,0,0,0,.2.425c.1.106,1.022.656,1.514.948l.307.18a3.745,3.745,0,0,1,.3-.99c.124-.08.452.015.561-.044a3.258,3.258,0,0,0,.474-.684,3.336,3.336,0,0,0,.306-.961,1.366,1.366,0,0,1,.24-.677,7.421,7.421,0,0,0-.139-1.391l-.034.013a17.393,17.393,0,0,1-2.593.817c-.45,0-.707.67-.75,1.289a2.234,2.234,0,0,1-.387,1.075",
    transform: "translate(-186.473 -260.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80027",
    "data-name": "Path 80027",
    className: "cls-105",
    d: "M244.876,338.6a3.7,3.7,0,0,0,.432.293c.107.044.595.151.595.151s.735-.61.852-.737.364-.615.662-.608a.3.3,0,0,1,.315.342c-.016.073-.056.331-.056.331h.193a4.592,4.592,0,0,1,.242-.673c.078-.109.312-.451.312-.451a6.008,6.008,0,0,0,.043-.99,2.557,2.557,0,0,0-1.587-1.369,1.8,1.8,0,0,0-1.966.939,6.016,6.016,0,0,0-.16,1.951c.051.3.124.821.124.821",
    transform: "translate(-187.163 -256.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80028",
    "data-name": "Path 80028",
    className: "cls-143",
    d: "M255.062,347.65a.84.84,0,0,0-.4.44c-.087.288-.018.477.124.466s.175-.4.259-.459a1.071,1.071,0,0,0,.2-.32s0-.16-.178-.127",
    transform: "translate(-194.728 -265.869)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73071",
    "data-name": "Group 73071",
    className: "cls-51",
    transform: "translate(59.074 80.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73070",
    "data-name": "Group 73070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73069",
    "data-name": "Group 73069",
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80029",
    "data-name": "Path 80029",
    className: "cls-104",
    d: "M251.133,345.436l.307.18a3.75,3.75,0,0,1,.3-.99c.124-.08.452.015.561-.044a3.265,3.265,0,0,0,.474-.684,3.337,3.337,0,0,0,.306-.961,1.368,1.368,0,0,1,.24-.677,7.418,7.418,0,0,0-.139-1.391l-.034.013c.024.418.054.887.083,1.047a.568.568,0,0,1-.155.5,6.592,6.592,0,0,0-.108.77,5.489,5.489,0,0,1-.416.945s-.283.305-.4.305a2.979,2.979,0,0,1-.567-.2.336.336,0,0,1,.026.283c-.065.12-.393.595-.393.595a2.692,2.692,0,0,0-.079.3",
    transform: "translate(-251.133 -340.87)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73074",
    "data-name": "Group 73074",
    className: "cls-51",
    transform: "translate(55.889 87.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73073",
    "data-name": "Group 73073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73072",
    "data-name": "Group 73072",
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80030",
    "data-name": "Path 80030",
    className: "cls-146",
    d: "M237.6,379.964a2.964,2.964,0,0,0,1.641-.527,2.9,2.9,0,0,1,.066-.513c.065-.329.928-1.77,1.136-2.457a6.754,6.754,0,0,1,1.015-2.283,5.149,5.149,0,0,0,.6-1.691c-.714-.862-1.439-1.36-1.857-.886l-.01.082c-.025.211-.091.773-.09.966a1.58,1.58,0,0,1-.076.46s.623.491.611.7a.776.776,0,0,1-.251.418l.021.432a7.34,7.34,0,0,1-.83,2.228,10.434,10.434,0,0,0-.949,1.683,13.351,13.351,0,0,0-1.03,1.389",
    transform: "translate(-237.596 -371.423)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73077",
    "data-name": "Group 73077",
    className: "cls-51",
    transform: "translate(53.933 84.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73076",
    "data-name": "Group 73076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73075",
    "data-name": "Group 73075",
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80031",
    "data-name": "Path 80031",
    className: "cls-146",
    d: "M231.456,359.223s-.859,1.905-1.034,2.193a12.23,12.23,0,0,0-.946,2.254,9.437,9.437,0,0,1-.182,1.019s-.037-1.369,0-1.558.75-2.086.75-2.086.743-1.35.815-1.539,1.048-1.893,1.048-1.893Z",
    transform: "translate(-229.278 -357.613)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_80032",
    "data-name": "Path 80032",
    className: "cls-150",
    d: "M248.677,366.072a2.389,2.389,0,0,0,.255,1.34,5.567,5.567,0,0,0,.866,1.208,4.9,4.9,0,0,0,1.245-.454,1.644,1.644,0,0,0,.575-.755s-.743-2.319-.917-2.568a.836.836,0,0,0-1.252-.162,2.341,2.341,0,0,0-.772,1.39",
    transform: "translate(-190.171 -278.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80033",
    "data-name": "Path 80033",
    className: "cls-150",
    d: "M242.62,353.074l.283-.262.217-.04-.071.151a8.425,8.425,0,0,0,1.143.7,5.1,5.1,0,0,1,1.07.757l-.157.472-.621-.276a12.35,12.35,0,0,1-1.5-.961c-.277-.277-.379-.393-.364-.546",
    transform: "translate(-185.547 -269.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80034",
    "data-name": "Path 80034",
    className: "cls-163",
    d: "M268.724,356.362l2.206,1.135.856.444.231-.319.072-.267-3.035-1.418s-.331.079-.4.184a.064.064,0,0,0-.009.021c-.04.1.076.22.076.22",
    transform: "translate(-205.447 -272.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80035",
    "data-name": "Path 80035",
    className: "cls-164",
    d: "M268.724,357.029l2.765,1.423.1-.231-2.942-1.412c-.04.1.076.22.076.22",
    transform: "translate(-205.447 -272.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80036",
    "data-name": "Path 80036",
    className: "cls-165",
    d: "M278.882,361.236l.99.561.015.356-.287.089-.409-.23-.537-.639Z",
    transform: "translate(-213.108 -276.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80037",
    "data-name": "Path 80037",
    className: "cls-166",
    d: "M279.043,359.388l.227-.137.2-.121.572.35.113.271.012.326Z",
    transform: "translate(-213.404 -274.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80038",
    "data-name": "Path 80038",
    className: "cls-164",
    d: "M278.655,361.818l.99.561.015.356-.287.089-.409-.23-.293-.441Z",
    transform: "translate(-213.107 -276.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80039",
    "data-name": "Path 80039",
    className: "cls-164",
    d: "M278.582,360.065l.108-.231.2-.121.572.35.113.271.027.317Z",
    transform: "translate(-213.052 -275.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80040",
    "data-name": "Path 80040",
    className: "cls-167",
    d: "M278.691,360.227l.886.5.027.317-1.021-.587Z",
    transform: "translate(-213.052 -275.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80041",
    "data-name": "Path 80041",
    className: "cls-167",
    d: "M279.661,362.734l-.847-.5-.158-.418.99.561Z",
    transform: "translate(-213.108 -276.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80042",
    "data-name": "Path 80042",
    className: "cls-168",
    d: "M275.828,359.121l.523.265-.17.107-.52-.264s0-.11.168-.107",
    transform: "translate(-210.817 -274.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80043",
    "data-name": "Path 80043",
    className: "cls-167",
    d: "M278.861,361.831l0-.48-.275-.142.034.478Z",
    transform: "translate(-213.052 -276.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80044",
    "data-name": "Path 80044",
    className: "cls-163",
    d: "M282.838,362.7l-.028-.79.227-.137.028.79Z",
    transform: "translate(-216.284 -276.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80045",
    "data-name": "Path 80045",
    className: "cls-165",
    d: "M282.86,363.358v-.125l.227-.134,0,.121Z",
    transform: "translate(-216.322 -277.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80046",
    "data-name": "Path 80046",
    className: "cls-5",
    d: "M370.187,406.621c-.116-.071-.23-.143-.351-.212a16.411,16.411,0,0,0-1.718-.852l-.42.216c-.244-.1-.494-.2-.747-.294l.193-.307a21.4,21.4,0,0,0-2.46-.728l-.316.271c-.285-.065-.574-.123-.864-.178l.055-.324a25.857,25.857,0,0,0-2.7-.347l-.191.308q-.461-.033-.925-.049l-.086-.322a27.424,27.424,0,0,0-2.764.054l-.053.324q-.466.035-.929.085l-.223-.3a25.267,25.267,0,0,0-2.654.452l.088.32c-.294.068-.585.14-.872.218l-.343-.255a20.5,20.5,0,0,0-2.377.819l.223.3q-.383.162-.751.34l-.443-.2c-.35.171-.692.35-1.022.541s-.637.39-.932.593l.344.255q-.305.214-.584.435l-.515-.127a10.267,10.267,0,0,0-1.059.983l-.813-2.589-.8.513-.069,2.144-.193.148-.851,6.914c-.03.336.84,2.842.874,3.178l.114.01,0,.684a6.034,6.034,0,0,0,.615,1.556l.405-.024v.673a8.77,8.77,0,0,0,1.275,1.417l.53-.113c.044.04.094.077.139.116v.557a13.25,13.25,0,0,0,1.484.987c.121.069.246.135.37.2l.466-.185c.135.072.274.139.412.207v.42a19.021,19.021,0,0,0,2.314.886l.373-.246c.218.067.438.13.66.19v.353a24.092,24.092,0,0,0,2.635.525l.255-.291q.422.058.848.1l.016.324a27.16,27.16,0,0,0,2.789.134l.124-.32q.428,0,.856-.022l.155.312a26.707,26.707,0,0,0,2.771-.269V426.8q.4-.063.8-.139l.286.28a22.946,22.946,0,0,0,2.577-.658v-.367c.191-.064.382-.129.57-.2l.4.229a17.853,17.853,0,0,0,2.22-1.007v-.438l.019-.01c.1-.058.194-.118.29-.177l.485.165a12.347,12.347,0,0,0,1.732-1.287v-.616l.034-.034.542.09a7.991,7.991,0,0,0,1.126-1.491l.32-.626a43.626,43.626,0,0,0,.444-4.628v-.649l.048-.006-.016-7.065-2.174-2.611.088,2.739a10.681,10.681,0,0,0-1.38-1.173l-.5.15c-.187-.131-.384-.259-.586-.385Zm2.158,1.918.015.455c-.091-.107-.181-.214-.28-.32Z",
    transform: "translate(-261.605 -308.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80047",
    "data-name": "Path 80047",
    className: "cls-6",
    d: "M475.612,435.2l-.251-3.957.442-6.05-.451,1.6-.658,5.805.682,4.287Z",
    transform: "translate(-363.032 -325.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80048",
    "data-name": "Path 80048",
    className: "cls-6",
    d: "M396.428,471.044l-2.173-4.448,2.149-5.644-2.789-.134-2.149,5.683,2.173,4.409,1.4.1Z",
    transform: "translate(-299.382 -352.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80049",
    "data-name": "Path 80049",
    className: "cls-6",
    d: "M381.015,468.63l-1.957-4.845,1.934-5.247-2.634-.525-1.934,5.286,1.957,4.806,1.177.272Z",
    transform: "translate(-287.878 -350.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80050",
    "data-name": "Path 80050",
    className: "cls-6",
    d: "M366.234,463.96l-2.027-4.676,2-5.416-2.314-.886-2,5.455,2.027,4.637,1.007.443Z",
    transform: "translate(-276.765 -346.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80051",
    "data-name": "Path 80051",
    className: "cls-6",
    d: "M354.223,457.33l-2.007-4.538,1.984-5.554-1.854-1.189-1.983,5.593,2.007,4.5.771.577Z",
    transform: "translate(-267.948 -341.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80052",
    "data-name": "Path 80052",
    className: "cls-6",
    d: "M346.815,449.153l-1.793-4,1.77-6.091-1.275-1.417-1.54,6.413,1.564,3.679.486.656Z",
    transform: "translate(-263.063 -334.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80053",
    "data-name": "Path 80053",
    className: "cls-6",
    d: "M343.678,439.92l-.99-3.911.967-6.181-.615-1.556-.967,6.22.99,3.872.2.757Z",
    transform: "translate(-261.608 -327.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80054",
    "data-name": "Path 80054",
    className: "cls-6",
    d: "M413.089,470.206l-2.173-4.448,2.149-5.644-2.771.269-2.149,5.683,2.172,4.409,1.435-.1Z",
    transform: "translate(-312.138 -351.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80055",
    "data-name": "Path 80055",
    className: "cls-6",
    d: "M429.277,466.608l-2.173-4.448,2.149-5.644-2.577.658-2.149,5.683,2.172,4.409,1.24-.251Z",
    transform: "translate(-324.667 -349.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80056",
    "data-name": "Path 80056",
    className: "cls-6",
    d: "M443.985,460.905l-2.173-4.448,2.149-5.644-2.22,1.007-2.149,5.683,2.172,4.409,1.015-.391Z",
    transform: "translate(-336.188 -344.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80057",
    "data-name": "Path 80057",
    className: "cls-6",
    d: "M457.784,453.478l-1.718-3.865,1.695-6.227-1.732,1.287-1.694,6.266,1.718,3.826.829-.524Z",
    transform: "translate(-347.462 -339.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80058",
    "data-name": "Path 80058",
    className: "cls-6",
    d: "M468.25,444.758l-1.042-3.729,1.019-6.363-1.126,1.491-1.305,6.034,1.329,4.058.667-.793Z",
    transform: "translate(-356.227 -332.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80059",
    "data-name": "Path 80059",
    className: "cls-5",
    d: "M470.98,417.4l.14-4.569-1.953.106-.023,3.409Z",
    transform: "translate(-358.787 -315.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80060",
    "data-name": "Path 80060",
    className: "cls-5",
    d: "M465,408.5l-.011-4.656-1.953.106-.024,3.408Z",
    transform: "translate(-354.096 -308.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80061",
    "data-name": "Path 80061",
    className: "cls-5",
    d: "M455.144,400.689l-.011-4.656-1.953.106-.024,3.409Z",
    transform: "translate(-346.562 -302.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80062",
    "data-name": "Path 80062",
    className: "cls-5",
    d: "M442.208,394.533l-.011-4.656-1.953.106-.023,3.408Z",
    transform: "translate(-336.668 -298.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80063",
    "data-name": "Path 80063",
    className: "cls-5",
    d: "M426.963,390.453l-.011-4.655L425,385.9l-.024,3.408Z",
    transform: "translate(-325.01 -295.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80064",
    "data-name": "Path 80064",
    className: "cls-7",
    d: "M348.685,398.594a13.216,13.216,0,0,0,1.484.987c.121.069.246.135.37.2L351,399.6c.22.116.442.229.671.337l-.258.29a19.046,19.046,0,0,0,2.314.886l.373-.246c.259.08.521.156.786.226l-.124.317a24.135,24.135,0,0,0,2.634.525l.255-.291c.281.039.565.072.849.1l.016.324a27.155,27.155,0,0,0,2.789.134l.124-.32c.285,0,.571-.01.856-.022l.155.311a26.69,26.69,0,0,0,2.771-.269l-.018-.326q.41-.064.815-.142l.286.28a22.993,22.993,0,0,0,2.577-.658l-.158-.312q.368-.12.727-.252l.4.23a17.811,17.811,0,0,0,2.22-1.007l-.288-.279c.1-.056.206-.111.306-.169s.194-.118.29-.177l.485.165a12.372,12.372,0,0,0,1.732-1.287l-.4-.229q.228-.208.433-.421l.542.089a7.992,7.992,0,0,0,1.126-1.491l-.486-.163q.132-.235.241-.472l.565.009a5.739,5.739,0,0,0,.451-1.6l-.541-.088c.019-.165.031-.329.034-.494l.554-.073a5.407,5.407,0,0,0-.246-1.609l-.561-.008c-.053-.164-.112-.327-.181-.489l.5-.149a6.989,6.989,0,0,0-.923-1.518l-.548.073c-.123-.153-.257-.3-.4-.452l.424-.217a10.686,10.686,0,0,0-1.548-1.331l-.5.15c-.187-.131-.384-.259-.587-.385l.318-.27c-.116-.071-.231-.143-.351-.212a16.551,16.551,0,0,0-1.718-.852l-.42.216c-.245-.1-.494-.2-.747-.294l.193-.307a21.409,21.409,0,0,0-2.46-.728l-.316.27c-.285-.065-.574-.123-.864-.178l.055-.324a25.858,25.858,0,0,0-2.7-.347l-.191.308q-.461-.032-.924-.049l-.087-.322a27.365,27.365,0,0,0-2.764.054l-.053.324c-.311.023-.62.051-.929.085l-.223-.3a25.272,25.272,0,0,0-2.654.452l.088.32c-.294.068-.585.14-.872.218l-.343-.255a20.534,20.534,0,0,0-2.377.819l.223.3q-.383.162-.751.339l-.443-.2c-.35.171-.692.35-1.022.541s-.637.39-.932.593l.344.255q-.3.213-.584.435l-.515-.127a9.84,9.84,0,0,0-1.406,1.377l.444.2c-.135.166-.258.335-.373.5l-.555-.049a6.558,6.558,0,0,0-.768,1.534l.52.127a5.462,5.462,0,0,0-.142.537l-.561.032a5.322,5.322,0,0,0-.079,1.6l.558.048a5.289,5.289,0,0,0,.089.534l-.532.112a6.042,6.042,0,0,0,.615,1.556l.561-.034c.1.167.2.334.313.5l-.467.184a8.778,8.778,0,0,0,1.274,1.417l.53-.113c.163.145.333.289.513.43Z",
    transform: "translate(-264.286 -293.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80065",
    "data-name": "Path 80065",
    className: "cls-8",
    d: "M357.122,401.161c-5.452-3.131-5.436-8.244.036-11.42s14.328-3.212,19.78-.081,5.436,8.244-.036,11.42-14.328,3.212-19.78.081",
    transform: "translate(-269.997 -296.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80066",
    "data-name": "Path 80066",
    className: "cls-7",
    d: "M372.793,406.963c-3.909-2.245-3.9-5.911.026-8.189A15.674,15.674,0,0,1,387,398.717c3.909,2.245,3.9,5.911-.026,8.189a15.675,15.675,0,0,1-14.183.058",
    transform: "translate(-282.865 -303.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80067",
    "data-name": "Path 80067",
    className: "cls-54",
    d: "M390.143,401.543a13.745,13.745,0,0,0-12.436.051c-3.44,2-3.45,5.212-.023,7.18a13.744,13.744,0,0,0,12.436-.051c3.44-2,3.45-5.211.023-7.18",
    transform: "translate(-286.881 -305.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80068",
    "data-name": "Path 80068",
    className: "cls-55",
    d: "M382.152,410.42c-2.985-1.714-2.98-4.516.015-6.254a11.987,11.987,0,0,1,10.85-.043c2.913,1.673,2.982,4.387.163,6.13a.97.97,0,0,1-.192.127,11.994,11.994,0,0,1-10.572.179,2.906,2.906,0,0,1-.264-.14",
    transform: "translate(-290.55 -308.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80069",
    "data-name": "Path 80069",
    className: "cls-56",
    d: "M390.072,420.526l-.145-2.21,5.108-2.438,5.553,1.835.248,2.507a.959.959,0,0,1-.192.127,11.993,11.993,0,0,1-10.572.179",
    transform: "translate(-298.205 -318.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80070",
    "data-name": "Path 80070",
    className: "cls-57",
    d: "M382.106,407.793a11.983,11.983,0,0,1,10.842-.044,5.231,5.231,0,0,1,1.594,1.351c1.312-1.641.813-3.639-1.517-4.977a11.983,11.983,0,0,0-10.842.044c-2.3,1.335-2.835,3.294-1.613,4.909a5.432,5.432,0,0,1,1.537-1.283",
    transform: "translate(-290.561 -308.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80071",
    "data-name": "Path 80071",
    className: "cls-58",
    d: "M399.018,413.369a8.335,8.335,0,0,0-7.541.031c-2.086,1.211-2.092,3.16-.014,4.354a8.335,8.335,0,0,0,7.541-.031c2.086-1.211,2.092-3.16.014-4.354",
    transform: "translate(-298.191 -315.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80072",
    "data-name": "Path 80072",
    className: "cls-55",
    d: "M405.679,417.6a4.434,4.434,0,0,0-4.013.016,1.223,1.223,0,0,0-.007,2.317,4.435,4.435,0,0,0,4.013-.016,1.223,1.223,0,0,0,.007-2.317",
    transform: "translate(-306.544 -319.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80073",
    "data-name": "Path 80073",
    className: "cls-59",
    d: "M407.136,416.193a3.617,3.617,0,0,0-3.273.013,1,1,0,0,0-.006,1.889,3.617,3.617,0,0,0,3.273-.013,1,1,0,0,0,.006-1.889",
    transform: "translate(-308.343 -317.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80074",
    "data-name": "Path 80074",
    className: "cls-169",
    d: "M283.354,431.35a2.748,2.748,0,0,1,2.471-.1l3,1.734c.633.366.553,1-.177,1.427L286,435.937a2.748,2.748,0,0,1-2.471.1l-3-1.734c-.633-.366-.553-1,.178-1.427Z",
    transform: "translate(-214.213 -329.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80075",
    "data-name": "Path 80075",
    className: "cls-170",
    d: "M283.354,430.446a2.749,2.749,0,0,1,2.471-.1l3,1.734c.633.365.553,1-.177,1.427L286,435.033a2.748,2.748,0,0,1-2.471.1l-3-1.734c-.633-.366-.553-1,.178-1.427Z",
    transform: "translate(-214.213 -328.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80076",
    "data-name": "Path 80076",
    className: "cls-171",
    d: "M292.2,406.252l-2.281-9.856-1.688-.047-2.4,10.241h.013a1.525,1.525,0,0,0,.937,1.491,5.076,5.076,0,0,0,4.59,0,1.619,1.619,0,0,0,.95-1.314h0a1.155,1.155,0,0,0-.12-.516",
    transform: "translate(-218.593 -303.117)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73081",
    "data-name": "Group 73081",
    transform: "translate(67.235 93.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73080",
    "data-name": "Group 73080",
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80077",
    "data-name": "Path 80077",
    className: "cls-173",
    d: "M285.8,394.5c0-.593-2.711,11.978-2.146,12.058.271.038-1.132-1.142-1.132-1.142s-.26-2.154-.071-2.21,2.978-9.121,2.978-9.121Z",
    transform: "translate(-283.19 -394.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80078",
    "data-name": "Path 80078",
    className: "cls-169",
    d: "M301.729,394.567c1.235,4.524,2.217,9.087.687,12.494l2.648-1.482.106-1.376-3.093-10.4Z",
    transform: "translate(-297.988 -394.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80079",
    "data-name": "Path 80079",
    className: "cls-174",
    d: "M289.483,418.777l-.266,1.136h.009a1.151,1.151,0,0,0,.707,1.125,3.827,3.827,0,0,0,3.462,0,1.221,1.221,0,0,0,.716-.991h0a.87.87,0,0,0-.09-.389l-.2-.851a1.6,1.6,0,0,1-.5.433,3.664,3.664,0,0,1-3.312,0,1.569,1.569,0,0,1-.525-.463",
    transform: "translate(-288.419 -413.502)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73083",
    "data-name": "Group 73083",
    transform: "translate(68.056 98.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73082",
    "data-name": "Group 73082",
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80081",
    "data-name": "Path 80081",
    className: "cls-176",
    d: "M302.152,414.5c.3.273.058,1.477-.52,2.573-.549,1.042-1,1.746-1.284,1.618l2.728-1.329a25.675,25.675,0,0,1-.924-2.863",
    transform: "translate(-297.755 -415.602)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73085",
    "data-name": "Group 73085",
    transform: "translate(67.235 93.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73084",
    "data-name": "Group 73084",
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80083",
    "data-name": "Path 80083",
    className: "cls-177",
    d: "M292.467,406.515l-.188.8h.007a.812.812,0,0,0,.5.793,2.7,2.7,0,0,0,2.443,0,.862.862,0,0,0,.506-.7h0a.617.617,0,0,0-.064-.275l-.139-.6a1.131,1.131,0,0,1-.356.306,2.584,2.584,0,0,1-2.337,0,1.1,1.1,0,0,1-.37-.326",
    transform: "translate(-290.761 -404.124)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73087",
    "data-name": "Group 73087",
    transform: "translate(68.807 95.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73086",
    "data-name": "Group 73086",
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80085",
    "data-name": "Path 80085",
    className: "cls-179",
    d: "M299.29,404.126c.3.209.058,1.132-.52,1.972-.549.8-.978,1-1.259.9l2.7-.679a16.6,16.6,0,0,1-.924-2.194",
    transform: "translate(-296.336 -404.811)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73089",
    "data-name": "Group 73089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73088",
    "data-name": "Group 73088",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80087",
    "data-name": "Path 80087",
    className: "cls-173",
    d: "M297.473,394.628a1.32,1.32,0,0,0-1.194,0,.364.364,0,0,0,0,.689,1.32,1.32,0,0,0,1.194,0,.364.364,0,0,0,0-.689",
    transform: "translate(-226.397 -301.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80088",
    "data-name": "Path 80088",
    className: "cls-180",
    d: "M298.359,395.425a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-227.529 -302.345)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73091",
    "data-name": "Group 73091",
    transform: "translate(69.983 92.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73090",
    "data-name": "Group 73090",
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80089",
    "data-name": "Path 80089",
    className: "cls-182",
    d: "M298.359,396.314a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-297.513 -396.021)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73093",
    "data-name": "Group 73093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73092",
    "data-name": "Group 73092",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80091",
    "data-name": "Path 80091",
    className: "cls-169",
    d: "M474.476,346.324a2.748,2.748,0,0,1,2.471-.1l3,1.734c.633.366.553,1-.177,1.427l-2.648,1.529a2.749,2.749,0,0,1-2.471.1l-3-1.734c-.633-.366-.554-1,.178-1.427Z",
    transform: "translate(-360.378 -264.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80092",
    "data-name": "Path 80092",
    className: "cls-170",
    d: "M474.476,345.42a2.748,2.748,0,0,1,2.471-.1l3,1.734c.633.366.553,1-.177,1.427l-2.648,1.529a2.748,2.748,0,0,1-2.471.1l-3-1.734c-.633-.366-.554-1,.178-1.427Z",
    transform: "translate(-360.378 -263.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80093",
    "data-name": "Path 80093",
    className: "cls-171",
    d: "M483.32,321.226l-2.281-9.856-1.688-.047-2.4,10.241h.013a1.525,1.525,0,0,0,.937,1.491,5.076,5.076,0,0,0,4.59,0,1.619,1.619,0,0,0,.95-1.314h0a1.154,1.154,0,0,0-.12-.516",
    transform: "translate(-364.758 -238.092)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73095",
    "data-name": "Group 73095",
    transform: "translate(112.192 73.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73094",
    "data-name": "Group 73094",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80094",
    "data-name": "Path 80094",
    className: "cls-173",
    d: "M476.92,309.469c0-.593-2.711,11.978-2.146,12.058.271.038-1.132-1.142-1.132-1.142s-.26-2.154-.071-2.21,2.978-9.121,2.978-9.121Z",
    transform: "translate(-474.312 -309.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80095",
    "data-name": "Path 80095",
    className: "cls-169",
    d: "M492.851,309.541c1.235,4.524,2.217,9.087.687,12.494l2.648-1.482.106-1.376-3.093-10.4Z",
    transform: "translate(-489.111 -309.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80096",
    "data-name": "Path 80096",
    className: "cls-174",
    d: "M480.6,333.751l-.266,1.136h.009a1.151,1.151,0,0,0,.707,1.125,3.827,3.827,0,0,0,3.462,0,1.221,1.221,0,0,0,.716-.991h0a.87.87,0,0,0-.09-.389l-.2-.851a1.6,1.6,0,0,1-.5.433,3.664,3.664,0,0,1-3.312,0,1.569,1.569,0,0,1-.525-.463",
    transform: "translate(-479.541 -328.476)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73097",
    "data-name": "Group 73097",
    transform: "translate(113.014 78.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73096",
    "data-name": "Group 73096",
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80098",
    "data-name": "Path 80098",
    className: "cls-176",
    d: "M493.274,329.474c.3.273.058,1.477-.52,2.573-.549,1.042-1,1.746-1.284,1.618l2.728-1.329a25.68,25.68,0,0,1-.924-2.863",
    transform: "translate(-488.877 -330.577)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73099",
    "data-name": "Group 73099",
    transform: "translate(112.192 73.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73098",
    "data-name": "Group 73098",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80100",
    "data-name": "Path 80100",
    className: "cls-177",
    d: "M483.589,321.489l-.188.8h.007a.812.812,0,0,0,.5.793,2.7,2.7,0,0,0,2.443,0,.862.862,0,0,0,.506-.7h0a.617.617,0,0,0-.064-.275l-.139-.6a1.132,1.132,0,0,1-.356.306,2.584,2.584,0,0,1-2.337,0,1.1,1.1,0,0,1-.37-.327",
    transform: "translate(-481.883 -319.098)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73101",
    "data-name": "Group 73101",
    transform: "translate(113.765 75.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73100",
    "data-name": "Group 73100",
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80102",
    "data-name": "Path 80102",
    className: "cls-179",
    d: "M490.412,319.1c.3.209.058,1.132-.52,1.972-.549.8-.978,1-1.259.9l2.7-.679a16.6,16.6,0,0,1-.924-2.194",
    transform: "translate(-487.458 -319.785)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73103",
    "data-name": "Group 73103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73102",
    "data-name": "Group 73102",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80104",
    "data-name": "Path 80104",
    className: "cls-173",
    d: "M488.6,309.6a1.32,1.32,0,0,0-1.194,0,.364.364,0,0,0,0,.689,1.32,1.32,0,0,0,1.194,0,.364.364,0,0,0,0-.689",
    transform: "translate(-372.562 -236.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80105",
    "data-name": "Path 80105",
    className: "cls-180",
    d: "M489.481,310.4a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-373.694 -237.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73105",
    "data-name": "Group 73105",
    transform: "translate(114.941 72.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73104",
    "data-name": "Group 73104",
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80106",
    "data-name": "Path 80106",
    className: "cls-182",
    d: "M489.481,311.288a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-488.635 -310.994)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73107",
    "data-name": "Group 73107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73106",
    "data-name": "Group 73106",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80108",
    "data-name": "Path 80108",
    className: "cls-169",
    d: "M152.074,351.29a2.748,2.748,0,0,1,2.471-.1l3,1.734c.633.366.553,1-.177,1.427l-2.648,1.529a2.749,2.749,0,0,1-2.471.1l-3-1.734c-.633-.366-.553-1,.178-1.427Z",
    transform: "translate(-113.814 -268.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80109",
    "data-name": "Path 80109",
    className: "cls-170",
    d: "M152.074,350.386a2.748,2.748,0,0,1,2.471-.1l3,1.734c.633.366.553,1-.177,1.427l-2.648,1.529a2.748,2.748,0,0,1-2.471.1l-3-1.734c-.633-.366-.553-1,.178-1.427Z",
    transform: "translate(-113.814 -267.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80110",
    "data-name": "Path 80110",
    className: "cls-171",
    d: "M160.918,326.192l-2.281-9.856-1.688-.047-2.4,10.241h.013a1.525,1.525,0,0,0,.937,1.491,5.076,5.076,0,0,0,4.59,0,1.619,1.619,0,0,0,.95-1.314h0a1.154,1.154,0,0,0-.12-.516",
    transform: "translate(-118.194 -241.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73109",
    "data-name": "Group 73109",
    transform: "translate(36.354 74.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73108",
    "data-name": "Group 73108",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80111",
    "data-name": "Path 80111",
    className: "cls-173",
    d: "M154.518,314.435c0-.593-2.711,11.978-2.146,12.058.271.038-1.132-1.142-1.132-1.142s-.26-2.154-.071-2.21,2.978-9.121,2.978-9.121Z",
    transform: "translate(-151.911 -314.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80112",
    "data-name": "Path 80112",
    className: "cls-169",
    d: "M170.45,314.507c1.235,4.524,2.217,9.087.687,12.494l2.648-1.482.106-1.376-3.093-10.4Z",
    transform: "translate(-166.709 -314.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80113",
    "data-name": "Path 80113",
    className: "cls-174",
    d: "M158.2,338.717l-.266,1.136h.009a1.151,1.151,0,0,0,.707,1.125,3.828,3.828,0,0,0,3.462,0,1.221,1.221,0,0,0,.717-.991h0a.87.87,0,0,0-.09-.389l-.2-.851a1.6,1.6,0,0,1-.5.433,3.664,3.664,0,0,1-3.312,0,1.569,1.569,0,0,1-.525-.463",
    transform: "translate(-157.139 -333.441)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73111",
    "data-name": "Group 73111",
    transform: "translate(37.176 79.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73110",
    "data-name": "Group 73110",
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80115",
    "data-name": "Path 80115",
    className: "cls-176",
    d: "M170.874,334.44c.3.273.058,1.477-.52,2.573-.549,1.042-1,1.746-1.284,1.618L171.8,337.3a25.671,25.671,0,0,1-.924-2.863",
    transform: "translate(-166.475 -335.543)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73113",
    "data-name": "Group 73113",
    transform: "translate(36.354 74.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73112",
    "data-name": "Group 73112",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80117",
    "data-name": "Path 80117",
    className: "cls-177",
    d: "M161.187,326.455l-.188.8h.007a.812.812,0,0,0,.5.793,2.7,2.7,0,0,0,2.443,0,.862.862,0,0,0,.506-.7h0a.617.617,0,0,0-.064-.275l-.139-.6a1.132,1.132,0,0,1-.356.306,2.584,2.584,0,0,1-2.337,0,1.1,1.1,0,0,1-.37-.327",
    transform: "translate(-159.482 -324.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73115",
    "data-name": "Group 73115",
    transform: "translate(37.927 76.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73114",
    "data-name": "Group 73114",
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80119",
    "data-name": "Path 80119",
    className: "cls-179",
    d: "M168.011,324.066c.3.209.058,1.132-.52,1.972-.549.8-.978,1-1.259.9l2.7-.679a16.6,16.6,0,0,1-.924-2.194",
    transform: "translate(-165.057 -324.751)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73117",
    "data-name": "Group 73117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73116",
    "data-name": "Group 73116",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80121",
    "data-name": "Path 80121",
    className: "cls-173",
    d: "M166.194,314.568a1.32,1.32,0,0,0-1.194,0,.364.364,0,0,0,0,.689,1.32,1.32,0,0,0,1.194,0,.364.364,0,0,0,0-.689",
    transform: "translate(-125.999 -240.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80122",
    "data-name": "Path 80122",
    className: "cls-180",
    d: "M167.08,315.365a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-127.13 -241.118)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73119",
    "data-name": "Group 73119",
    transform: "translate(39.103 74.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73118",
    "data-name": "Group 73118",
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80123",
    "data-name": "Path 80123",
    className: "cls-182",
    d: "M167.08,316.254a.776.776,0,0,0-.7,0,.214.214,0,0,0,0,.405.776.776,0,0,0,.7,0,.214.214,0,0,0,0-.405",
    transform: "translate(-166.233 -315.96)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceNew);
export default __webpack_public_path__ + "static/media/MaintenanceNew.18122b16ea4648fc7e7b3156eeae8a11.svg";
export { ForwardRef as ReactComponent };